var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _use, _use2, _path317, _path318, _path319, _circle, _path320, _path321, _path322, _path323, _path324, _circle2, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-bo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h512v341.333H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h512v170.667H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M307.817 224.759c-.615.592-104.091 103.949-104.546 104.4a97.808 97.808 0 0 0-1.383-1.038c.426-.435 103.952-103.742 104.558-104.369-.265-.308 1.862 1.304 1.371 1.007z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M314.331 218.167c-.383.733-1.52 2.615-1.077 4.002-.844-.545-1.268-.958-2.078-1.556.545.957.382 1.513-.137 1.859-.339.448-1.501.344-2.243.203.743.453 1.566.922 2.596 1.022 1.03.1 1.388.044 2.015.105-.624.335-2.267.885-3.414 1.063-.574.09-1.685.191-2.176-.106-.615.592-1.977-.38-1.37-1.007-.266-.308-.298-.805-.365-1.461-.076-.741.086-2.022.706-3.222.095.6.285 1.234.517 1.81.228.565.708 1.026 1.183 1.525-.277-.52-.444-1.306.104-1.873.547-.567 1.342-.568 2.089-.273-.665-.514-1.17-.822-1.973-1.407.83-.007 3.486-1.03 4.363-1.554.876-.525 3.66-2.728 5.222-4.058-1.288 1.488-3.587 4.212-3.962 4.928z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327.494 237.637c-.781.424-133.475 75.32-134.056 75.646-.256-.344-.751-1.01-.996-1.324.548-.317 133.275-75.154 134.058-75.613-.156-.36 1.37 1.693.994 1.291z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.875 232.84c-.604.614-2.302 2.155-2.322 3.593-.636-.724-.91-1.221-1.497-1.987.216 1.048-.119 1.545-.729 1.755-.47.35-1.554-.025-2.222-.336.568.612 1.209 1.257 2.167 1.597.958.34 1.32.37 1.904.577-.709.174-2.465.314-3.625.215-.58-.05-1.68-.215-2.057-.617-.781.424-1.777-.832-.994-1.291-.156-.36-.026-.845.12-1.491.165-.73.732-1.923 1.715-2.93a8.298 8.298 0 0 0-.086 1.861c.038.598.351 1.154.647 1.746-.099-.564-.007-1.36.702-1.776.708-.415 1.473-.228 2.096.232-.473-.652-.86-1.067-1.444-1.82.801.19 3.682-.165 4.693-.462 1.012-.297 4.395-1.757 6.325-2.667-1.717 1.126-4.802 3.201-5.393 3.802z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.079 231.982c-.706.514-119.95 90.516-120.474 90.908-.308-.31-.907-.911-1.2-1.192.491-.38 119.778-90.328 120.48-90.876-.214-.338 1.631 1.513 1.194 1.16z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.599 226.232c-.498.68-1.93 2.408-1.716 3.835-.748-.641-1.1-1.1-1.805-1.79.384 1.013.133 1.545-.437 1.825-.41.404-1.543.161-2.255-.067.662.538 1.401 1.1 2.405 1.322 1.003.222 1.368.21 1.979.345-.673.257-2.39.605-3.555.645-.582.02-1.699-.012-2.136-.365-.706.513-1.896-.612-1.195-1.16-.213-.338-.163-.833-.123-1.49.045-.744.413-1.992 1.222-3.107a8.355 8.355 0 0 0 .218 1.853c.134.588.535 1.101.924 1.652-.19-.547-.228-1.346.407-1.842.634-.496 1.421-.402 2.113-.02-.575-.59-1.025-.955-1.725-1.63.824.092 3.619-.603 4.572-1.018.953-.415 4.067-2.264 5.83-3.396-1.517 1.32-4.236 3.743-4.723 4.408z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 224.759c.615.592 104.091 103.949 104.546 104.4a97.808 97.808 0 0 1 1.383-1.038c-.426-.435-103.953-103.742-104.558-104.369.265-.308-1.862 1.304-1.371 1.007z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.669 218.167c.383.733 1.52 2.615 1.077 4.002.844-.545 1.268-.958 2.078-1.556-.545.957-.382 1.513.137 1.859.339.448 1.501.344 2.243.203-.743.453-1.566.922-2.596 1.022-1.03.1-1.388.044-2.015.105.624.335 2.267.885 3.414 1.063.574.09 1.685.191 2.176-.106.615.592 1.976-.38 1.37-1.007.266-.308.297-.805.365-1.461.076-.741-.086-2.022-.706-3.222a8.544 8.544 0 0 1-.517 1.81c-.228.565-.708 1.026-1.183 1.525.277-.52.444-1.306-.104-1.873-.547-.567-1.342-.568-2.089-.273.665-.514 1.17-.822 1.973-1.407-.83-.007-3.486-1.03-4.363-1.554-.876-.525-3.66-2.728-5.222-4.058 1.288 1.488 3.587 4.212 3.962 4.928z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.506 237.637c.781.424 133.475 75.32 134.056 75.646.256-.344.751-1.01.996-1.324-.548-.317-133.275-75.154-134.058-75.613.156-.36-1.37 1.693-.995 1.291z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.125 232.84c.604.614 2.302 2.155 2.322 3.593.636-.724.91-1.221 1.497-1.987-.216 1.048.119 1.545.729 1.755.47.35 1.554-.025 2.222-.336-.568.612-1.209 1.257-2.167 1.597-.958.34-1.32.37-1.904.577.709.174 2.465.314 3.625.215.58-.05 1.68-.215 2.056-.617.782.424 1.778-.832.995-1.291.156-.36.026-.845-.12-1.491-.165-.73-.732-1.923-1.715-2.93.102.6.124 1.253.086 1.861-.038.598-.351 1.154-.647 1.746.099-.564.007-1.36-.702-1.776-.708-.415-1.473-.228-2.096.232.473-.652.86-1.067 1.444-1.82-.801.19-3.682-.165-4.693-.462-1.012-.297-4.395-1.757-6.325-2.667 1.717 1.126 4.802 3.201 5.393 3.802z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.921 231.982c.706.514 119.95 90.516 120.473 90.908.31-.31.908-.911 1.202-1.192-.492-.38-119.779-90.328-120.48-90.876.213-.338-1.632 1.513-1.195 1.16z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.401 226.232c.498.68 1.93 2.408 1.716 3.835.748-.641 1.1-1.1 1.805-1.79-.384 1.013-.133 1.545.437 1.825.41.404 1.543.161 2.255-.067-.662.538-1.401 1.1-2.405 1.322-1.004.222-1.368.21-1.979.345.673.257 2.39.605 3.555.645.582.02 1.699-.012 2.136-.365.706.513 1.896-.612 1.195-1.16.213-.338.163-.833.123-1.49-.045-.744-.413-1.992-1.222-3.107a8.355 8.355 0 0 1-.218 1.853c-.134.588-.535 1.101-.924 1.652.19-.547.228-1.346-.407-1.842-.634-.496-1.421-.402-2.113-.02.574-.59 1.025-.955 1.725-1.63-.824.092-3.619-.603-4.572-1.018-.953-.415-4.067-2.264-5.83-3.396 1.517 1.32 4.236 3.743 4.723 4.408z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234.813 302.352c4.177-2.846 16.094-4.336 17.771-3.867-8.47 6.451-17.034 6.687-17.771 3.867z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M234.855 302.369c.738 2.82 9.258 2.567 17.71-3.847-9.05 2.737-16.694 4.323-17.71 3.847z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.855 302.369c.738 2.82 9.258 2.567 17.71-3.847-9.05 2.737-16.694 4.323-17.71 3.847z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M234.831 302.317c4.448-3.026 16.722-4.183 17.803-3.878-8.484 6.425-17.065 6.697-17.803 3.878z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M285.398 234.841l-27.164 55.81c-1.35 1.044-2.467-.36-2.852-.203-1.628 1.827-3.87 2.205-4.344 2.631-1.89 2.573-.849 4.663-.736 4.836 1.413 1.907-1.67 3.763-1.547 4.352-.605 1.07-2.88.828-3.348 2.123-.102-.147-4.624 8.879-5.1 9.845-.675.523-3.89 6.535-3.89 6.535-2.254-.038-10.916-5.565-11.086-5.48 4.867-7.786 16.54-19.734 16.303-20.497 3.281-5.554 8.52-11.572 10.775-11.533 3.196-1.682 4.755-6.009 4.134-7.005 2.456-.058 3.794-1.519 3.965-1.605l20.051-40.077c1.676-.552 1.423.132 1.96 1.097 0 0 1.068-1.283.997-1.44.948-.462 1.87.195 1.882.611z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M286.448 222.666c-.52 1.102.286 1.107.563 1.256l1.153.312c1.303.02 1.99.695 2.001 1.112l-31.93 65.305c-1.35 1.044-2.64-.273-3.054-.106l21.898-44.619s8.427-15.684 10.635-20.043l-2.897-1.24c-.899-.213-1.168-.815-.773-1.726l13.41-23.059-10.81 22.384-.196.424",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M286.448 222.666c-.52 1.102.286 1.107.563 1.256l1.153.312c1.303.02 1.99.695 2.001 1.112l-31.93 65.305c-1.35 1.044-2.64-.273-3.054-.106l21.898-44.619s8.427-15.684 10.635-20.043l-2.897-1.24c-.899-.213-1.168-.815-.773-1.726l13.41-23.059-10.81 22.384-.196.424",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M244.057 290.603c-3.137-.139-4.895 2.182-2.847 4.96m1.47-2.495c-1.126.61-1.838-.356-1.838-.356m16.269-13.942c-1.658 5.98-4.672 9.945-5.279 11.165-2.303 2.35-4.21 7.692-3.862 8.627l-8.64 14.194",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M258.091 290.877c-1.41-.496-6.083-4.843-10.67-4.083-3.495 4.062-5.59 8.204-6.211 8.77 4.267 3.519 7.076 5.266 8.117 5.795.68-.434 1.05-1.637 1.05-1.637.888-.983-.201-1.855-.201-1.855.119-2.622 2.026-4.45 3.962-4.577 2.428-.199 1.746-.395 2.055-.406 1.113-.637 1.898-2.007 1.898-2.007z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M258.091 290.877c-1.41-.496-6.083-4.843-10.67-4.083-3.495 4.062-5.59 8.204-6.211 8.77 4.267 3.519 7.076 5.266 8.117 5.795.68-.434 1.05-1.637 1.05-1.637.888-.983-.201-1.855-.201-1.855.119-2.622 2.026-4.45 3.962-4.577 2.428-.199 1.746-.395 2.055-.406 1.113-.637 1.898-2.007 1.898-2.007z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M253.447 290.965c-2.151-.042-4.35.981-5.069 2.809l5.069-2.81",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M253.447 290.965c-2.151-.042-4.35.981-5.069 2.809m-3.836.722c.2.445.76.681 1.277.51.518-.17.78-.676.58-1.121-.198-.445-.776-.645-1.294-.474-.518.17-.762.64-.563 1.085zm2.67-3.64c.198.445.79.67 1.307.5.517-.17.75-.667.55-1.112-.198-.445-.747-.654-1.265-.484-.517.17-.792.651-.593 1.096z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.996 241.187c.853-.281 1.226-1.244.816-2.16l-5.003-1.806s-.584.102-1.086.777c-.49.701.18 1.262.18 1.262l5.093 1.927",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M282.996 241.187c.853-.281 1.226-1.244.816-2.16l-5.003-1.806s-.584.102-1.086.777c-.49.701.18 1.262.18 1.262l5.093 1.927",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M228.832 305.13c4.12-2.91 16.004-4.577 17.69-4.134-8.338 6.577-16.895 6.941-17.69 4.133z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M228.874 305.145c.796 2.808 9.31 2.428 17.63-4.112-8.993 2.873-16.604 4.572-17.63 4.112z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M228.874 305.145c.796 2.808 9.31 2.428 17.63-4.112-8.993 2.873-16.604 4.572-17.63 4.112z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M228.85 305.093c4.385-3.092 16.634-4.433 17.72-4.144-8.35 6.551-16.925 6.952-17.72 4.144z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M278.036 236.871l-26.024 56.207c-1.328 1.065-2.475-.321-2.856-.16-1.59 1.852-3.825 2.263-4.29 2.696-1.836 2.601-.754 4.675-.638 4.847 1.452 1.885-1.593 3.787-1.457 4.374-.583 1.079-2.863.87-3.305 2.173-.104-.145-4.443 8.946-4.899 9.92-.664.532-3.756 6.592-3.756 6.592-2.255-.005-11.027-5.4-11.196-5.312 4.708-7.859 16.136-19.98 15.883-20.739 3.168-5.602 8.284-11.698 10.539-11.693 3.162-1.73 4.632-6.079 3.99-7.066 2.455-.094 3.763-1.575 3.933-1.664l19.232-40.371c1.664-.577 1.425.111 1.98 1.067 0 0 1.043-1.299.97-1.454.937-.476 1.873.167 1.894.583z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278.036 236.871l-26.024 56.207c-1.328 1.065-2.475-.321-2.856-.16-1.59 1.852-3.825 2.263-4.29 2.696-1.836 2.601-.754 4.675-.638 4.847 1.452 1.885-1.593 3.787-1.457 4.374-.583 1.079-2.863.87-3.305 2.173-.104-.145-4.443 8.946-4.899 9.92-.664.532-3.756 6.592-3.756 6.592-2.255-.005-11.027-5.4-11.196-5.312 4.708-7.859 16.136-19.98 15.883-20.739 3.168-5.602 8.284-11.698 10.539-11.693 3.162-1.73 4.632-6.079 3.99-7.066 2.455-.094 3.763-1.575 3.933-1.664l19.232-40.371c1.664-.577 1.425.111 1.98 1.067 0 0 1.043-1.299.97-1.454.937-.476 1.873.167 1.894.583z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M278.838 224.681c-.498 1.11.308 1.103.588 1.248l1.159.295c1.303 0 2.004.665 2.024 1.082l-30.597 65.772c-1.328 1.065-2.644-.233-3.055-.06l20.986-44.94s8.107-15.808 10.225-20.199l-2.92-1.195c-.904-.2-1.186-.798-.81-1.716l12.94-23.255-10.354 22.542-.186.426",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M278.838 224.681c-.498 1.11.308 1.103.588 1.248l1.159.295c1.303 0 2.004.665 2.024 1.082l-30.597 65.772c-1.328 1.065-2.644-.233-3.055-.06l20.986-44.94s8.106-15.807 10.225-20.199l-2.92-1.195c-.904-.2-1.186-.798-.81-1.716l12.94-23.255-10.354 22.542-.186.426",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M237.835 293.243c-3.139-.092-4.85 2.255-2.745 5.002m1.419-2.517c-1.113.628-1.845-.329-1.845-.329m15.982-14.182c-1.535 6.004-4.468 10.013-5.05 11.242-2.255 2.384-4.054 7.754-3.685 8.683l-8.35 14.321",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M251.874 293.307c-1.421-.474-6.181-4.75-10.753-3.923-3.411 4.114-5.422 8.287-6.031 8.861 4.338 3.455 7.183 5.16 8.234 5.673.67-.444 1.016-1.652 1.016-1.652.868-.996-.238-1.852-.238-1.852.065-2.623 1.935-4.48 3.868-4.635 2.423-.235 1.738-.421 2.046-.437 1.1-.653 1.858-2.035 1.858-2.035z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.874 293.307c-1.421-.474-6.181-4.75-10.753-3.923-3.411 4.114-5.422 8.287-6.031 8.861 4.338 3.455 7.183 5.16 8.234 5.673.67-.444 1.016-1.652 1.016-1.652.868-.996-.238-1.852-.238-1.852.065-2.623 1.935-4.48 3.868-4.635 2.423-.235 1.738-.421 2.046-.437 1.1-.653 1.858-2.035 1.858-2.035z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M247.231 293.464c-2.151-.01-4.328 1.047-5.01 2.885l5.01-2.885",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M247.231 293.464c-2.151-.01-4.328 1.047-5.01 2.885m-3.821.78c.208.441.773.669 1.288.49.514-.178.766-.688.557-1.13-.208-.441-.79-.632-1.304-.454-.515.178-.75.652-.541 1.093zm2.595-3.68c.208.441.803.658 1.317.48.514-.178.737-.678.529-1.12-.208-.441-.762-.643-1.276-.465s-.778.663-.57 1.104z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M275.763 243.251c.847-.293 1.2-1.262.772-2.172l-5.04-1.73s-.581.11-1.069.793c-.475.708.206 1.26.206 1.26l5.131 1.85",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M275.763 243.251c.847-.293 1.2-1.262.772-2.172l-5.04-1.73s-.581.11-1.069.793c-.475.708.206 1.26.206 1.26l5.131 1.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M277.994 302.167c-4.22-2.875-16.257-4.38-17.951-3.907 8.557 6.516 17.206 6.755 17.951 3.907z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.952 302.183c-.746 2.848-9.352 2.593-17.89-3.886 9.142 2.766 16.863 4.367 17.89 3.886z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M277.952 302.183c-.746 2.848-9.352 2.593-17.89-3.886 9.142 2.766 16.863 4.367 17.89 3.886z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M277.975 302.13c-4.492-3.056-16.89-4.225-17.982-3.917 8.57 6.49 17.237 6.765 17.982 3.917z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M226.897 233.974l27.439 56.373c1.363 1.055 2.492-.363 2.88-.205 1.645 1.846 3.91 2.227 4.389 2.658 1.908 2.599.857 4.71.744 4.885-1.428 1.926 1.687 3.8 1.562 4.396.61 1.08 2.91.836 3.382 2.144.102-.148 4.67 8.968 5.151 9.945.682.527 3.93 6.6 3.93 6.6 2.277-.039 11.025-5.621 11.198-5.534-4.917-7.865-16.708-19.935-16.468-20.705-3.314-5.61-8.607-11.689-10.884-11.65-3.229-1.7-4.803-6.069-4.175-7.076-2.481-.058-3.833-1.534-4.006-1.62l-20.254-40.483c-1.692-.557-1.436.134-1.979 1.108 0 0-1.079-1.296-1.008-1.454-.957-.467-1.889.197-1.9.618z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M225.836 221.675c.526 1.114-.288 1.118-.568 1.269l-1.164.315c-1.316.021-2.01.703-2.022 1.124l32.254 65.964c1.363 1.055 2.665-.276 3.084-.107l-22.12-45.07s-8.512-15.842-10.741-20.245l2.925-1.252c.908-.216 1.18-.824.781-1.744l-13.545-23.292 10.92 22.61.196.428",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M225.836 221.675c.526 1.114-.288 1.118-.568 1.269l-1.164.315c-1.316.021-2.01.703-2.022 1.124l32.254 65.964c1.363 1.055 2.665-.276 3.084-.107l-22.12-45.07s-8.511-15.842-10.741-20.245l2.925-1.252c.908-.216 1.18-.824.781-1.744l-13.545-23.292 10.92 22.61.196.428",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M268.657 290.298c3.168-.14 4.944 2.204 2.875 5.01m-1.484-2.52c1.136.617 1.855-.36 1.855-.36m-16.432-14.082c1.674 6.04 4.718 10.045 5.331 11.278 2.327 2.373 4.254 7.77 3.901 8.714l8.728 14.337",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M254.48 290.576c1.425-.501 6.145-4.892 10.779-4.125 3.53 4.103 5.646 8.287 6.273 8.858-4.31 3.555-7.148 5.32-8.2 5.854-.686-.439-1.06-1.653-1.06-1.653-.897-.993.204-1.874.204-1.874-.12-2.648-2.047-4.496-4.003-4.624-2.452-.2-1.763-.398-2.075-.41-1.125-.643-1.918-2.026-1.918-2.026z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M254.48 290.576c1.425-.501 6.145-4.892 10.779-4.125 3.53 4.103 5.646 8.287 6.273 8.858-4.31 3.555-7.148 5.32-8.2 5.854-.686-.439-1.06-1.653-1.06-1.653-.897-.993.204-1.874.204-1.874-.12-2.648-2.047-4.496-4.003-4.624-2.452-.2-1.763-.398-2.075-.41-1.125-.643-1.918-2.026-1.918-2.026z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M259.172 290.664c2.172-.043 4.392.991 5.12 2.838l-5.12-2.838",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M259.172 290.664c2.172-.043 4.392.991 5.12 2.838m3.874.729c-.2.45-.766.688-1.29.515-.523-.172-.788-.683-.586-1.133.2-.449.785-.65 1.308-.478.523.172.77.647.568 1.096zm-2.696-3.677c-.201.45-.798.677-1.32.505-.523-.172-.759-.674-.557-1.123.2-.45.755-.66 1.278-.489.523.172.8.658.6 1.107z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M229.324 240.383c-.862-.283-1.239-1.257-.825-2.182l5.054-1.824s.59.103 1.097.785c.494.708-.182 1.275-.182 1.275l-5.144 1.946",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M229.324 240.383c-.862-.283-1.239-1.257-.825-2.182l5.054-1.824s.59.103 1.097.785c.494.708-.182 1.275-.182 1.275l-5.144 1.946",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M283.343 305.13c-4.12-2.91-16.004-4.577-17.69-4.134 8.338 6.577 16.895 6.941 17.69 4.133z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M283.3 305.145c-.795 2.808-9.309 2.428-17.63-4.112 8.994 2.873 16.604 4.572 17.63 4.112z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M283.3 305.145c-.795 2.808-9.309 2.428-17.63-4.112 8.994 2.873 16.604 4.572 17.63 4.112z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M283.325 305.093c-4.386-3.092-16.634-4.433-17.721-4.144 8.352 6.551 16.926 6.952 17.72 4.144z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M234.139 236.871l26.024 56.207c1.328 1.065 2.474-.321 2.855-.16 1.591 1.852 3.826 2.263 4.29 2.696 1.837 2.601.754 4.675.638 4.847-1.452 1.885 1.594 3.787 1.458 4.374.583 1.079 2.863.87 3.305 2.173.104-.145 4.443 8.946 4.899 9.92.663.532 3.756 6.592 3.756 6.592 2.254-.005 11.027-5.4 11.196-5.312-4.709-7.859-16.136-19.98-15.883-20.739-3.168-5.602-8.285-11.698-10.539-11.693-3.162-1.73-4.632-6.079-3.99-7.066-2.455-.094-3.763-1.575-3.933-1.664l-19.232-40.371c-1.664-.577-1.425.111-1.981 1.067 0 0-1.042-1.299-.969-1.454-.937-.476-1.873.167-1.894.583z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M234.139 236.871l26.024 56.207c1.328 1.065 2.474-.321 2.855-.16 1.591 1.852 3.826 2.263 4.29 2.696 1.837 2.601.754 4.675.638 4.847-1.452 1.885 1.594 3.787 1.458 4.374.583 1.079 2.863.87 3.305 2.173.104-.145 4.443 8.946 4.899 9.92.663.532 3.756 6.592 3.756 6.592 2.254-.005 11.027-5.4 11.196-5.312-4.709-7.859-16.136-19.98-15.883-20.739-3.168-5.602-8.285-11.698-10.539-11.693-3.162-1.73-4.632-6.079-3.99-7.066-2.455-.094-3.763-1.575-3.933-1.664l-19.232-40.371c-1.664-.577-1.425.111-1.981 1.067 0 0-1.042-1.299-.969-1.454-.937-.476-1.873.167-1.894.583z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M233.337 224.681c.497 1.11-.308 1.103-.588 1.248l-1.16.295c-1.302 0-2.003.665-2.023 1.082l30.597 65.772c1.328 1.065 2.644-.233 3.055-.06l-20.986-44.94s-8.107-15.808-10.225-20.199l2.92-1.195c.904-.2 1.186-.798.809-1.716l-12.939-23.255 10.353 22.542.187.426",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M233.337 224.681c.497 1.11-.308 1.103-.588 1.248l-1.16.295c-1.302 0-2.003.665-2.023 1.082l30.597 65.772c1.328 1.065 2.644-.233 3.055-.06l-20.986-44.94s-8.107-15.807-10.225-20.199l2.92-1.195c.904-.2 1.186-.798.809-1.716l-12.939-23.255 10.353 22.542.187.426",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 293.243c3.138-.092 4.849 2.255 2.745 5.002m-1.419-2.517c1.113.628 1.844-.329 1.844-.329m-15.982-14.182c1.536 6.004 4.469 10.013 5.05 11.242 2.256 2.384 4.054 7.754 3.686 8.683l8.35 14.321",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M260.301 293.307c1.42-.474 6.181-4.75 10.753-3.923 3.411 4.114 5.422 8.287 6.031 8.861-4.338 3.455-7.183 5.16-8.235 5.673-.67-.444-1.016-1.652-1.016-1.652-.868-.996.24-1.852.24-1.852-.066-2.623-1.936-4.48-3.87-4.635-2.423-.235-1.737-.421-2.046-.437-1.1-.653-1.857-2.035-1.857-2.035z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M260.301 293.307c1.42-.474 6.181-4.75 10.753-3.923 3.411 4.114 5.422 8.287 6.031 8.861-4.338 3.455-7.183 5.16-8.235 5.673-.67-.444-1.016-1.652-1.016-1.652-.868-.996.24-1.852.24-1.852-.066-2.623-1.936-4.48-3.87-4.635-2.423-.235-1.737-.421-2.046-.437-1.1-.653-1.857-2.035-1.857-2.035z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M264.944 293.464c2.15-.01 4.328 1.047 5.01 2.885l-5.01-2.885",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M264.944 293.464c2.15-.01 4.328 1.047 5.01 2.885m3.82.78c-.207.441-.772.669-1.287.49-.514-.178-.766-.688-.557-1.13.208-.441.79-.632 1.304-.454.515.178.749.652.54 1.093zm-2.594-3.68c-.208.441-.803.658-1.317.48-.514-.178-.737-.678-.529-1.12.208-.441.761-.643 1.275-.465.514.178.78.663.571 1.104z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M236.412 243.251c-.847-.293-1.2-1.262-.772-2.172l5.04-1.73s.58.11 1.068.793c.476.708-.205 1.26-.205 1.26l-5.131 1.85",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M236.412 243.251c-.847-.293-1.2-1.262-.772-2.172l5.04-1.73s.58.11 1.068.793c.476.708-.205 1.26-.205 1.26l-5.131 1.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M250.934 267.377c.556-.62 37.479-39.977 37.905-40.438a94.12 94.12 0 0 1-1.455-.997c-.414.432-37.434 39.832-38.031 40.45-.404-.174 2.016 1.351 1.58.985z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M287.8 226.355c-1.342-1.093-3.678-2.385-5.32-1.961-.554-2.29 2.67-4.677 4.022-4.328-.338 2.51 3.398 4.102 3.328 4.11l-2.03 2.179z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M290.246 224.433c1.043.82 1.492.883 2.976 1.682 1.456.783 3.46-1.189 4.387-1.796 0 0 .994 3.626-1.208 6.017-2.2 2.39-4.858 2.897-6.958 2.194 0 0 2.765-2.709 1.624-3.885-1.105-1.14-1.504-1.232-2.606-1.954",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.67726 .73575 -.82314 -.56784 0 0)",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.132,
    d: "M19.355-370.222h4.413v2.415h-4.413z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M243.38 309.67l-.984 9.64s1.492-1.826 1.85-2.432c.359-.607 1.652-2.23 1.929-7.85 0 0-1.01-3.107-1.486-3.1-.79-.39-1.31 3.741-1.31 3.741zm2.37-21.495s-2.588 15.48-2.85 16.888c0 .482 1.313 1.758 2.262-1.235l1.564-11.254s-.703-2.999-.976-4.399z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 303.536c-.631-.793-1.42-1.785-1.498-2.185l-.408 3.415s2.154 1.574 1.847 4.587l.418-.607.242-1.207s.442-2.012.446-3.215c0 0-.455-.195-1.047-.788z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M242.396 319.309s3.576-3.06 3.779-10.282l.443-2.012s.074 1.603.79.39c.7-1.615.665-3.018.665-3.018s1.293-1.623 1.683.377c0 0-1.201 9.444-1.283 10.247a54.753 54.753 0 0 1-.285 2.21s-.71-1.193-1.427.02c-.777 1.215-2.01 2.837-4.365 2.068zm4.33-26.737l-1.563 11.254s1.246.584 1.455 3.189c.114 1.201.592.593.79.39.261-.806.068-2.408.068-2.408l.68-7.832s-1.354-3.59-1.43-4.593z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M245.488 318.665l-.228 2.811s1.07-.015 1.788-1.228c.836-1.216 1.14-3.025 1.14-3.025s-.829-1.192-1.427.02c-.578 1.011-1.273 1.422-1.273 1.422zm1.92-11.259c.578-1.01.763-2.819.664-3.018l-.727.61c.234 1.2.063 2.408.063 2.408z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M250.93 306.273c-.491-.996-1.322-1.586-1.322-1.586l-1.588 12.658s-.447 3.215-2.43 4.046c0 0 1.13 11.015 4.707 7.956.517-.409 1.162-3.827.951-5.83-.25-2.203-.834-5.203-.89-6.406-.034-1.403.164-2.825.509-5.036.14-.804.557-2.567.637-2.769.199-.203-.043-1.838-.574-3.033z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M252.65 304.327s.967.989 1.146.986c.237-.003-2.51 20.643-2.51 20.643s.103-2.165-.7-6.368c-.651-3.415.19-8 .925-10.199 0 0 .866-.646 1.139-5.062z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M248.076 297.372s-.534 5.824-.66 7.63c0 0 1.812-2.633 2.28-.232l.407-3.416s-1.576-2.585-2.027-3.982z",
    fill: "#f7e214",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M246.689 306.997s-.595-6.523-3.755-1.912c-.122.002-.29 2.592-.108 3.212.099.83.973 1.855 1.339 2.472.69 1.028 1.43-.228 1.43-.228s.718-1.048 1.094-3.544z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M221.652 252.734c-.116-3.712-1.284-9.888-1.342-14.121l-12.807-13.05s-1.58 10.573-6.23 16.618l20.38 10.56",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M222.577 253.174c.54-2.582 1.187-5.488 1.616-10.888l-8.244-8.123c.033 3.39-3.806 8.634-4.066 14.968",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M229.687 260.994c.945-4.53-1.373-5.092 2.075-11.466l-7.618-7.305c-1.42 4.296-2.375 7.06-2.251 10.773l6.49 4.618",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M200.055 288.087c-1.543-4.584.551-13.58.319-19.342-.175-3.718 2.559-17.698 2.5-21.927l-15.055-9.403s-.656 15.28-2.389 31.922c-1.559 8.548-1.549 16.36-.428 22.885 1.6 9.275 3.172 13.082 6.92 17.006 6.649 6.881 20.967 2.905 20.967 2.905 12.062-2.495 19.01-10.094 19.01-10.094s-3.923.927-10.28 1.573c-13.931-.976-19.418 2.506-19.852-11.788",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M240.404 297.35l.233-.101c-2.612.977-6.253 2.056-6.253 2.056l-8.489.653c-18.413.43-16.108-10.97-15.378-29.364.175-6.98 1.559-15.77 1.202-18.883l-12.343-7.071c-4.026 11.374-2.771 19.332-3.577 25.15-.42 6.269-1.757 18.51.275 23.85 2.877 12.426 12.606 11.92 25.777 10.827 6.533-.542 10.048-2.222 10.048-2.222l8.498-4.89",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M240.644 297.1c-2.553 1.322-6.311 2.298-6.311 2.298l-8.604.85c-13.348 1.132-21.162-8.244-19.452-29.446.011-7.49.251-10.817 2.836-20.795l7.336 4.304v.691c-.415 2.24-1.465 7.477-1.465 9.872 0 17.023 10.764 30.099 25.427 32.319l.233-.1",
    fill: "#007a3d",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M191.915 245.917c1.244 2.09 8.672 13.405 12.833 15.545m-11.582-8.153c1.244 2.14 10.338 14.884 14.434 15.601m-16.515 3.874c2.081 2.496 4.154 7.441 10.338 10.648m-7.428 3.518c4.155 3.874 14.434 12.389 24.358 12.739m-24.358-6.364c2.081 2.496 6.592 14.168 25.61 8.87m-28.52-6.73c1.244 2.8 10.753 18.403 27.69 12.382",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M210.933 282.486c-1.542-4.585.552-13.58.32-19.343-.175-3.718 1.578-16.577 1.52-20.806l-14.076-10.524s-.655 15.28-2.388 31.922c-1.56 8.549-2.748 19.02-1.593 25.538 1.891 10.669 7.02 13.67 7.947 14.495 7.19 6.406 23.422 5.776 25.035 5.2 11.6-4.146 16.652-11.515 16.652-11.515s-5.495-.089-11.852.558c-13.932-.976-20.968-.395-21.401-14.69",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M251.283 291.747l.233-.1c-2.612.977-6.254 2.056-6.254 2.056l-8.488.654c-18.413.43-16.108-10.97-15.378-29.364.175-6.98.415-13.25.058-16.363l-11.036-8.05c-4.026 11.374-2.934 17.79-3.74 23.61-.42 6.267-1.758 18.508.275 23.849 2.877 12.425 12.606 11.919 25.776 10.826 6.534-.542 10.049-2.221 10.049-2.221l8.497-4.89",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M251.61 291.581c-2.554 1.322-6.311 2.298-6.311 2.298l-8.604.85c-13.348 1.132-21.163-8.244-19.452-29.446.011-7.49-.239-8.015 2.345-17.993 4.089 2.65 11.904 9.321 11.904 9.321s-2.126 2.993-1.628 7.178c0 17.023 6.85 25.665 21.513 27.885l1.608-13.903",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M202.793 240.315c1.244 2.09 8.672 13.406 12.834 15.545m-11.582-8.153c1.244 2.14 10.338 14.884 14.434 15.601m-16.515 3.874c2.08 2.496 4.154 7.442 10.338 10.648m-7.428 3.518c4.154 3.874 14.434 12.39 24.358 12.739m-24.358-6.364c2.08 2.496 6.591 14.168 25.609 8.871m-28.52-6.731c1.245 2.801 10.754 18.403 27.69 12.383",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M187.918 238.894s-.623 5.422-.682 6.394c-.288 4.702-.155 8.26.066 10.475-.014.24.906 5.864.589 6.165-1.08 1.233-1.119 1.37-2.258.457-.163-.187.491-5.948.54-6.74.11-.85.288-7.58.41-10.515.012-1.16 1.01-6.872 1.01-6.872s.132-1.216.319.62",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M187.918 238.894s-.623 5.422-.682 6.394c-.288 4.702-.148 8.26.066 10.475-.014.24 1.098 8.069.752 6.172-1.08 1.234-1.302 1.699-2.441.786-.164-.188.511-6.284.56-7.076.11-.85.288-7.58.41-10.515.012-1.16 1.01-6.872 1.01-6.872s.132-1.216.319.62l.006.016z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M187.801 236.993s-1.228 6.496-1.339 10.224c-.16 4.521-.354 5.8-.282 8.436.047.18-.442 3.405-.586 4.808-.102.722.106.185-.014.239-.923.565-1.551.11-2.114-.335-.167-.127 1.492-4.034 1.54-4.826.877-11.474 2.54-18.198 2.54-18.198s-.663 4.07.255-.348",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M187.801 236.993s-1.228 6.496-1.332 10.224c-.16 4.521-.354 5.8-.282 8.436.047.18-.441 3.406-.585 4.808-.103.723.105.185-.015.24-.923.564-1.551.11-2.114-.336-.167-.126 1.492-4.034 1.541-4.833.876-11.475 2.533-18.199 2.533-18.199s-.664 4.07.254-.347v.008zm-.532 18.47s-.974.44-1.082.19m-.042-1.337s.832-.022.963-.256m-.049-1.12s-.614.401-.78.146m.765-1.794l-.592.025m.63-1.62l-.649.022m.548-2.291s-.367.164-.41-.078m.526-1.813l-.53-.024m-.508 10.202s-.955.135-1.06-.169m1.137-2.033s-.952.078-.992-.225m1.03-1.362s-.773.025-.828-.037m.98-1.493l-.77-.035m.766-1.802l-.527-.083m.74-1.496s-.48.1-.581-.145m.635-1.697s-.432.282-.414-.018m-.052 9.556s-.948.009-.93-.282m13.603-21.101s-.622 5.421-.682 6.394c-.287 4.702-.155 8.26.067 10.474-.015.24.906 5.865.589 6.165-1.081 1.233-1.12 1.37-2.258.458-.164-.188.49-5.948.54-6.74.11-.852.288-7.581.409-10.515.013-1.16 1.01-6.873 1.01-6.873s.133-1.216.32.621",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M198.797 233.293s-.623 5.421-.683 6.394c-.287 4.701-.148 8.26.067 10.474-.015.24 1.098 8.07.752 6.172-1.081 1.234-1.303 1.7-2.442.786-.163-.187.512-6.283.56-7.076.11-.85.289-7.58.41-10.514.013-1.16 1.01-6.873 1.01-6.873s.133-1.216.32.621l.005.016z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M198.68 231.391s-1.228 6.497-1.34 10.224c-.159 4.521-.354 5.8-.282 8.436.048.18-.441 3.406-.585 4.808-.102.722.105.185-.015.239-.923.565-1.55.11-2.114-.335-.167-.126 1.493-4.034 1.541-4.826.876-11.474 2.54-18.198 2.54-18.198l.255-.348",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M198.68 231.391s-1.228 6.497-1.332 10.224c-.16 4.522-.354 5.8-.282 8.437.047.18-.442 3.405-.586 4.807-.102.723.106.185-.014.24-.924.564-1.552.11-2.114-.336-.167-.126 1.492-4.033 1.54-4.833.877-11.474 2.534-18.199 2.534-18.199l.254-.347v.008zm-.532 18.47s-.974.441-1.082.19m-.043-1.337s.832-.022.963-.256m-.048-1.119s-.614.4-.78.145m.764-1.794l-.591.025m.63-1.62l-.65.023m.549-2.292s-.367.164-.41-.078m.525-1.812l-.53-.024m-.507 10.201s-.955.136-1.06-.168m1.136-2.033s-.951.078-.991-.225m1.03-1.363s-.774.025-.828-.037m.98-1.493l-.77-.034m.766-1.802l-.527-.084m.74-1.496s-.48.1-.582-.145m.636-1.696s-.432.281-.414-.019m-.052 9.556s-.948.009-.93-.282",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M207.288 225.346s.49 5.481.19 8.578c-.347 3.759-.295 4.834-.669 7.011-.059.146.066 2.858.045 4.03.015.607-.125.145-.012.2.856.544 1.53.22 2.141-.104.239-.088-1.034-3.464-.993-4.124.41-9.577-.495-15.283-.495-15.283l-.214-.309",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M207.288 225.346s.495 5.481.183 8.578c-.345 3.758-.296 4.834-.67 7.011-.059.146.067 2.857.045 4.03.015.607-.124.145-.012.2.857.544 1.531.219 2.142-.104.239-.088-1.034-3.464-.993-4.13.41-9.577-.488-15.283-.488-15.283l-.214-.31zm-.36 15.65s.936.191 1.076-.052m-.839-1.774s.939.143.954-.108m-.873-1.213s.76.084.828.038m-.815-1.318l.77.035m-.562-1.556l.534-.026m-.503-1.297s.401.119.536-.075m-.442-1.457s.392.268.407.018m-1.018 7.92s.943.085.958-.157",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M241.08 236.424l.85.063s-1.314-.096-.85-.063z",
    fill: "#005000",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M252.506 273.494s-.397-.17-.496 0c0 .085.1.17.198.17.1 0 .298-.17.298-.17zm-1.09 1.189s1.684-.17 2.279-.17",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M226.336 303.15c-.243 3.26-7.845 7.009-13.525.128-6.068-4.804-4.755-12.15.067-13.168l58.255-56.814c2.337-1.276 2.562-2.493 3.726-3.736 2.445 2.596 7.508 7.257 10.27 9.508-1.68 1.406-3.046 2.737-3.418 3.833l-55.375 60.249z",
    fill: "#e8a30e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.132
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M275.006 229.387c2.781-3.816 13.62 6.098 10.724 9.176-2.896 3.077-13.286-5.324-10.724-9.176z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.132,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M284.76 237.823c-2.041 1.55-9.9-5.104-8.599-7.62 2.168-2.356 10.814 6.091 8.6 7.62z",
    fill: "#cccccf",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.132
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M281.63 243.064c-4.882-1.557-8.342-4.805-10.532-9.662m-24.503 47.92c-6.14-1.897-10.345-5.9-12.239-12.42m9.75 15.281c-6.14-1.897-10.345-5.9-12.239-12.42m-2.252 27.515c-6.14-1.897-11.071-6.393-12.965-12.913m10.405 15.776c-6.14-1.898-11.145-6.465-13.038-12.985",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M212.636 304.022c-.305 1.449-1.098 1.901-2.206 1.458m14.667-2.047c-2.305 3.627-4.868 2.535-7.012 2.572",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M209.484 304.215c0 .97.819 1.753 1.832 1.752 1.013-.001 1.838-.787 1.843-1.756.006-.97-.81-1.757-1.823-1.761-1.013-.004-1.834 1.07-1.844 2.04",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M212.81 303.847c-.304 1.449-1.097 1.901-2.205 1.458m14.492-1.872c-2.305 3.627-4.868 2.535-7.012 2.572",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M268.62 309.67l.984 9.64s-1.492-1.826-1.85-2.432c-.359-.607-1.652-2.23-1.929-7.85 0 0 1.01-3.107 1.486-3.1.79-.39 1.31 3.741 1.31 3.741zm-2.37-21.495s2.588 15.48 2.85 16.888c0 .482-1.313 1.758-2.262-1.235l-1.564-11.254s.703-2.999.976-4.399z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M260.398 303.536c.631-.793 1.42-1.785 1.498-2.185l.408 3.415s-2.154 1.574-1.847 4.587l-.418-.607-.242-1.207s-.442-2.012-.446-3.215c0 0 .455-.195 1.047-.788z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M269.604 319.309s-3.576-3.06-3.779-10.282l-.443-2.012s-.074 1.603-.79.39c-.7-1.615-.665-3.018-.665-3.018s-1.293-1.623-1.683.377c0 0 1.201 9.444 1.283 10.247.103 1.004.285 2.21.285 2.21s.71-1.193 1.427.02c.776 1.215 2.01 2.837 4.365 2.068zm-4.33-26.737l1.563 11.254s-1.246.584-1.455 3.189c-.115 1.201-.592.593-.79.39-.261-.806-.068-2.408-.068-2.408l-.68-7.832s1.354-3.59 1.43-4.593z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M266.512 318.665l.228 2.811s-1.07-.015-1.788-1.228c-.836-1.216-1.14-3.025-1.14-3.025s.829-1.192 1.427.02c.578 1.011 1.273 1.422 1.273 1.422zm-1.92-11.259c-.578-1.01-.763-2.819-.664-3.018l.727.61c-.234 1.2-.063 2.408-.063 2.408z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M261.07 306.273c.491-.996 1.322-1.586 1.322-1.586l1.588 12.658s.447 3.215 2.43 4.046c0 0-1.13 11.015-4.707 7.956-.517-.409-1.162-3.827-.951-5.83.25-2.203.834-5.203.89-6.406.034-1.403-.164-2.825-.509-5.036-.14-.804-.557-2.567-.637-2.769-.199-.203.043-1.838.574-3.033z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.35 304.327s-.967.989-1.146.986c-.237-.003 2.51 20.643 2.51 20.643s-.103-2.165.7-6.368c.651-3.415-.19-8-.925-10.199 0 0-.866-.646-1.139-5.062z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M263.924 297.372s.534 5.824.66 7.63c0 0-1.812-2.633-2.28-.232l-.407-3.416s1.576-2.585 2.027-3.982z",
    fill: "#f7e214",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M265.311 306.997s.595-6.523 3.755-1.912c.122.002.29 2.592.108 3.212-.099.83-.973 1.855-1.339 2.472-.69 1.028-1.43-.228-1.43-.228s-.718-1.048-1.094-3.544z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M290.348 252.734c.116-3.712 1.284-9.888 1.342-14.121l12.807-13.05s1.58 10.573 6.23 16.618l-20.38 10.56",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M289.423 253.174c-.54-2.582-1.187-5.488-1.616-10.888l8.244-8.123c-.033 3.39 3.806 8.634 4.066 14.968",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M282.313 260.994c-.945-4.53 1.373-5.092-2.075-11.466l7.618-7.305c1.42 4.296 2.375 7.06 2.251 10.773l-6.49 4.618",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M311.945 288.087c1.543-4.584-.552-13.58-.319-19.342.175-3.718-2.559-17.698-2.5-21.927l15.055-9.403s.656 15.28 2.389 31.922c1.559 8.548 1.549 16.36.428 22.885-1.6 9.275-3.172 13.082-6.92 17.006-6.649 6.881-20.967 2.905-20.967 2.905-12.062-2.495-19.01-10.094-19.01-10.094s3.923.927 10.28 1.573c13.931-.976 19.418 2.506 19.852-11.788",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M271.596 297.35l-.233-.101c2.611.977 6.253 2.056 6.253 2.056l8.489.653c18.413.43 16.108-10.97 15.378-29.364-.175-6.98-1.559-15.77-1.202-18.883l12.343-7.071c4.026 11.374 2.771 19.332 3.577 25.15.42 6.269 1.757 18.51-.275 23.85-2.877 12.426-12.606 11.92-25.777 10.827-6.533-.542-10.048-2.222-10.048-2.222l-8.498-4.89",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M271.356 297.1c2.553 1.322 6.31 2.298 6.31 2.298l8.605.85c13.348 1.132 21.162-8.244 19.452-29.446-.011-7.49-.251-10.817-2.836-20.795l-7.336 4.304v.691c.415 2.24 1.464 7.477 1.464 9.872 0 17.023-10.763 30.099-25.426 32.319l-.233-.1",
    fill: "#007a3d",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M320.085 245.917c-1.244 2.09-8.672 13.405-12.833 15.545m11.582-8.153c-1.244 2.14-10.338 14.884-14.434 15.601m16.515 3.874c-2.081 2.496-4.155 7.441-10.338 10.648m7.428 3.518c-4.155 3.874-14.434 12.389-24.358 12.739m24.358-6.364c-2.081 2.496-6.592 14.168-25.61 8.87m28.52-6.73c-1.244 2.8-10.753 18.403-27.69 12.382",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M301.066 282.486c1.543-4.585-.551-13.58-.318-19.343.174-3.718-1.58-16.577-1.521-20.806l14.076-10.524s.655 15.28 2.388 31.922c1.56 8.549 2.748 19.02 1.593 25.538-1.891 10.669-7.02 13.67-7.947 14.495-7.19 6.406-23.422 5.776-25.035 5.2-11.6-4.146-16.652-11.515-16.652-11.515s5.495-.089 11.852.558c13.932-.976 20.968-.395 21.401-14.69",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M260.717 291.747l-.233-.1c2.612.977 6.254 2.056 6.254 2.056l8.488.654c18.413.43 16.108-10.97 15.378-29.364-.175-6.98-.415-13.25-.058-16.363l11.036-8.05c4.026 11.374 2.934 17.79 3.74 23.61.42 6.267 1.758 18.508-.275 23.849-2.877 12.425-12.606 11.919-25.776 10.826-6.534-.542-10.049-2.221-10.049-2.221l-8.497-4.89",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M260.39 291.581c2.554 1.322 6.311 2.298 6.311 2.298l8.604.85c13.348 1.132 21.163-8.244 19.452-29.446-.011-7.49.239-8.015-2.345-17.993-4.089 2.65-11.904 9.321-11.904 9.321s2.126 2.993 1.628 7.178c0 17.023-6.85 25.665-21.513 27.885l-1.609-13.903",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M309.207 240.315c-1.244 2.09-8.672 13.406-12.834 15.545m11.582-8.153c-1.244 2.14-10.338 14.884-14.434 15.601m16.515 3.874c-2.08 2.496-4.154 7.442-10.338 10.648m7.428 3.518c-4.154 3.874-14.434 12.39-24.358 12.739m24.358-6.364c-2.08 2.496-6.591 14.168-25.609 8.871m28.52-6.731c-1.245 2.801-10.754 18.403-27.69 12.383",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M324.082 238.894s.623 5.422.682 6.394c.288 4.702.155 8.26-.066 10.475.014.24-.906 5.864-.59 6.165 1.082 1.233 1.12 1.37 2.259.457.163-.187-.491-5.948-.54-6.74-.11-.85-.288-7.58-.41-10.515-.012-1.16-1.01-6.872-1.01-6.872s-.132-1.216-.319.62",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M324.082 238.894s.623 5.422.682 6.394c.288 4.702.148 8.26-.066 10.475.014.24-1.098 8.069-.752 6.172 1.08 1.234 1.302 1.699 2.441.786.164-.188-.511-6.284-.56-7.076-.11-.85-.288-7.58-.41-10.515-.012-1.16-1.01-6.872-1.01-6.872s-.132-1.216-.319.62l-.006.016z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M324.199 236.993s1.228 6.496 1.339 10.224c.16 4.521.354 5.8.282 8.436-.047.18.442 3.405.585 4.808.103.722-.105.185.015.239.923.565 1.551.11 2.114-.335.167-.127-1.492-4.034-1.54-4.826-.877-11.474-2.54-18.198-2.54-18.198s.663 4.07-.255-.348",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M324.199 236.993s1.228 6.496 1.332 10.224c.16 4.521.354 5.8.282 8.436-.047.18.441 3.406.585 4.808.103.723-.105.185.015.24.923.564 1.551.11 2.114-.336.167-.126-1.492-4.034-1.541-4.833-.876-11.475-2.533-18.199-2.533-18.199s.664 4.07-.255-.347v.008zm.531 18.47s.975.44 1.083.19m.042-1.337s-.832-.022-.963-.256m.049-1.12s.614.401.78.146m-.765-1.794l.592.025m-.63-1.62l.649.022m-.548-2.291s.367.164.41-.078m-.526-1.813l.53-.024m.508 10.202s.955.135 1.06-.169m-1.137-2.033s.952.078.992-.225m-1.03-1.362s.773.025.828-.037m-.98-1.493l.77-.035m-.766-1.802l.527-.083m-.74-1.496s.48.1.581-.145m-.635-1.697s.432.282.414-.018m.052 9.556s.948.009.93-.282",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M313.203 233.293s.623 5.421.683 6.394c.287 4.701.155 8.26-.067 10.474.015.24-.906 5.865-.589 6.165 1.081 1.233 1.12 1.37 2.258.458.164-.188-.491-5.948-.54-6.74-.11-.852-.288-7.581-.409-10.515-.013-1.16-1.01-6.873-1.01-6.873s-.133-1.216-.32.621",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M313.203 233.293s.623 5.421.683 6.394c.287 4.701.147 8.26-.067 10.474.015.24-1.098 8.07-.752 6.172 1.081 1.234 1.303 1.7 2.442.786.163-.187-.512-6.283-.56-7.076-.11-.85-.289-7.58-.41-10.514-.013-1.16-1.01-6.873-1.01-6.873s-.133-1.216-.32.621l-.005.016z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M313.32 231.391s1.228 6.497 1.34 10.224c.159 4.521.354 5.8.282 8.436-.048.18.441 3.406.585 4.808.102.722-.105.185.014.239.924.565 1.552.11 2.115-.335.167-.126-1.493-4.034-1.541-4.826-.876-11.474-2.54-18.198-2.54-18.198l-.255-.348",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M313.32 231.391s1.228 6.497 1.332 10.224c.16 4.522.354 5.8.282 8.437-.047.18.442 3.405.586 4.807.102.723-.106.185.014.24.924.564 1.552.11 2.114-.336.167-.126-1.492-4.033-1.54-4.833-.877-11.474-2.534-18.199-2.534-18.199l-.254-.347v.008zm.532 18.47s.974.441 1.082.19m.043-1.337s-.832-.022-.963-.256m.048-1.119s.614.4.78.145m-.764-1.794l.591.025m-.63-1.62l.65.023m-.549-2.292s.367.164.41-.078m-.525-1.812l.53-.024m.507 10.201s.955.136 1.06-.168m-1.136-2.033s.951.078.991-.225m-1.03-1.363s.774.025.828-.037m-.98-1.493l.77-.034m-.766-1.802l.527-.084m-.74-1.496s.48.1.581-.145m-.635-1.696s.432.281.414-.019m.052 9.556s.948.009.93-.282m-11.216-23.446s-.49 5.481-.19 8.578c.347 3.759.295 4.834.669 7.011.059.146-.066 2.858-.045 4.03-.015.607.125.145.012.2-.856.544-1.53.22-2.141-.104-.239-.088 1.034-3.464.993-4.124-.41-9.577.495-15.283.495-15.283l.214-.309",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M304.712 225.346s-.495 5.481-.183 8.578c.345 3.758.296 4.834.67 7.011.059.146-.067 2.857-.045 4.03-.015.607.124.145.012.2-.857.544-1.531.219-2.142-.104-.239-.088 1.034-3.464.993-4.13-.41-9.577.487-15.283.487-15.283l.215-.31zm.36 15.65s-.936.191-1.076-.052m.839-1.774s-.939.143-.954-.108m.873-1.213s-.76.084-.828.038m.815-1.318l-.77.035m.562-1.556l-.534-.026m.503-1.297s-.401.119-.536-.075m.442-1.457s-.392.268-.407.018m1.018 7.92s-.943.085-.958-.157",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M270.92 236.424l-.85.063s1.314-.096.85-.063z",
    fill: "#005000",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M259.494 273.494s.397-.17.496 0c0 .085-.1.17-.198.17-.1 0-.298-.17-.298-.17zm1.09 1.189s-1.684-.17-2.279-.17",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M225.777 229.84c-.03-2.24 2.08-3.536 2.404-3.755 1.035-.7 1.74-1.305 3.97-1.597 0 0 .153.462.145.859-.008.397-.494 1.769-2.209 2.928-1.746 1.18-4.31 1.565-4.31 1.565z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M225.753 228.986l31.62 41.045 1.502-1.48-32.256-41.692-.866 2.127z",
    fill: "#a05a2c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M225.263 220.97s3.42-.355 2.969-2.31c-.484-1.934-2.788-1.898-3.75-1.988-.994-.066-4.131.663-5.062 1.596-.963.956-2.928 2.588-2.291 5.33.637 2.744 1.444 4.632 2.453 6.34 1.002 1.759.75 3.45.483 4.196-.081.316-.397 1.354.46 1.733 1.26.538 1.576.542 2.667-.674 1.117-1.189 2.614-3.114 2.583-5.354-.03-2.239 2.08-3.535 2.404-3.754 1.035-.7 1.739-1.305 3.97-1.597 0 0-.791-1.29-1.98-1.226-1.213.037-3.62-1.03-4.906-2.292z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M225.263 220.97s3.42-.355 2.969-2.31c-.484-1.934-2.788-1.898-3.75-1.988-.994-.066-4.131.663-5.062 1.596-.963.956-2.928 2.588-2.291 5.33.637 2.744 1.444 4.632 2.453 6.34 1.002 1.759.75 3.45.483 4.196-.081.316-.397 1.354.46 1.733 1.26.538 1.576.542 2.667-.674 1.117-1.189 2.614-3.114 2.583-5.354-.03-2.239 2.08-3.535 2.404-3.754 1.035-.7 1.739-1.305 3.97-1.597 0 0-.791-1.29-1.98-1.226-1.213.037-3.62-1.03-4.906-2.292z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M225.263 220.97c-.46.007-1.826-.591-2.772-.256-.922.362-2.831 1.478-2.524 3.097m11.123-.216s-1.972.812-3.363 1.752c-.583.394-2.516 2.179-3.762 3.456-1.1 1.09-1.344 2.56-3.706 4.156m9.587-9.652c-.405.36-.81.72-1.505 1.103-.662.362-.874.939-1.294 1.397",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M285.664 303.15c.243 3.26 7.845 7.009 13.525.128 6.068-4.804 4.755-12.15-.067-13.168l-58.255-56.814c-2.337-1.276-2.562-2.493-3.726-3.736-2.445 2.596-7.508 7.257-10.27 9.508 1.68 1.406 3.046 2.737 3.418 3.833l55.375 60.249z",
    fill: "#e8a30e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.132
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M236.994 229.387c-2.781-3.816-13.62 6.098-10.724 9.176 2.896 3.077 13.286-5.324 10.724-9.176z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.132,
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M227.24 237.823c2.041 1.55 9.9-5.104 8.599-7.62-2.168-2.356-10.814 6.091-8.6 7.62z",
    fill: "#cccccf",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.132
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M230.37 243.064c4.882-1.557 8.342-4.805 10.532-9.662m24.503 47.92c6.14-1.897 10.345-5.9 12.239-12.42m-9.75 15.281c6.14-1.897 10.345-5.9 12.239-12.42m2.252 27.515c6.14-1.897 11.071-6.393 12.965-12.913m-10.405 15.776c6.14-1.898 11.145-6.465 13.038-12.985",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M299.364 304.022c.305 1.449 1.098 1.901 2.206 1.458m-14.667-2.047c2.305 3.627 4.868 2.535 7.012 2.572",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M302.516 304.215c0 .97-.819 1.753-1.832 1.752-1.013-.001-1.838-.787-1.843-1.756-.006-.97.81-1.757 1.823-1.761 1.013-.004 1.834 1.07 1.844 2.04",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M299.19 303.847c.304 1.449 1.097 1.901 2.205 1.458m-14.492-1.872c2.305 3.627 4.868 2.535 7.012 2.572",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M276.96 187.22c1.893 3.029 4.7 8.493 5.467 12.68 1.413 7.721-.796 16.282-7.523 22.332-5.48 4.929-14.083 6.452-17.674 7.189-3.583.735-6.175 1.887-6.767 2.68-.03-.558-.112-1.116.486-1.674 1.701-.75 4.462-1.193 8.311-1.987 7.735-1.594 15.861-4.494 20.288-12.934 5.773-11.006 2.333-19.655-2.667-28.241l.079-.045z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M279.085 219.98a.462.605 49.857 0 1-.667-.643.462.605 49.857 0 1 .667.644z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M284.348 218.602c-1.15.683-2.29.861-3.204 1.167-.706.235-1.921.618-2.34.776-.4.15-1.024.432-1.558.673-.846.383-1.762 1.446-1.762 1.446s1.288 1.351 2.826 1.16c1.206-.15 1.814-.48 2.419-.775.628-.306.614-.653 1.52-1.306 1.001-.722 1.703-2.147 2.099-3.141zm-6.029 1.276c-.368.578-1.25.533-1.754.454l-.228.289c.692.01 1.638.017 2.112-.606-.012-.093-.068-.138-.13-.137z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M284.332 218.654c-1.041 1.015-2.985 2.143-4.935 2.976-1.953.834-4.234 1.101-5.334 1.095l-.29.306c1.582-.148 3.667-.434 5.434-1.16 2.304-.944 4.196-2.16 5.14-3.156l-.015-.06zm-2.537 4.88c-2.077-.073-3.22.573-5.15.995-1.803.395-3.913-.543-5.08 1.192 4.7 3.047 8.093.997 10.23-2.187z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M277.567 227.803c-.895-.768-8.586-3.37-9.814-.462 1.83 2.023 7.185 2.475 9.814.462z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M275.744 229.85c-.812-.128-1.77-.317-2.705-.425-.94-.108-1.308-.271-2.003-.367-1.137-.157-2.438-1.752-6.444-.534 1.551 3.572 6.844 4.322 11.152 1.326zm1.732-1.99c-4.097.818-8.913-.003-10.817-1.125l-.304.202c4.39 1.871 8.655 1.625 11.121.923zm4.254-4.326c-2.413 1.618-5.523 2.825-12.185 1.932l-.09.231c9.128.783 10.03-.89 12.275-2.163z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M275.714 229.88c-3.185.112-4.978 1.531-10.944-1.405-.487-.24-1.138-.407-1.515-.586l-.547.202c.416.185 1.086.18 1.46.345 7.45 3.287 7.24 1.75 11.546 1.443z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M263.735 225.713a.456.614 66.176 1 0 .468.786.456.614 66.176 1 0-.468-.786z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M263.624 226.404c-.688.177-.885.994-.944 1.475l-.355.129c.18-.635.434-1.5 1.196-1.76.091.036.12.1.103.156z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M283.649 199.268a.474.59 15.75 1 1-.923-.22.474.59 15.75 0 1 .923.22z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M279.063 216.697c-.149-2.225-1.229.859-3.41-4.112-.634-1.445-.629-2.367-1.059-4.535 1.188 1.874 3.173 2.38 3.98 3.829.792 1.425.59 3.716.49 4.818z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M274.637 208.213s1.075 2.508 2.622 4.283c1.556 1.785 1.847 3.956 1.847 3.956",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M275.7 210.343c1.37 1.843 3.209 4.027 3.295 6.32l.214.079c-.319-3.015-2.101-4.408-3.2-5.929l-.308-.47zm11.571 2.846c-1.001.824-2.055 1.122-2.879 1.53-.637.315-1.172.733-1.547.938-.36.196-.944.288-1.418.591-.752.482-2.222 2.168-2.222 2.168s1.394 1.142 2.258.955c2.512-.487 3.244-1.484 4.512-2.407.978-.801 1.044-2.704 1.296-3.775z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M278.075 218.492l-.236.347c1.441-.142 3.738-1.526 5.269-2.297 2.06-1.036 3.213-1.825 4.081-3.299-.983 1.474-2.268 2.31-4.202 3.245-1.623.785-3.932 2.113-4.912 2.004z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M288.126 208.317c-.84.973-1.825 1.437-2.564 1.971-.572.413-1.024.911-1.357 1.174-.319.251-.879.436-1.292.811-.654.596-1.625 2.336-1.625 2.336s.696.744 1.514.42c2.532-.314 3.276-1.515 4.218-3.675.527-1.121 1.048-1.941 1.106-3.037z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M278.975 212.745a.594.471 61.956 1 0 .864-.376.594.471 61.956 0 0-.864.376z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M280.012 215.025l-.171.38c3.035-1.384 7.017-4.175 8.32-7.017-1.853 3.066-4.915 5.087-8.15 6.637zm8.806-11.398c-.721 1.013-1.616 1.535-2.275 2.11-.509.445-.9.966-1.194 1.246-.283.269-.797.488-1.16.885-.573.63-1.363 2.405-1.363 2.405s.926.872 1.674.498c.747-.374 1.75-1.222 2.246-1.665.516-.46.643-1.573 1.25-2.42.705-.987.847-1.978.822-3.06z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M286.633 206.761c-1.473 1.677-3.284 3.276-4.98 4.007l-.134.385c2.762-1.566 3.926-2.981 5.148-4.338l-.034-.054zm1.14-6.022c-.502.984-1.256 1.567-1.776 2.162-.403.46-.68.968-.909 1.255-.22.274-.667.539-.94.936-.43.63-.863 2.285-.863 2.285s.628.668 1.268.235c.64-.433 1.558-1.318 1.948-1.774.407-.475.612-1.503 1.035-2.327.492-.958.452-1.839.238-2.772zm-4.66-1.167c-.267.577-.374 1.143-.547 1.738l-.068-.425c.142-.466.256-.957.478-1.385.046-.01.091-.012.137.072z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M286.262 203.776c-1.095 1.669-2.525 3.32-3.999 4.201l-.058.353c2.333-1.76 3.184-3.158 4.099-4.513l-.042-.041zm-5.995 10.555c-.122-.532-.22-.95-.569-1.428-.052-.003-.09.013-.101.062.318.515.452.967.54 1.59l.13-.224z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M279.345 193.406a.458.35 39.522 0 1-.52.472.458.35 39.522 0 1 .52-.472z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M280.693 194.699c-.38-.331-.852-.628-1.332-.921-.055.019-.06.057-.045.105.551.348 1.035.686 1.445 1.073l-.068-.257zm5.89.38c-1.206 2.544-4.107 4.322-2.943 8.055 2.998 2.708 3.19-4.845 2.944-8.056z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M283.833 189.51c-.493 2.601-2.802 4.752-1.289 8.2 4.25 1.068 2.225-4.66 1.29-8.2z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M281.32 185.615c2.135 3.971 2.648 6.268.128 8.872 0 0-1.323-1.244-1.638-3.532-.268-1.935 1.311-4.252 1.51-5.34z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M277.774 183.31c.567 2.518-1.612 3.672 1.504 6.914 2.224-2.645 1.162-3.306-1.504-6.914z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M276.936 187.716c-3.592.383-2.193-2.73-3.217-5.606 2.116 1.577 4.982 2.211 3.217 5.606zm2.342 4.752c-1.01-4.684-4.233-2.852-6.016-4.916.922 3.02 2.277 5.083 6.016 4.916zm1.45 4.357c-2.807-.185-5.083-1.567-6.594-4.673 2.879 1.286 6.07 1.416 6.594 4.673z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M281.153 200.892c-1.107-1.272-1.135-2.092-1.556-2.94-.698-1.403-1.439-2.645-3.245-3.954.013 3.313.484 6.973 4.801 6.894z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M281.791 204.353c-1.723-2.4-3.32-4.44-5.925-6.115 1.08 2.357.581 6.717 5.925 6.115z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M281.305 209.112c-5.288-.148-4.788-5.137-4.832-7.47.955 1.428 2.123 2.67 2.993 3.697.95 1.122 1.866 2.388 1.839 3.773z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M280.667 212.083c-.428-1.082-.1-1.519-1.043-2.469-1.02-1.026-2.977-2.864-4.001-4.973-.148 1.865-.172 4.743 1.272 5.706 1.093.729 2.046.934 3.772 1.736zm-4.619 7.73c-4.15-3.228-1.655-5.95-1.307-8.365 1.055 2.722 4.023 5.07 1.307 8.365zm1.702-31.122c-1.334-2.502-2.144-3.873-3.923-6.483 2.054 2.969 2.94 4.854 4.12 6.887",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M276.109 220.62c.169-3.286-.727-6.118-1.307-9.085.549 3.133 1.327 6.285 1.033 9.345l.274-.26zm4.926-7.88c-.433-2.01-4.393-3.344-5.382-8.012.811 4.641 4.826 5.812 5.23 8.424l.152-.411zm.886-2.732l-.107.51c-.586-3.147-4.282-4.696-5.35-8.893 1.561 4.548 4.574 5.149 5.457 8.383zm.73-4.712c-1.818-2.774-4.361-3.82-6.768-7.077 2.251 3.2 5.09 4.7 6.812 7.506l-.043-.429zm-.064-3.65c-2.002-.857-4.079-3.259-6.252-7.649 1.425 3.249 3.232 6.187 6.252 8.138v-.49z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M281.663 197.363c-2.335-1.847-5.364-3.074-7.541-5.242 1.81 2.064 5.286 3.507 7.606 5.547l-.065-.305zm-1.805-4.59c-2.36-1.603-4.634-2.103-6.596-5.139 1.576 2.97 4.084 3.723 6.682 5.364l-.086-.224zm6.726 2.366c-.846 3.278-1.56 6.723-3.803 8.934l.021-.429c1.025-.574 2.645-3.988 3.782-8.505zm-2.73-5.506c-.153 3.387-.094 6.97-1.847 8.892l-.129-.387c1.787-1.447 1.638-5.276 1.977-8.505zm-2.406-3.855c.6 2.981.644 5.738-.15 10.198l-.172-.327c.498-2.627 1.063-5.318.322-9.871zm-3.61-2.366c1.199 2.529 2.116 5.088 1.333 7.832l-.215-.306c.928-2.509-.157-5.017-1.117-7.526zm-4.632 33.284c1.417 3.409-.456 5.884-2.67 7.318-1.723-4.953 1.868-4.398 2.67-7.318z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M273.266 216.686c.243 2.108-2.05 4.469-2.76 8.036l-.32.29c1.053-4.35 3.275-6.024 3.08-8.326z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M281.3 193.296a.35.458 1.848 1 1-.691-.124.35.458 1.848 0 1 .69.124z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M281.095 195.152c.03-.503-.024-1.058-.085-1.616-.048-.032-.082-.013-.11.028.06.65.088 1.238.033 1.8l.162-.212z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M280.339 192.94a.282.408 1.944 0 1-.537.267.282.408 1.944 0 1 .537-.267z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M280.7 194.51c-.116-.412-.307-.82-.504-1.229-.044 0-.064.033-.073.08.222.48.403.93.516 1.401l.06-.251z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M282.35 199.333a.458.35 80.536 0 1-.703.014.458.35 80.536 1 1 .702-.014z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M282.514 201.194c-.069-.5-.23-1.033-.4-1.57-.053-.021-.083.004-.102.05.187.625.33 1.198.385 1.758l.117-.238z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M281.185 199.71a.472.353 57.082 1 1-.489.524.472.353 57.082 0 1 .488-.524z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M282.45 201.146c-.358-.368-.801-.696-1.252-1.022-.051.02-.057.063-.042.116.518.387.972.763 1.357 1.192l-.064-.286z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M280.91 212.406a.35.458 12.73 1 1-.656-.252.35.458 12.73 0 1 .655.252z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M280.362 214.19c.124-.488.176-1.043.222-1.603-.042-.04-.079-.028-.114.007-.063.649-.147 1.233-.307 1.773l.199-.177z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M281.579 213.201a.35.458 50.478 0 0 .52.472.35.458 50.478 1 0-.52-.472z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M280.23 214.495c.38-.332.853-.628 1.333-.921.054.018.06.057.044.105-.55.348-1.034.686-1.444 1.073l.068-.257z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M278.094 218.572a.35.458 40.348 0 1-.464-.527.35.458 40.348 0 1 .464.527z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M276.78 219.902c.336-.375.64-.843.94-1.318-.018-.055-.057-.062-.105-.046-.356.545-.701 1.024-1.094 1.428l.258-.064z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M276.1 218.148a.475.59 10.023 0 0 .944.105.475.59 10.023 1 0-.945-.105z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M276.67 218.744c-.25.643-.072.893.076 1.173l-.156.329c-.221-.369-.305-.777-.11-1.544.093-.035.16-.01.19.042zm-12.92 10.008c-.71.06-1.065-.335-1.297-.767l-.38-.003c.402.535.827.958 1.637.95.072-.064.076-.133.04-.18z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M263.798 229.489a.619.452 9.459 0 1 .209-.881.619.452 9.459 1 1-.209.88z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M269.54 219.819c.537 3.288-1.38 5.96-4.273 6.788-.945-4.238 2.963-4.39 4.274-6.788z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M269.546 219.845c-1.062 2.58-2.498 4.98-5.072 7.627l-.554.072c2.865-2.266 4.437-5.21 5.626-7.699z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M264.32 227.522a.543.403 9.82 0 1-.428-.777.543.403 9.82 1 1 .428.777z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M262.305 228.046c.526-.167 1.036-.443 1.546-.728-.007-.063-.053-.092-.117-.105-.599.32-1.165.582-1.769.746l.34.087zm2.8-5.326c-.139 1.32-1.177 2.508-2.136 3.435-.957.926-1.064 1.274-2.415 1.674-1.298-2.955 3.043-3.54 4.55-5.109z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M265.092 222.689c-1.448 2.71-3.753 4.041-5.01 5.79l-.178-.016c1.8-2.373 3.33-2.824 5.188-5.774zm-29.975-35.469c-1.893 3.029-4.7 8.493-5.467 12.68-1.414 7.721.796 16.282 7.523 22.332 5.48 4.929 14.082 6.452 17.674 7.189 3.582.735 6.175 1.887 6.767 2.68.03-.558.111-1.116-.486-1.674-1.702-.75-4.463-1.193-8.312-1.987-7.734-1.594-15.86-4.494-20.287-12.934-5.773-11.006-2.333-19.655 2.667-28.241l-.079-.045z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M249.71 227.82c-.237.44-4.279 3.986-7.954 3.72-2.691-.194-3.136-.842-3.136-.842s-.251-.668 2.138-1.157c2.414-.493 6.599-2.142 8.952-1.722z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M238.752 230.714c2.89.327 5.833-.84 8.138-1.72",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M246.603 222.561c.31.054 3.628 1.753 4.905 3.984.935 1.633.783 2.024.783 2.024s-.237.28-1.397-1.04c-1.171-1.334-3.598-3.49-4.29-4.968z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M252.248 228.487c-.945-1.776-2.656-3.292-3.978-4.485",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M234.949 187.574c-.078-.327.316-3.656 2.185-4.71 1.368-.772 1.861-.551 1.861-.551s.409.295-.52 1.354c-.938 1.07-2.221 3.374-3.526 3.907z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M238.925 182.347c-1.52.762-2.42 2.386-3.139 3.639",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M234.007 189.266c-.167-.221-1.088-3.145-.248-5.047.615-1.392 1.013-1.49 1.013-1.49s.37.012.141 1.392c-.23 1.394-.248 3.982-.906 5.145z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M234.738 182.797c-.717 1.47-.726 3.292-.75 4.711",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M234 189.293c.234.004 2.896-.778 4.14-2.232.911-1.065.854-1.372.854-1.372s-.134-.238-1.166.567c-1.042.813-3.117 2.053-3.829 3.037z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M238.951 185.743c-.938 1.168-2.4 2.039-3.532 2.728",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M232.727 191.562c-.176-.22-1.39-3.32-.925-5.569.34-1.646.674-1.818.674-1.818s.324-.048.319 1.522c-.005 1.587.342 4.466-.068 5.865z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M232.456 184.255c-.419 1.748-.17 3.775.008 5.356",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M231.788 193.681c-.272-.185-2.431-3.113-2.22-5.571.155-1.8.564-2.062.564-2.062s.42-.13.694 1.507c.278 1.653 1.253 4.567.962 6.126z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M230.12 186.136c-.24 1.925.451 3.975.971 5.578",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M230.627 196.417c-.235-.156-2.334-2.74-2.574-5.023-.176-1.673.09-1.938.09-1.938s.293-.143.766 1.354c.477 1.512 1.684 4.15 1.718 5.607z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M228.148 189.539c.132 1.793.984 3.648 1.636 5.1",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M232.786 191.592c.276.065 3.403-.265 4.848-1.833 1.057-1.149.986-1.563.986-1.563s-.162-.342-1.366.437c-1.217.787-3.643 1.864-4.468 2.959z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M238.57 188.256c-1.088 1.275-2.798 2.03-4.123 2.633",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M231.773 193.696c.271.086 3.413-.018 4.968-1.479 1.137-1.069 1.096-1.487 1.096-1.487s-.137-.354-1.394.337c-1.27.697-3.768 1.597-4.67 2.63z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M237.783 190.786c-1.177 1.193-2.937 1.823-4.303 2.33",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M230.781 196.452c.294.08 3.652-.165 5.253-1.793 1.172-1.193 1.11-1.638 1.11-1.638s-.161-.373-1.477.42c-1.33.8-3.965 1.868-4.886 3.01z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M237.089 193.083c-1.21 1.327-3.066 2.075-4.506 2.675",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M231.29 195.211s-.305-.59-.309-1.137c-.004-.547.136-.83.136-.83l-.213-.132s-.107.587-.106.87c.001.282.01.353.01.353s-.383-.328-.466-.515c-.083-.186-.19-.464-.19-.464l-.187.084s.174.578.322.69c.515.396.828 1.187.828 1.187",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.968 192.326a.58.393 83.534 1 1 .13 1.152.58.393 83.534 1 1-.13-1.152z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.294 192.317a.393.58 19.29 1 1-.383 1.095.393.58 19.29 1 1 .383-1.095z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M231.175 195.15s.609-.267.957-.689c.349-.421.418-.73.418-.73l.249.033s-.288.522-.467.74c-.179.22-.23.269-.23.269s.504-.013.686-.105c.182-.092.44-.24.44-.24l.093.182s-.5.339-.686.334c-.649-.019-1.391.397-1.391.397",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.02 193.743a.393.58 45.57 1 0-.828.812.393.58 45.57 1 0 .828-.812z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.006 192.904a.393.58 19.818 1 0-.393 1.09.393.58 19.818 1 0 .393-1.09z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M229.808 199.329c-.254-.146-2.607-2.694-3.007-5.053-.293-1.726-.034-2.02-.034-2.02s.296-.168.886 1.357c.595 1.541 2.024 4.203 2.155 5.716z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M226.778 192.342c.255 1.855 1.264 3.727 2.036 5.194",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M229.971 199.353c.31.064 3.785-.411 5.343-2.21 1.14-1.316 1.045-1.775 1.045-1.775s-.191-.377-1.507.533c-1.33.92-3.999 2.203-4.88 3.452z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M236.306 195.435c-1.17 1.46-3.05 2.36-4.507 3.078",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M229.518 202.269c.304.005 3.751-.984 5.363-2.827 1.18-1.349 1.107-1.738 1.107-1.738s-.173-.301-1.51.718c-1.35 1.03-4.037 2.6-4.96 3.847z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M235.933 197.772c-1.216 1.48-3.109 2.583-4.577 3.456",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M229.42 202.269c-.355-.11-3.604-2.399-4.092-4.843-.357-1.79.02-2.15.02-2.15s.425-.234 1.21 1.286c.792 1.536 2.727 4.116 2.862 5.707z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M225.36 195.365c.3 1.933 1.666 3.748 2.712 5.172",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M229.52 205.943c.308-.052 3.612-1.705 4.899-3.88.942-1.593.795-1.976.795-1.976s-.232-.273-1.394 1.014c-1.174 1.3-3.6 3.401-4.3 4.842z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M235.171 200.167c-.954 1.733-2.663 3.21-3.986 4.372",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M229.359 206.066c-.358-.045-3.86-1.793-4.756-4.23-.656-1.783-.36-2.228-.36-2.228s.365-.323 1.38 1.1c1.027 1.438 3.327 3.738 3.736 5.358z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M224.27 199.698c.627 1.943 2.25 3.56 3.498 4.834",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M229.413 204.378s-.479-.544-.629-1.122c-.15-.578-.076-.914-.076-.914l-.261-.083s.043.65.12.948c.076.298.104.371.104.371s-.493-.245-.63-.42c-.138-.176-.325-.44-.325-.44l-.175.137s.338.565.524.646c.65.281 1.192 1.034 1.192 1.034",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.22 201.66a.632.43 69.444 1 1 .444 1.185.632.43 69.444 1 1-.444-1.184z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.62 201.302a.43.632 5.202 1 1-.115 1.26.43.632 5.202 1 1 .114-1.26z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M229.375 204.324s.574-.443.83-.982c.257-.54.25-.883.25-.883l.27-.032s-.165.63-.296.908a4.234 4.234 0 0 1-.173.345s.53-.148.699-.294c.168-.146.402-.37.402-.37l.146.168s-.439.49-.637.535c-.692.153-1.367.79-1.367.79",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.027 202.084a.43.632 31.485 1 0-.66 1.079.43.632 31.485 1 0 .66-1.079z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.713 201.457a.43.632 5.73 1 0-.127 1.258.43.632 5.73 1 0 .126-1.258z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M229.79 209.306c-.345-.058-4.045-1.91-5.487-4.347-1.055-1.784-.89-2.212-.89-2.212s.259-.307 1.56 1.135c1.316 1.456 4.033 3.81 4.818 5.424z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M223.46 202.837c1.069 1.94 2.984 3.594 4.465 4.896",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M230.028 209.243c.392-.05 4.228-1.964 5.21-4.631.718-1.953.394-2.44.394-2.44s-.399-.355-1.512 1.204c-1.125 1.574-3.643 4.093-4.092 5.867z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M235.602 202.27c-.687 2.128-2.464 3.898-3.83 5.293",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M231.028 212.53c.363-.092 3.918-2.384 4.84-5.086.676-1.978.38-2.414.38-2.414s-.366-.3-1.404 1.34c-1.049 1.656-3.39 4.387-3.816 6.16z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M236.22 205.128c-.647 2.145-2.3 4.065-3.571 5.574",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M230.76 212.532c-.44.023-5.029-1.31-6.637-4.04-1.177-2-.92-2.597-.92-2.597s.368-.469 1.9 1.018c1.546 1.503 4.81 3.763 5.656 5.619z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M223.257 205.996c1.177 2.197 3.478 3.783 5.256 5.04",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M234.828 219.404c.283-.191 2.767-3.28 2.966-5.937.147-1.945-.193-2.24-.193-2.24s-.369-.153-.889 1.603c-.525 1.774-1.903 4.884-1.884 6.574z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M237.598 211.322c-.087 2.083-1.06 4.271-1.803 5.983",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M234.615 219.328c-.456.14-5.653.021-8.106-2.274-1.795-1.68-1.69-2.344-1.69-2.344s.255-.564 2.28.514c2.046 1.088 6.11 2.478 7.516 4.104z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M224.902 214.797c1.85 1.878 4.714 2.851 6.934 3.634",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M232.705 216.621c-.404.022-5.04-1.097-7.264-3.42-1.628-1.702-1.546-2.214-1.546-2.214s.218-.401 2.041.862c1.842 1.276 5.488 3.191 6.77 4.772z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M223.97 211.074c1.682 1.87 4.25 3.215 6.242 4.28",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M232.96 216.482c.383-.14 3.806-2.98 4.197-5.952.286-2.176-.147-2.604-.147-2.604s-.48-.275-1.25 1.583c-.778 1.877-2.745 5.043-2.8 6.973z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M237.001 208.034c-.215 2.349-1.604 4.575-2.666 6.322",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M231.938 214.892s-.735-.344-1.148-.87c-.412-.526-.488-.904-.488-.904l-.304.032s.335.646.546.919c.212.272.274.334.274.334s-.616-.031-.835-.15c-.22-.118-.531-.306-.531-.306l-.118.22s.6.429.827.428c.793-.002 1.687.529 1.687.529",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.501 213.102a.708.48 45.889 1 1 .986 1.017.708.48 45.889 1 1-.986-1.017z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.777 212.105a.708.48 71.645 1 1 .446 1.344.708.48 71.645 1 1-.446-1.344z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M232.033 214.867s.39-.712.413-1.38c.022-.668-.14-1.018-.14-1.018l.265-.154s.111.72.101 1.065c-.01.345-.023.432-.023.432s.478-.39.586-.615c.107-.225.247-.56.247-.56l.225.107s-.23.7-.415.835c-.64.466-1.05 1.422-1.05 1.422",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.742 211.384a.48.708 7.93 1 0-.195 1.403.48.708 7.93 1 0 .195-1.403z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.124 211.33a.708.48 72.174 1 0 .434 1.348.708.48 72.174 1 0-.434-1.349z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M236.556 221.433c-.323.204-4.534 1.136-7.218-.255-1.966-1.018-2.089-1.582-2.089-1.582s.03-.51 1.992-.031c1.982.485 5.678.817 7.315 1.868z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M227.344 219.651c2.07 1.169 4.673 1.398 6.7 1.599",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M236.81 221.36c.228-.147 2.084-2.744 2.004-5.186-.058-1.788-.38-2.098-.38-2.098s-.334-.182-.617 1.39c-.287 1.589-1.184 4.324-1.006 5.893z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M238.44 214.164c.123 1.922-.512 3.846-.992 5.354",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M240.575 224.36c-.397.244-5.448 1.559-8.512.26-2.244-.95-2.345-1.548-2.345-1.548s.075-.553 2.356-.182c2.306.376 6.649.46 8.501 1.47z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 223.124c2.357 1.104 5.416 1.158 7.796 1.225",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M240.815 224.33c.217-.32 1.302-4.083 0-6.027-.952-1.424-1.514-1.399-1.514-1.399s-.514.143-.102 1.687c.417 1.56.62 4.6 1.616 5.739z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M239.353 216.972c1.1 1.478 1.238 3.62 1.368 5.282",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M238.23 222.558s-.62.486-1.287.1c-.667-.387-.91-.76-.91-.76l-.312.165s.636.55.979.75c.343.2.436.241.436.241s-.673.23-.959.197c-.285-.033-.699-.101-.699-.101l-.032.286s.807.122 1.069.105c.261-.017 1.632-.55 1.632-.55",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.095 222.65a.816.554 24.117 1 1 1.49.666.816.554 24.117 1 1-1.49-.667z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.028 221.042a.816.554 49.87 1 1 1.052 1.248.816.554 49.87 1 1-1.052-1.248z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M238.348 222.969s.524-.59.18-1.28c-.345-.689-.701-.954-.701-.954l.183-.302s.509.669.688 1.023c.179.355.214.45.214.45s.27-.656.256-.944a17.5 17.5 0 0 0-.058-.704l.287-.014s.072.813.039 1.073c-.033.26-.65 1.596-.65 1.596",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.635 218.814a.816.554 69.449 1 0 .573 1.529.816.554 69.449 1 0-.573-1.53zm-1.669.836a.816.554 43.692 1 0 1.18 1.129.816.554 43.692 1 0-1.18-1.128z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M243.529 225.978c-.278.373-4.5 3.125-7.88 2.455-2.475-.49-2.804-1.132-2.804-1.132s-.145-.636 2.14-.802c2.307-.167 6.413-1.178 8.544-.521z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M232.967 227.332c2.641.633 5.53-.084 7.787-.615",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M246.156 226.716s-.498.76-1.368.584c-.87-.176-1.272-.493-1.272-.493l-.28.295s.895.364 1.344.457c.448.092.565.102.565.102s-.65.499-.973.569c-.324.07-.8.147-.8.147l.07.324s.926-.165 1.205-.28c.279-.115 1.578-1.202 1.578-1.202",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.674 228.327a.94.638 5.412 1 1 1.872.178.94.638 5.412 1 1-1.872-.178zm.426-2.103a.94.638 31.167 1 1 1.61.973.94.638 31.167 1 1-1.61-.973z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M244.775 226.356c.193-.344.816-4.206-.958-5.949-1.298-1.276-1.926-1.174-1.926-1.174s-.556.21.153 1.678c.717 1.483 1.428 4.457 2.731 5.445z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M241.96 219.292c1.473 1.31 1.968 3.405 2.379 5.028",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M246.789 227.282s.233-.878-.478-1.409c-.711-.53-1.216-.619-1.216-.619l.033-.405s.87.424 1.237.696c.368.273.453.353.453.353s-.061-.816-.225-1.104a20.06 20.06 0 0 0-.424-.695l.288-.163s.494.8.595 1.084c.1.284.157 1.978.157 1.978",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.981 222.856a.94.638 42.736 1 0 1.381 1.276.94.638 42.736 1 0-1.381-1.276zm-1.283 1.724a.94.638 16.98 1 0 1.798.548.94.638 16.98 1 0-1.798-.549z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M255.045 222.92s-2.497 5.8-1.634 6.375c0 0 2.533-4.502 4.757-6.205 1.157-1.091 1.86.009 2.009-.95.148-.959-3.043-2.335-3.043-2.335l-2.044 2.876",
    fill: "#452c25"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M255.045 222.92s-2.497 5.8-1.634 6.375c0 0 2.533-4.502 4.757-6.206 1.157-1.09 1.86.01 2.009-.949.148-.96-3.043-2.335-3.043-2.335l-2.044 2.876",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.175
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M245.936 227.336s-3.63 6.319-2.678 6.393c.952.075 4.833-8.057 4.833-8.057l-1.323.227-.832 1.437z",
    fill: "#452c25"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M245.936 227.336s-3.63 6.319-2.678 6.393c.952.075 4.833-8.057 4.833-8.057l-1.323.227-.832 1.437z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M247.032 225.575s-3.793 6.217-2.844 6.317c.949.1 5.042-7.922 5.042-7.922l-1.329.19-.869 1.415z",
    fill: "#452c25"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M247.032 225.575s-3.793 6.217-2.844 6.317c.949.1 5.042-7.922 5.042-7.922l-1.329.19-.869 1.415z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M247.8 224.494s-4.32 5.847-3.383 6.034c.936.186 5.71-7.433 5.71-7.433l-1.339.069-.988 1.33z",
    fill: "#452c25"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M247.8 224.494s-4.32 5.847-3.383 6.034c.936.186 5.71-7.433 5.71-7.433l-1.339.069-.988 1.33z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M248.955 223.466s-5.058 5.193-4.155 5.508c.903.315 6.647-6.57 6.647-6.57l-1.336-.118-1.156 1.18z",
    fill: "#452c25"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M248.955 223.466s-5.058 5.193-4.155 5.508c.903.315 6.647-6.57 6.647-6.57l-1.336-.118-1.156 1.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M249.135 221.578s-4.414 5.774-3.48 5.976c.933.202 5.83-7.335 5.83-7.335l-1.34.046-1.01 1.313z",
    fill: "#452c25"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M249.135 221.578s-4.414 5.774-3.48 5.976c.933.202 5.83-7.335 5.83-7.335l-1.34.046-1.01 1.313z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M248.01 226.54s-4.32 5.847-3.383 6.034c.936.186 5.71-7.433 5.71-7.433l-1.34.069-.988 1.33z",
    fill: "#452c25"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M248.01 226.54s-4.32 5.847-3.383 6.034c.936.186 5.71-7.433 5.71-7.433l-1.34.069-.988 1.33z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 225.384s-2.529 4.76-2.24 4.957c.29.197 3.36-2.715 4.877-5.547 1.518-2.833-2.745.472-2.745.472",
    fill: "#452c25"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 225.384s-2.529 4.76-2.24 4.957c.29.197 3.36-2.715 4.877-5.547 1.518-2.833-2.745.472-2.745.472",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M250.71 224.912s-2.496 5.799-1.634 6.374c0 0 3.133-3.499 3.95-6.278.818-2.78 0-.192 0-.192l-.227-3.02-2.043 2.876",
    fill: "#452c25"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M250.71 224.912s-2.496 5.799-1.634 6.374c0 0 3.133-3.499 3.95-6.278.818-2.78 0-.192 0-.192l-.227-3.02-2.043 2.876",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.175
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M249.414 224.405s-5.058 5.193-4.155 5.507c.902.315 6.648-6.57 6.648-6.57l-1.337-.118-1.156 1.18z",
    fill: "#452c25"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M249.414 224.405s-5.058 5.193-4.155 5.507c.902.315 6.648-6.57 6.648-6.57l-1.337-.118-1.156 1.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M249.816 225.108s-5.058 5.194-4.155 5.508c.903.315 6.648-6.57 6.648-6.57l-1.337-.118-1.156 1.18z",
    fill: "#452c25"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M249.816 225.108s-5.058 5.194-4.155 5.508c.903.315 6.648-6.57 6.648-6.57l-1.337-.118-1.156 1.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M250.217 225.93s-5.057 5.192-4.155 5.507c.903.315 6.648-6.57 6.648-6.57l-1.336-.118-1.157 1.18z",
    fill: "#452c25"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M250.217 225.93s-5.057 5.192-4.155 5.507c.903.315 6.648-6.57 6.648-6.57l-1.336-.118-1.157 1.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M250.596 218.8s-3.758 4.8-3.216 5.626c.542.826 3.974-2.204 5.058-4.328 1.084-2.124-1.807-1.455-1.807-1.455",
    fill: "#452c25"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M250.596 218.8s-3.758 4.8-3.216 5.626c.542.826 3.974-2.204 5.058-4.328 1.084-2.124-1.807-1.455-1.807-1.455",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M250.475 223.898s-3.221 6.164-2.39 5.81c.831-.354 4.096-4.99 4.457-6.013.362-1.023.24-2.091.24-2.091l-2.493 1.534.214 1.194",
    fill: "#452c25"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M250.475 223.898s-3.221 6.164-2.39 5.81c.831-.354 4.096-4.99 4.457-6.013.362-1.023.24-2.091.24-2.091l-2.493 1.534.214 1.194",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M250.497 221.87s2.673-4.913-.019.926c-2.69 5.839-3.697 4.875-3.697 4.875-.208-.333 2.34-4.289 2.34-4.289s1.892-3.044 2.345-3.333",
    fill: "#452c25"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M250.497 221.87s2.673-4.913-.019.926c-2.69 5.839-3.697 4.875-3.697 4.875-.208-.333 2.34-4.289 2.34-4.289s1.892-3.044 2.345-3.333",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.121
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M253.363 221.218s2.973-4.88-.007.926c-2.98 5.807-4.142 4.825-4.142 4.825-.242-.336 2.603-4.259 2.603-4.259s2.11-3.019 2.623-3.302",
    fill: "#452c25"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M253.363 221.218s2.973-4.88-.007.926c-2.98 5.807-4.142 4.825-4.142 4.825-.242-.336 2.603-4.259 2.603-4.259s2.11-3.019 2.623-3.302",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.129
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M252.273 219.158s-3.758 4.8-3.216 5.626c.542.826 3.974-2.203 5.058-4.327 1.084-2.125-1.806-1.456-1.806-1.456",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M291.01 267.815a35.007 39.384 0 1 1-70.015 0 35.007 39.384 0 1 1 70.014 0z",
    fill: "#e8a30e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.945 267.813c0-18.296 12.873-32.338 28.052-32.338 15.18 0 28.052 14.042 28.052 32.338",
    style: {
      lineHeight: "normal",
      InkscapeFontSpecification: "Sans",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb",
      marker: "none"
    },
    fontWeight: 400,
    overflow: "visible",
    color: "#000",
    fontFamily: "Sans",
    fill: "none",
    stroke: "#390",
    strokeWidth: 0.875
  }), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M221.037 269.877c.955 20.791 16.243 37.319 34.961 37.319s34.003-16.528 34.958-37.319h-69.919z",
    fill: "#007934",
    stroke: "#eee",
    strokeWidth: 0.088
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M291.01 267.814a35.007 39.384 0 1 1-70.015 0 35.007 39.384 0 1 1 70.014 0z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.394
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 240.388c-.383 1.5.04 2.733.772 3.896.566.9.938 1.857.92 2.887a8.391 8.391 0 0 0-.74.47l-5.92-3.932 3.974 5.855a8.606 8.606 0 0 0-.208.303c-1.127-.508-2.185-.609-3.194-.414-1.425.276-2.636-.023-3.9-.776.79 1.331 1.966 1.905 3.307 2.209 1.038.236 1.977.65 2.693 1.393-.078.28-.142.563-.191.85l-6.97 1.414 6.954 1.33c.02.12.042.238.067.358-1.157.438-1.98 1.113-2.554 1.964-.814 1.203-1.875 1.848-3.301 2.21 1.499.383 2.731-.045 3.894-.777.899-.567 1.857-.94 2.887-.921.145.257.302.503.47.74l-3.93 5.926 5.858-3.982c.098.07.197.143.297.21-.507 1.127-.606 2.19-.41 3.199.275 1.426-.026 2.631-.779 3.895 1.331-.79 1.905-1.966 2.209-3.306.235-1.039.65-1.978 1.392-2.694.281.078.563.142.851.191l1.414 6.97 1.33-6.954c.119-.02.238-.042.358-.067.437 1.157 1.113 1.98 1.964 2.555 1.203.813 1.848 1.874 2.21 3.3.382-1.499-.045-2.73-.778-3.894-.567-.9-.935-1.856-.916-2.889.256-.144.5-.3.736-.468l5.925 3.93-3.976-5.86a8.6 8.6 0 0 0 .205-.295c1.127.509 2.19.606 3.199.411 1.425-.276 2.63.025 3.895.778-.79-1.33-1.964-1.9-3.305-2.204-1.037-.235-1.975-.657-2.69-1.4.078-.279.137-.561.186-.848l6.971-1.408-6.955-1.335a8.284 8.284 0 0 0-.067-.358c1.158-.438 1.979-1.113 2.554-1.965.813-1.203 1.877-1.843 3.303-2.204-1.499-.383-2.733.04-3.896.772-.9.568-1.856.936-2.889.916a8.39 8.39 0 0 0-.468-.736l3.932-5.92-5.862 3.972a8.596 8.596 0 0 0-.296-.205c.51-1.128.609-2.186.414-3.195-.276-1.425.023-2.636.776-3.9-1.331.79-1.9 1.965-2.204 3.305-.236 1.04-.657 1.981-1.403 2.697a8.481 8.481 0 0 0-.846-.193l-1.408-6.97-1.334 6.954c-.12.02-.24.042-.359.067-.437-1.157-1.113-1.979-1.964-2.554-1.203-.813-1.843-1.877-2.204-3.303z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.131
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: 330,
    width: 330,
    transform: "rotate(22.5 -488.474 805.044) scale(.15213)",
    fill: "#fcbf49",
    strokeWidth: 1.112
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    height: 330,
    width: 330,
    transform: "matrix(-.15213 0 0 .15213 270.886 248.204)",
    fill: "#fcbf49",
    strokeWidth: 1.112
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M262.237 252.484c-1.75-1.521-3.955-1.75-5.172-.608-.883 1.18-.805 2.571.228 4.031-.076 0-.228.076-.304.152-.767-1.46-.9-2.965-.38-4.335 1.673-1.37 3.955-1.522 5.628.76"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M259.499 252.028c-.989 0-1.217.228-1.673.608-.457.38-.685.305-.761.38-.076.077 0 .305.152.229.152-.076.456-.228.913-.609.456-.38.913-.38 1.369-.38 1.369 0 2.13 1.141 2.282 1.065.152-.076-.76-1.293-2.282-1.293"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M261.248 253.321c-.988-1.065-2.814-1.141-3.575.076h.305c.76-1.217 2.586-.685 2.738-.152v.152"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.685,
    cy: 253.245,
    cx: 259.347
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M257.673 253.397c.761.685 2.434.76 3.575-.076l-.532-.076c-.76.837-1.978.76-2.738.152v-.152"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M261.324 253.701c-1.293.99-2.586.913-3.346.457-.761-.457-.761-.609-.609-.609.152 0 .304.152.913.457.608.304 1.521.304 3.042-.305m-3.727 2.282a.456.456 0 1 1-.608.457c-.076.152-.38.608-.989.608h-.152l.152.228c.152 0 .609 0 .913-.228a.685.685 0 1 0 .684-1.065m.913 3.195c-.684-.457-.989-1.141-1.75-1.141-.151 0-.456.076-.76.228h-.152l.152.228c.304 0 .76-.38 1.293-.076.533.304.837.609 1.217.76m-.228 0c-1.521-.456-1.826-.151-2.282-.151h-.152l.152.304c.609 0 .913-.456 2.282-.152"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M258.51 259.178c-1.673-.152-1.14.836-2.51.836h-.152l.152.229c1.673 0 .913-.913 2.51-1.065m-8.748-6.694c1.75-1.521 3.956-1.75 5.173-.608.883 1.18.804 2.571-.229 4.031.076 0 .229.076.305.152.767-1.46.899-2.965.38-4.335-1.673-1.37-3.955-1.522-5.629.76"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5 252.028c.99 0 1.218.228 1.674.608.456.38.684.305.76.38.077.077 0 .305-.152.229-.152-.076-.456-.228-.912-.609-.457-.38-.913-.38-1.37-.38-1.369 0-2.13 1.141-2.281 1.065-.152-.076.76-1.293 2.282-1.293"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M250.751 253.321c.989-1.065 2.814-1.141 3.575.076h-.304c-.76-1.217-2.586-.685-2.738-.152v.152"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1 1)",
    r: 0.685,
    cy: 253.245,
    cx: -252.653
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M254.326 253.397c-.76.685-2.434.76-3.575-.076l.533-.076c.76.837 1.977.76 2.738.152v-.152"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M250.675 253.701c1.293.99 2.586.913 3.347.457.76-.457.76-.609.608-.609-.152 0-.304.152-.912.457-.609.304-1.522.304-3.043-.305m3.727 2.282a.456.456 0 1 0 .609.457c.076.152.38.608.988.608h.153l-.153.228c-.152 0-.608 0-.912-.228a.685.685 0 1 1-.685-1.065m-.913 3.195c.685-.457.99-1.141 1.75-1.141.152 0 .456.076.76.228h.153l-.153.228c-.304 0-.76-.38-1.293-.076-.532.304-.836.609-1.217.76m.229 0c1.52-.456 1.825-.151 2.281-.151h.153l-.153.304c-.608 0-.912-.456-2.281-.152"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M253.49 259.178c1.673-.152 1.14.836 2.51.836h.152l-.153.229c-1.673 0-.912-.913-2.51-1.065"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M259.431 275.652c1.71.217 3.497.164 5.042-.317 1.412-.492 2.952-.82 4.476-.664.007-.213.456-.363.205-.532-.558-.344-1.261-.308-1.952-.658-1.129-.524-1.793-1.417-2.918-2.054-.124-.05-.62-.341-.612-.614 2.369 3.41 7.965 1.668 12.757 1.292.44.122 1.598-.212 2.56-.508 1.16-.392 3.949-.083 4.666-.552.119-.042-1.18-.848-1.43-1.076-.666-.835-2.393-.726-3.252-1.627-1.346-1.51-3.43-1.959-5.12-3.214-.374-.225-1.14-.154-1.706-.286-.695-.587-.016-.568-5.327-4.944-4.808-1.98-4.524-3.482-7.51-4.633-1.058-.521-2.026-1.454-2.923-1.21-1.606.433-5.086 2.211-6.646 3.139-1.297.769-2.924 2.15-4.037 3.04-.293.232-3.678 3.102-7.513 5.209-3.835 2.106-9.386 4.992-9.863 5.03 8.655-.433-7.738 2.453 31.103 5.179z",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M238.195 265.683c2.192-1.19 10.579-5.781 13.18-9.01-.354.023.706 1.004.62 1.403.812-.029.394-.91 1.07-.945.52.018.9-.196 1.352-.357.523-.095.211.233.205.41-.709 1.302-2.22 2.056-3.447 3.053.141.118.283.235.205.409.435.064.954.081 1.264-.184.075-.054.08-.23.084-.343.441.185.275.525.121.752-.314.682-1.578.576-1.973 1.198-.46.669-.925 1.232-1.616 1.731.534-.44 1.145-.999 1.82-1.033 1.043-.078 1.44-.756 2.34-.952.972-.193 1.591-.984 2.36-1.594-.308.449-.922.83-.712 1.36a.62.62 0 0 0 .61.12c-.696.902-2.079 1.553-2.562 2.63-.44-.184-.743.145-1.045.192-.443.154-.32.85-.629 1.072-1.281.706-1.923 1.898-2.476 2.91-.077.11-1.062.656-1.439.757-.674.266-4.903 3.534-4.96 3.073-.365-2.2-4.639 1.771-14.179-1.655m32.585-.091c-.07-.088-.214-.134-.213-.176.157-.338-.506-.403-.495-.75 1.111.037 1.962 1.31 2.662.558.152-.17-.277-.436.386-.63.147-.032-.14-.174-.064-.26-.365-.013-.667.019-.892-.068-.288-.094-.44-.183-.801-.285-.362-.096-.504-.486.02-.6.97-.142 1.987.535 2.747.176.602-.28 1.197-.345 1.796-.541.294-.075 1.267.005.957.285-.225.166-.742.102-1.046.176-.524.151-.979.394-1.505.593.365-.03.278.394.729.283.672-.189 1.354-.425 2.095-.49-.068-.17.156-.295.161-.469l.219.007c-.348-.523.675-.272 1.062-.692-.003.084.061.087.142.131-.526.194-.31.544-.465.802-.075.082-.295.117-.227.251.285.22.297-.159.522-.067.217.05.515.144.662.107.364.012.743-.144.526-.457-.283-.263-.576-.489-.565-.831.001-.042-.07-.087-.214-.134.592.02 1.032.208 1.242.469.283.267.343.654.795.76.88.155.82-.274.835-.706.664.064 1.62.355 1.463.692-.072.251-.607.45-1.128.48-.365.024-.156.295-.376.33-.437-.015-.968.052-1.12.22-.154.254.048.773.333.955.43.226 1.333-.04 2.004.067.077-.382.536-.493.918-.744.446-.238-.203-.476-.57-.662-.289-.094-.067-.171.085-.382.227-.246.894-.013.974-.221.154-.253-.124-.648.173-.812.224-.16.515.144.426.357.292-.027.371-.198.673-.23.366-.03.584.272.426.357-.447.285-.828.484-.697.92-.007.216-.529.283-.307.465.427.314.417.615.56.962.133.39.95.502 1.694.358-.267-.738 1.426-.38 2.18-.571.063.002.067-.125.005-.169-.357-.222-.427-.31-.344-.612.001-.037-.132-.131-.213-.176 1.1.38 3.051.9 3.85 1.57-1.046.175-2.999-.297-4.046-.074-1.268.3-2.548.685-3.896.64-.592-.02-1.175-.292-1.767-.312m-11.964-.743c.145.042-.363-.054-.434-.1",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M257.248 276.425c2.068-.117 2.391 1.489 3.746.085 1.239.228 2.386-.187 2.403-.365 2.886.604 11.85-.226 11.258-.86-.924-1.056-2.427-1.454-3.611-2.36-.265-.167-.818-.257-1.225-.371-.679-.208-1.582-.05-2.16-.353-.93-.522-1.917-.975-2.741-1.631-.52-.372-.698-.964-1.268-1.415-.61-.451-1.489-.538-2.115-.814-.944-.378-1.463-1.29-2.339-1.951-.303-.241-.82-.221-1.172-.436-.753-.394-1.33-1.242-1.994-1.127-1.188.204-1.889 1.175-3.062 1.705-.976.44-1.427 1.256-2.274 1.783-.222.138-2.802 1.852-5.681 3.042-2.88 1.19-6.655 2.631-7.004 2.632 0 0 2.543 1.871 8.462 1.62l3.619 1.167 2.023-.356s5.039-.004 5.135.005z",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M245.075 271.83c1.33-.637 6.418-3.098 7.988-4.827-.217.014.434.537.384.75.495-.016.236-.487.648-.506.316.01.547-.105.822-.192.318-.051.13.125.127.219-.425.697-1.343 1.101-2.086 1.635.087.063.174.126.127.219.266.033.583.042.77-.1.045-.028.048-.123.05-.183.27.098.17.28.077.402-.188.364-.959.309-1.196.642-.277.358-.558.66-.977.927.324-.236.693-.535 1.105-.554.635-.043.873-.406 1.42-.51.592-.105.966-.528 1.43-.855-.184.24-.557.445-.426.728.044.031.217.19.402.132-.42.482-1.289.763-1.577 1.34-.27-.099-.453.077-.637.102-.269.083-.19.455-.377.574-.778.378-1.163 1.017-1.495 1.558-.046.059-.643.351-.873.406-.41.143-2.97 1.893-3.008 1.646-.233-1.175-2.72.56-8.553-1.265",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.131
  })), /*#__PURE__*/React.createElement("path", {
    overflow: "visible",
    fontWeight: 400,
    style: {
      lineHeight: "normal",
      InkscapeFontSpecification: "Sans",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb",
      marker: "none"
    },
    d: "M255.997 228.43c-19.334 0-35.007 17.632-35.007 39.383 0 21.75 15.673 39.383 35.007 39.383 19.334 0 35.007-17.633 35.007-39.383 0-21.751-15.673-39.383-35.007-39.383zm0 8.795c14.095 0 26.302 13.107 26.302 30.588 0 17.48-12.207 30.584-26.302 30.584-14.094 0-26.302-13.103-26.302-30.584s12.208-30.588 26.302-30.588z",
    color: "#000",
    fontFamily: "Sans",
    fill: "#00a6de",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M261.041 284.577c.004.215-.075.223-.478.277-.395.054-.47.055-.476-.149-.004-.215.084-.223.479-.277.373-.05.47-.077.475.15z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M261.126 284.565c.005.135-.252.168-.562.21-.31.04-.555.07-.56-.058-.007-.134.25-.167.562-.209.31-.042.554-.083.56.057zm-3.02 9.582c.85-2.27 1.072-3.985-.143-6.419 2.016-1.924 3.496-1.256 4.832.11-1.271 2.403-.939 4.116-.212 6.326-1.58.836-2.958.812-4.476-.017z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M260.335 286.532c-.042 0-.084.002-.126.005.14 2.76.022 5.498-.003 8.239.055.002.112.003.168.003-.01-2.758.15-5.428-.032-8.248h-.008z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M260.717 286.56c-.357 2.513-.49 5.052-.403 8.22l.148-.001c-.02-3.127.089-5.668.394-8.191a2.952 2.952 0 0 0-.139-.028zm.684-2.627c-.358.394-.556.39-.376 1.002.396-.27.385-.493.376-1.002z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M260.606 284.197c.234.246.576.375.358 1.04-.427-.37-.371-.407-.358-1.04z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M260.533 284.876c.31.225.593.272.381.852-.271-.325-.389-.297-.38-.852z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M260.448 285.238c.235.242.577.368.36 1.019-.426-.362-.37-.398-.36-1.02z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M260.312 285.765c.274.238.671.365.428.993-.474-.4-.24-.493-.428-.993z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M260.259 286.297c.257.23.662.365.432.972-.366-.335-.413-.388-.432-.972zm1.378-1.809c-.186.156-.616.14-.634.805.53-.305.525-.247.634-.805z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M261.609 284.96c-.199.144-.658.127-.673.749.565-.28.56-.226.673-.748z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M261.541 285.388c-.205.156-.68.137-.697.809.585-.304.578-.246.697-.81z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M261.506 285.975c-.216.08-.721-.079-.725.754.432-.115.402-.368.725-.754z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M261.266 286.483c-.302.126-.472.1-.527.77.436-.295.43-.24.527-.77zm.33.394c-.761 2.184-.922 4.252-.847 7.882a6.85 6.85 0 0 0 .186-.023c-.038-3.6.1-5.592.8-7.779a2.956 2.956 0 0 0-.138-.08zm1.244-2.406c-.435.308-.627.263-.581.896.446-.177.482-.398.58-.896z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M262.003 284.56c.179.29.487.486.133 1.088-.34-.45-.279-.475-.133-1.088z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M261.789 285.205c.256.284.524.39.193.91-.198-.374-.32-.372-.193-.91z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M261.63 285.54c.177.285.487.48.136 1.067-.342-.442-.28-.466-.137-1.068z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M261.382 286.022c.219.29.582.499.21 1.058-.38-.49-.13-.53-.21-1.058z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M261.217 286.53c.205.278.573.496.219 1.038-.288-.405-.323-.466-.219-1.038zm1.738-1.468c-.217.112-.635.005-.794.648.584-.183.567-.128.794-.648z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M262.826 285.516c-.225.098-.673-.018-.819.585.614-.152.596-.102.82-.585z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M262.67 285.917c-.236.108-.698-.01-.857.639.639-.17.62-.116.857-.639z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M262.51 286.481c-.23.032-.69-.23-.871.58.448-.02.472-.273.871-.58z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M262.166 286.924c-.322.058-.484-.002-.68.637.492-.193.474-.142.68-.637zm.145.46c-.99 1.985-1.2 3.803-.708 7.195a5.07 5.07 0 0 0 .218-.073c-.49-3.24-.297-5.053.612-7.016a3.48 3.48 0 0 0-.122-.107zm1.653-2.376c-.473.247-.658.178-.695.81.467-.118.533-.33.695-.81z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M263.12 284.986c.14.31.421.545-.008 1.093-.281-.488-.216-.505.009-1.093z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M262.824 285.597c.217.315.47.454.074.925-.147-.396-.269-.409-.074-.925z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M262.62 285.907c.143.306.424.54 0 1.074-.283-.482-.218-.497 0-1.074z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M262.314 286.353c.18.316.514.568.072 1.073-.315-.534-.061-.542-.072-1.073z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M262.084 286.833c.168.303.506.566.083 1.055-.233-.437-.26-.503-.083-1.055zm1.916-1.225c-.228.081-.63-.078-.871.537.604-.105.58-.054.871-.537z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M263.815 286.04c-.236.067-.667-.105-.89.471.63-.07.607-.022.89-.471z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M263.607 286.416c-.247.075-.692-.102-.933.52.656-.086.63-.034.933-.52z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M263.376 286.953c-.232.002-.656-.317-.942.46.449.038.506-.208.942-.46z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M262.976 287.346c-.328.016-.48-.064-.758.542.514-.128.49-.077.758-.542zm-3.174-.745c-.044.01-.09.024-.136.037.327 2.514.536 5.052.496 8.136.042.002.083.004.125.004.108-3.147-.112-5.67-.485-8.178zm-.687-2.72c.355.41.552.416.368 1.02-.394-.288-.382-.511-.368-1.02z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M259.908 284.18c-.237.237-.58.35-.367 1.025.429-.35.375-.39.367-1.025z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M259.975 284.863c-.312.21-.596.245-.388.835.275-.313.39-.28.388-.835z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M260.058 285.229c-.237.232-.58.342-.37 1.003.432-.342.376-.382.37-1.003z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M260.19 285.762c-.276.226-.674.335-.435.974.477-.378.243-.482.435-.974z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M260.239 286.297c-.26.218-.665.335-.44.953.368-.32.415-.37.44-.953zm-1.365-1.871c.185.163.615.169.628.833-.528-.33-.523-.271-.628-.833z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M258.898 284.9c.198.152.658.155.668.777-.564-.304-.557-.25-.668-.778z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M258.963 285.329c.204.165.68.169.692.841-.582-.33-.577-.273-.692-.841z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 285.918c.216.09.722-.046.72.787-.432-.135-.4-.387-.72-.787z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M259.23 286.437c.302.139.47.122.522.793-.435-.313-.43-.259-.521-.793zm-.267.515a4.03 4.03 0 0 0-.135.084c.705 2.168.965 4.174.903 7.693.054.01.11.017.163.023.1-3.56-.17-5.629-.93-7.8zm-1.292-2.597c.434.326.626.29.576.922-.445-.2-.481-.42-.576-.922z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M258.508 284.48c-.18.282-.49.465-.14 1.082.344-.434.282-.461.14-1.082z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M258.717 285.135c-.258.273-.527.367-.2.902.2-.365.322-.358.2-.902z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M258.875 285.477c-.18.278-.491.459-.146 1.061.346-.427.284-.453.146-1.061z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M259.117 285.97c-.22.281-.585.473-.217 1.048.383-.472.135-.523.217-1.047z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M259.278 286.486c-.205.27-.576.47-.226 1.028.29-.391.326-.45.226-1.028zm-1.724-1.545c.215.12.634.034.788.683-.584-.21-.567-.155-.788-.683z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M257.678 285.4c.224.107.673.012.814.621-.612-.18-.596-.128-.814-.621z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M257.83 285.808c.235.118.7.02.852.678-.636-.2-.619-.145-.851-.678z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M257.986 286.378c.23.043.693-.198.868.62-.449-.04-.47-.294-.868-.62z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M258.327 286.837c.321.073.483.02.675.668-.49-.216-.473-.162-.675-.668zm-.068.624l-.11.095c.897 2.013 1.042 3.738.75 6.945l.041.023.14.049c.333-3.254.17-5.014-.82-7.112zm-1.715-2.621c.47.269.657.207.688.843-.465-.14-.53-.356-.688-.843z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M257.388 284.856c-.142.304-.425.526 0 1.094.284-.476.22-.495 0-1.094z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M257.68 285.48c-.22.305-.475.434-.082.923.152-.39.272-.397.082-.923z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M257.88 285.8c-.144.3-.427.52-.007 1.074.287-.47.222-.488.007-1.074z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M258.184 286.26c-.183.307-.518.545-.08 1.07.319-.52.065-.54.08-1.07z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M258.41 286.75c-.17.295-.51.542-.091 1.052.236-.427.263-.491.09-1.052zm-1.907-1.312c.228.092.632-.048.867.577-.604-.133-.578-.08-.867-.577z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M256.685 285.878c.237.078.668-.075.886.513-.63-.1-.605-.05-.886-.513z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M256.89 286.263c.246.088.692-.07.93.564-.657-.116-.63-.063-.93-.564z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M257.117 286.811c.233.012.66-.287.938.503-.448.018-.504-.23-.938-.503z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M257.513 287.222c.329.032.481-.041.756.577-.514-.15-.49-.1-.756-.577zm2.324-3.383c.333.43.529.445.311 1.037-.377-.309-.352-.531-.31-1.037z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M260.613 284.183c-.249.222-.599.314-.423.999.449-.324.396-.367.423-1z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M260.643 284.866c-.323.193-.61.212-.434.811.29-.297.405-.256.434-.81z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M260.704 285.236c-.25.218-.598.309-.423.98.448-.317.396-.36.423-.98z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M260.808 285.775c-.29.21-.694.296-.49.946.498-.35.27-.467.49-.946z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M260.826 286.312c-.271.202-.683.297-.493.924.385-.298.437-.345.493-.924zm-1.26-1.943c.177.173.605.201.582.866-.51-.358-.507-.3-.582-.866z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M259.564 284.842c.19.163.649.192.625.813-.546-.336-.543-.281-.625-.813z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M259.605 285.274c.195.176.67.206.645.878-.564-.363-.563-.304-.645-.878z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M259.602 285.863c.212.102.725-.005.677.826-.424-.16-.378-.408-.677-.826z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M259.81 286.394c.294.157.464.149.477.82-.417-.337-.414-.282-.477-.82zm-.4.335c-.05.02-.098.042-.148.065.624 2.552.77 4.908.716 7.968a.934.934 0 0 1 .053.004l.071-.013c.09-2.73 0-5.399-.692-8.024zm-1.066-2.549c.412.354.607.33.516.957-.432-.227-.452-.45-.516-.957z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M259.171 284.359c-.197.27-.519.433-.21 1.07.372-.41.313-.442.21-1.07z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M259.34 285.026c-.275.256-.551.332-.258.886.223-.352.343-.336.258-.886z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M259.475 285.377c-.198.265-.52.425-.213 1.049.373-.404.312-.434.213-1.049z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M259.686 285.885c-.24.266-.615.433-.285 1.03.415-.446.169-.515.285-1.03z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M259.814 286.408c-.224.255-.606.432-.291 1.01.314-.371.354-.428.291-1.01zm-1.625-1.65c.207.134.63.074.743.73-.569-.246-.555-.189-.743-.73z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M258.284 285.222c.217.122.671.056.774.673-.602-.219-.588-.166-.774-.673z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M258.412 285.639c.226.134.694.066.807.73-.625-.24-.61-.183-.807-.73z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M258.53 286.219c.226.057.705-.154.828.672-.446-.069-.453-.323-.829-.672z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M258.84 286.697c.318.093.483.052.633.71-.476-.247-.463-.194-.633-.71zm-.82.978a2.787 2.787 0 0 0-.057.053c.74 1.483.947 2.698.804 3.935v.002c-.027.81-.15 1.681-.357 2.638l.157.071.03.009c.582-2.738.527-4.761-.577-6.708z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M258.648 287.158a4.055 4.055 0 0 0-.139.101c.846 2.262.962 4.347.84 7.388l.113.03a.41.41 0 0 0 .048.01c.161-3.094.057-5.257-.862-7.53zm-1.53-2.563c.46.289.648.236.652.87-.46-.16-.513-.377-.651-.87z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M257.96 284.648c-.153.297-.447.508-.045 1.093.305-.463.24-.485.046-1.093z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M258.227 285.285c-.234.294-.493.41-.123.916.169-.381.289-.384.123-.916z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M258.412 285.611c-.157.293-.45.501-.054 1.073.308-.456.244-.478.054-1.073z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M258.696 286.085c-.196.298-.542.52-.127 1.064.341-.504.089-.536.127-1.064z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M258.9 286.584c-.183.286-.533.519-.137 1.046.256-.417.285-.479.137-1.046zm-1.849-1.393c.225.102.634-.021.842.613-.597-.16-.576-.105-.842-.613z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M257.215 285.638c.232.087.67-.046.863.55-.625-.127-.604-.077-.863-.55z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M257.403 286.031c.241.099.695-.04.905.604-.651-.146-.628-.091-.905-.604z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M257.605 286.589c.233.022.672-.259.916.542-.45-.002-.493-.253-.916-.542z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M257.984 287.016c.327.046.482-.02.73.608-.507-.173-.486-.121-.73-.608zm-2.029-1.75c.502.206.676.122.79.749-.479-.08-.57-.285-.79-.749z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M256.792 285.173c-.102.321-.353.579.142 1.088.22-.51.152-.521-.142-1.088z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M257.162 285.756c-.18.331-.413.492.038.927.098-.406.217-.43-.038-.927z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M257.4 286.048c-.103.316-.354.572.132 1.068.223-.504.157-.514-.132-1.068z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M257.76 286.465c-.14.33-.441.61.059 1.074.248-.558-.004-.545-.058-1.074z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M258.047 286.924c-.13.315-.434.605.046 1.056.178-.454.197-.521-.046-1.056zm-2.055-1.058c.238.062.619-.13.932.461-.615-.054-.582-.004-.932-.461z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M256.23 286.28c.243.047.65-.161.941.394-.635-.017-.605.03-.941-.394z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M256.481 286.637c.255.055.677-.16.993.44-.665-.031-.632.018-.993-.44z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M256.777 287.152c.231-.018.615-.37.993.378-.442.076-.528-.164-.993-.378z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M257.221 287.51c.329-.012.47-.105.822.475-.527-.083-.497-.036-.822-.476zm4.04-.795c-.72 2.613-.821 5.315-.75 8.061.055-.002.11-.005.166-.01-.03-3.09.091-5.441.733-7.985-.05-.023-.1-.046-.15-.066zm1.065-2.445c-.415.336-.608.303-.523.934.434-.207.457-.43.523-.934z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M261.498 284.412c.196.279.516.455.201 1.079-.369-.427-.308-.456-.201-1.08z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M261.325 285.071c.274.268.549.356.251.897-.221-.36-.341-.351-.25-.897z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M261.187 285.415c.196.274.518.45.206 1.059-.37-.421-.31-.448-.206-1.059z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M260.972 285.914c.237.276.613.46.277 1.043-.41-.465-.164-.522-.277-1.043z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M260.841 286.431c.22.266.603.46.284 1.024-.312-.386-.351-.445-.284-1.024zm1.637-1.577c-.208.125-.631.046-.749.698.572-.221.557-.165.749-.698z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M262.379 285.316c-.218.111-.672.025-.778.636.602-.192.587-.139.778-.636z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25 285.727c-.228.121-.697.032-.814.693.625-.212.61-.157.813-.693z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M262.126 286.3c-.227.047-.704-.186-.832.635.446-.05.454-.302.832-.635z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M261.812 286.764c-.318.08-.483.03-.638.68.478-.224.465-.171.638-.68zm.2.382c-.99 2.24-1.122 4.407-.891 7.557.074-.015.149-.032.223-.05-.255-3.187-.128-5.226.79-7.415a4.408 4.408 0 0 0-.121-.093zm1.537-2.406c-.462.269-.648.207-.658.842.46-.14.516-.355.658-.842z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M262.706 284.756c.153.304.445.527.04 1.094-.302-.476-.239-.496-.04-1.094z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M262.437 285.38c.231.305.49.433.115.922-.165-.39-.287-.397-.115-.922z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M262.248 285.7c.154.298.446.519.046 1.073-.304-.47-.24-.488-.046-1.074z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M261.961 286.158c.194.308.538.546.12 1.07-.338-.52-.086-.54-.12-1.07z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M261.753 286.65c.18.294.529.542.129 1.05-.252-.427-.281-.49-.129-1.05zm1.858-1.311c-.224.092-.632-.05-.846.575.599-.132.576-.079.846-.575z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M263.445 285.78c-.232.076-.669-.078-.867.51.627-.099.604-.05.867-.51z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M263.255 286.164c-.244.086-.695-.07-.91.562.653-.115.629-.063.91-.562z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M263.048 286.712c-.233.012-.67-.289-.92.501.45.018.496-.23.92-.501z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M262.667 287.123c-.327.03-.484-.043-.734.575.507-.15.485-.1.734-.575zm.016.601c-1.157 2.03-1.058 4.188-.581 6.67.06-.025.118-.052.178-.079-.204-1.073-.335-2.057-.33-2.99v-.004c-.06-1.084.157-2.182.847-3.482a11.75 11.75 0 0 0-.114-.114zm2.024-2.26c-.503.184-.677.092-.794.713.478-.057.571-.26.794-.712z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M263.872 285.334c.099.325.347.593-.151 1.08-.215-.52-.149-.528.151-1.08z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M263.498 285.9c.175.338.41.51-.046.924-.096-.41-.214-.439.046-.924z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M263.256 286.18c.101.321.351.587-.14 1.063-.22-.514-.152-.522.14-1.063z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M262.894 286.581c.138.336.436.63-.068 1.07-.243-.567.01-.543.068-1.07z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M262.603 287.027c.127.32.43.625-.054 1.054-.175-.462-.193-.53.054-1.054zm2.064-.964c-.238.05-.618-.158-.937.418.615-.026.584.022.937-.418z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M264.426 286.465c-.243.036-.649-.19-.946.353.637.01.606.056.946-.353z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M264.17 286.811c-.255.043-.674-.19-.995.395.665-.001.632.047.996-.395z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M263.872 287.312c-.231-.028-.612-.398-.996.334.44.096.53-.141.996-.334z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M263.423 287.65c-.328-.027-.468-.126-.824.438.529-.06.499-.014.824-.438zm-3.72 2.919l1.215.027c.735.016 1.326.184 1.325.377 0 .192-.592.333-1.327.317l-1.215-.028c-.735-.016-1.326-.184-1.324-.377 0-.191.592-.334 1.327-.316z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M258.862 290.549l-.364.611a.333.333 0 0 0 .208.08l.22.004.407-.684-.471-.011zm.946.022l-.407.685.47.01.408-.685-.471-.01zm.947.02l-.408.686.47.01.408-.684-.47-.011zm.946.023l-.408.684.471.011.358-.602a.338.338 0 0 0-.219-.09l-.202-.003z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.044
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M252.303 286.729c.009-.002.278 1.902.493 2.829.027.113.161.175.2.286.04.119.011.25.02.374 0 .014.004.028.003.042-.01.172-.138.332-.096.502.025.097.142.144.185.234.253.525.261 1.16.401 1.697.06.227-.042-.043.39.593.043.064.21.067.21.067l.166.006.168.167-.215.234-.715.093-.341-.212s.086-.19.018-.28c-.049-.065-.2-.017-.214-.097-.026-.148-.074-.55-.08-.55-.012 0-.009-.026-.016-.037 0 0-.578-.63-.791-1.002-.11-.192-.124-.433-.244-.619-.076-.119-.23-.174-.293-.301-.529-1.056-1.14-3.102-1.14-3.09m-6.809-1.193l1.903.447-.515 2.784c-.327.884-.295.915-.188 1.162.22.476.39 1.191 1.161 2.315.27.284.556.31.66.426.051.124.279.306.47.379l.598-.016c.098-.145.1-.098.125-.206-.044-.13-.328-.077-.528-.251-.107-.337-.552-.847-.616-1.202-.246-.774-.178-.799-.124-1.592.025-.408.35-1.316.47-1.809.277-.53.552-1.447.506-2.104l-.823-1.814-.48-.735m-1.796-1.16c-3.036.98-1.741 3.775-.88 3.806m9.81-8.652l.447-1.017.03-.372-.043-.077-.806.981-.01.064",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M255.126 279.888c.194.073.44.144.483.029.053-.143.077-.244-.072-.355-.072-.062.037-.162-.047-.343-.533-.373-.899-.382-1.03-.68l-.02-.205c-.028-.26-.794-.368-.98-.495 0 0-.323-.16-.494-.198-.073-.015-.222-.009-.222-.009-.777-.007-1.134.81-1.263 1.308 0 0-.153 2.267-.531 3.293a.755.755 0 0 1-.155.25c-.064.068-.132.17-.226.164-2.154-.148-3.62-.245-4.495-.213s-1.874.71-1.936.784c0 0-.973.639-1.187 1.68-.07.348.015.759.151 1.168.969 2.75 1.923-.01 2.27.022l.427.04c.502.047 1.424 1.588 2.833 1.896 4.25.93 5.416-1.294 5.325-6.235l.051-.07-.013-.17.216-.393-.04-.546-.077-.26.008-.1 1.198-.155.206-.096",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M253.063 278.487l.513-1.165.033-.425-.05-.089-.92 1.124-.012.073m-9.525 8.06c.272.816.762 1.627.728 1.927-.053.451-.305.659-.324.701-.018.04-.112.097-.142.125-.13.122-.217.368-.276.544-.073.218-.114.412-.09.625.09.79.544 2.414.567 2.438 0 0 .258.152.331.302.075.152.05.3.041.467-.013.229-.142.74-.142.74s.01.099.039.128c.081.082.356.225.356.225l.575-.016s-.32-.324-.345-.397a.381.381 0 0 1-.018-.235c.041-.17.203-.37.256-.472.058-.109-.005-.393-.005-.393-.006-.104-.09-.152-.095-.196a8.802 8.802 0 0 1-.084-.928c-.013-.3.038-1.199.038-1.199s.136-.116.19-.188c.05-.066.119-.22.119-.22s.696-.4.995-.67c.354-.318.928-1.103.928-1.103s.165-.319.19-.498a.559.559 0 0 0-.015-.187 4.068 4.068 0 0 0-.354-.964 3.42 3.42 0 0 0-.554-.822.516.516 0 0 0-.08-.058m6.335 1.986c-.57.378-1.921.689-1.943.962 0 0-.04 1.712-.235 2.395-.076.269-.204.348-.304.607-.103.27-.097.476-.187.745-.096.287-.269.545-.294 1.043l.014.414.415.246-.43.146-.672-.268-.055-.63.147-.654.007-.105-.166-.396-.108-1.422.114-1.06-.148-3.903m4.988-5.701c.27.217.626.358 1.438.094.155.1.32.224.667-.255m-.367-.56c.005-.006.157.104.213.104.044 0 .098-.089.063-.118-.04-.032-.112-.069-.146-.045-.05.035-.128.068-.13.059z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M253.63 278.843s.077.002.105.066c.096.216.33.253.516.025a.354.354 0 0 1 .088-.07c-.038-.002-.063.001-.093-.029-.206-.206-.42-.032-.491-.017-.047.01-.08.018-.125.025z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M265.741 291.1l.001.006a2.037 2.037 0 0 0-.015.794 2.076 2.076 0 0 0-.015.8 2.076 2.076 0 0 0-.013.762 2.14 2.14 0 0 0-.011.722c.263.201 1.009.225 1.342.042.04-.229.04-.505-.002-.757a2.076 2.076 0 0 0-.003-.762 2.07 2.07 0 0 0-.004-.8 2.038 2.038 0 0 0-.005-.794 2.391 2.391 0 0 0-.006-.827 2.234 2.234 0 0 0-.006-.796 2.362 2.362 0 0 0-.007-.827l.001-.007c.038-.245.04-.521-.006-.834a2.524 2.524 0 0 0-.007-.844 2.57 2.57 0 0 0-.006-.834 2.329 2.329 0 0 0-.006-.835c.07-.26.042-.586-.008-.843v-.003a2.69 2.69 0 0 0-.003-.832 2.486 2.486 0 0 0-.006-.834c.033-.276.03-.556-.006-.844.035-.275.03-.544-.01-.833a3.126 3.126 0 0 0-.008-.833c.038-.265.05-.547 0-.846.038-.272.034-.55-.01-.836.038-.258.04-.534-.01-.833a2.44 2.44 0 0 0-.01-.817c.036-.277.034-.48.002-.756a2.12 2.12 0 0 0-.01-.328l-.841-.012c-.036.058-.046.174-.023.331-.042.12-.04.64.009.76a2.459 2.459 0 0 0-.02.818 2.67 2.67 0 0 0-.02.833 2.856 2.856 0 0 0-.021.835c-.053.3-.045.58-.01.846a3.11 3.11 0 0 0-.02.833 3.095 3.095 0 0 0-.02.833 3.46 3.46 0 0 0-.018.844 2.486 2.486 0 0 0-.017.834 2.636 2.636 0 0 0-.014.831c-.053.258-.085.585-.02.847a2.36 2.36 0 0 0-.016.834 2.599 2.599 0 0 0-.017.834c-.05.27-.06.546-.017.844a2.79 2.79 0 0 0-.016.841c-.055.308-.06.583-.017.826a2.227 2.227 0 0 0-.017.797 2.396 2.396 0 0 0-.017.82z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M265.732 291.89c.31.144 1.103.12 1.289.024m-1.296-.82c.296.125 1.004.119 1.29.023m-1.25-.858c.286.144.967.107 1.245.024m-1.229-.815c.317.144 1.008.104 1.223.021m-1.207-.837c.34.097.938.093 1.2.004m-1.184-.839c.35.084.899.087 1.179.004m-1.163-.85c.32.082.938.087 1.156.007m-1.14-.835c.278.089.865.081 1.134 0m-1.11-.837c.355.086.847.093 1.104.003m-1.088-.85c.361.085.874.075 1.082.005m-1.07-.838c.358.08.919.051 1.064.004m-1.043-.817c.333.06.895.029 1.037-.017m-1.02-.846c.328.088.872.047 1.014.002m-.992-.817c.312.08.803.047.986-.018m-.96-.832c.306.067.819.042.954-.002m-.942-.837c.306.063.803.036.935-.007m-.906-.825c.333.04.758.037.884-.004m-.864-.848c.276.058.736.053.858.014m-.84-.83c.301.047.717.044.837.005m-.87-.762c.226.023.78.038.873.009m-1.185 16.483c.315.144 1.119.119 1.308.023m-1.323.736c.32.144 1.134.119 1.326.023",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinejoin: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M268.277 274.21c.509-.11 1.241-.126 2.252-.153a14.585 14.585 0 0 0-.92-.273c.591-.081 1.997-.063 2.358-.066-.244-.15-.85-.389-1.011-.421.773-.128 1.697-.006 2.347.098-.304-.17-.647-.39-1.082-.508.928-.063 1.296.011 2.158.127a2.791 2.791 0 0 0-.941-.516c1.031-.189 1.61-.229 2.62-.148-2.92-1.336-6.463-.64-8.596.83.214-.336.675-.845 1.125-1.229a2.692 2.692 0 0 0-.739.041c.312-.342.9-.8 1.298-.958-.29-.015-.536-.022-.797.03.391-.364.982-.748 1.483-1.003a3.318 3.318 0 0 0-.897.02c.396-.465 1.087-.942 1.698-1.232a4.182 4.182 0 0 0-.998.077c.508-.463 1.188-.95 2.082-1.4-3.543.396-5.498 2.95-5.665 5.113-.944-2.035-3.515-3.982-7.055-3.834 1.057.323 1.896.715 2.55 1.112a4.638 4.638 0 0 0-1.073.081c.718.202 1.568.583 2.103 1a3.583 3.583 0 0 0-.952.123c.594.183 1.314.485 1.818.798-.288-.012-.546.034-.849.097.46.099 1.196.477 1.612.78a2.913 2.913 0 0 0-.79.078c1.066.415 1.134.602 1.369.743-2.21-.472-5.403.257-7.858 3.11.356-.3 1.877-.867 2.36-.997-.252.302-.34.46-.538.838.552-.446 1.385-.815 2.18-1.131a5.06 5.06 0 0 0-.432.794c.579-.359.755-.41 1.94-.974-.085.145-.321.46-.434.758.362-.206 1.223-.52 1.806-.73.04-.015-.351.32-.528.721.133-.05.943-.343.973-.351-1.868 1.304-3.26 3.493-2.979 6.155.108-.416.602-1.611.881-2.089-.03.317.042.843.1 1.078a9.068 9.068 0 0 1 1.028-2.118c-.037.425-.027.894.031 1.087.252-.588.45-1.093 1.068-2.182-.04.163-.048.622-.01 1.027a14.19 14.19 0 0 1 1.142-1.984c-.022.24-.066.647-.048.816.05-.086.196-.327.366-.596.266-.419.59-.907.695-.985.08.082.158.182.23.298.29.466.499 1.179.564 1.917a3.35 3.35 0 0 0 .241-.927c.332.742.705 1.901.732 2.54.112-.339.17-.55.21-1.081.345.554.645 1.92.673 2.513.135-.232.246-.522.327-.955.338.763.471 1.713.553 2.369.868-3.158-.377-5.199-1.895-6.756.381.207.864.632 1.336 1.144a5.202 5.202 0 0 0-.28-.932c.56.399 1.387 1.22 1.618 1.458-.04-.312-.085-.478-.25-.876.662.459 1.254 1.245 1.589 1.678-.027-.2-.08-.575-.218-1.005.604.451 1.205 1.358 1.48 1.87-.008-.35-.106-.72-.188-1.1.822.695 1.126 1.43 1.386 1.875.007-2.851-3.293-5.416-6.359-5.683z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#e7e7e7",
    strokeWidth: 0.131
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M267.007 274.24c3.343-.478 7.637 2.401 7.63 5.654-.26-.445-.565-1.18-1.387-1.876.082.381.18.751.187 1.1-.274-.51-.875-1.418-1.48-1.87.138.431.192.806.219 1.006-.336-.433-.927-1.22-1.59-1.678.166.399.21.564.25.876-.23-.237-1.057-1.06-1.618-1.458.107.24.238.694.281.932-.472-.512-.955-.937-1.337-1.144m-1.904-1.582c-2.001-1.29-6.248-1.055-9.33 2.527.355-.3 1.876-.866 2.359-.997-.252.302-.34.46-.538.838.552-.446 1.385-.814 2.18-1.131a5.1 5.1 0 0 0-.432.794c.578-.359.755-.41 1.94-.974-.086.145-.322.46-.434.758.362-.206 1.222-.52 1.806-.73.04-.015-.351.32-.528.721.133-.05.943-.343.973-.351",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M266.392 273.692c-.425-2.353-3.243-5.06-7.395-4.887 1.057.323 1.896.715 2.55 1.112a4.625 4.625 0 0 0-1.073.081c.718.202 1.567.583 2.103 1a3.584 3.584 0 0 0-.952.123c.594.183 1.313.485 1.818.798-.288-.012-.546.034-.849.097.46.1 1.196.477 1.612.78a2.92 2.92 0 0 0-.79.078c1.065.415 1.134.602 1.369.744m1.578 1.002c-2.782.85-5.47 3.586-5.088 7.19.108-.416.602-1.611.881-2.089-.03.317.041.843.1 1.077a9.08 9.08 0 0 1 1.028-2.117c-.037.425-.027.894.031 1.087.252-.588.45-1.093 1.068-2.182-.04.163-.048.621-.01 1.027a14.13 14.13 0 0 1 1.142-1.984c-.023.24-.066.647-.048.816.126-.22.887-1.453 1.06-1.581m-1.73.174a9.328 9.328 0 0 0-.414 1.548m-.603-.853c-.189.49-.422 1.38-.497 1.948m-.525-.974a9.507 9.507 0 0 0-.602 2.014",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str2",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.131,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M266.527 275.864l.011-.643"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M269.408 278.666c.085.508.127.775.096 1.503m-1.154-3.258c.11.566.156.942.154 1.7m-1.139-2.838c.122.35.197.8.198 1.38m5.064-.422a3.69 3.69 0 0 1 .623 1.287m-2.127-2.332c.364.428.718 1.189.834 1.563m-2.097-1.986c.313.407.526.839.727 1.313m-11.3-.846a4.968 4.968 0 0 1 1.845-1.275m-.203.982c.414-.524.626-.853 1.711-1.326m-.203 1.146c.342-.437.89-.931 1.722-1.227m-.35 1.254c.542-.494 1.042-.758 1.708-1.04m-3.97-4.327c.716.079 1.704.327 2.308.726m-1.278.355c.651.011 1.54.206 1.998.454m-1.132.467c.645.012 1.452.277 2.112.656m-1.349.222c.863.076 1.455.39 1.84.625m.897.153c2.037-1.731 5.944-2.676 9.115-1.225-1.01-.081-1.589-.041-2.62.148.423.12.823.41.94.516-.86-.116-1.229-.19-2.157-.127.435.118.778.338 1.081.508-.65-.104-1.573-.226-2.346-.098.16.032.766.271 1.01.42-.36.004-1.766-.014-2.356.067.405.108.675.192.919.273-1.011.027-1.743.042-2.252.154m5.16-1.713c-.627-.254-1.724-.37-2.287-.333m1.07.722c-1.11-.368-2.164-.348-2.694-.268m1.43.678c-.977-.275-2.122-.282-2.652-.202m1.306.69c-.94-.227-1.613-.196-2.143-.115m.891 1.141c.385.326.66.708.86 1.183",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M266.052 272.639c.167-2.163 2.122-4.717 5.664-5.114-.893.452-1.573.938-2.081 1.401.355-.07.6-.083.998-.077-.61.29-1.302.767-1.698 1.232.295-.053.6-.048.897-.02-.501.255-1.092.64-1.483 1.003.261-.052.507-.046.797-.03-.398.158-.986.615-1.298.958a2.69 2.69 0 0 1 .738-.04c-.45.383-.91.892-1.124 1.227m2.173-4.253c-.518.143-1.174.415-1.65.758m.95.397a4.825 4.825 0 0 0-1.493.549m.907.434c-.508.09-1.086.374-1.568.74m1.067.188a3.43 3.43 0 0 0-1.542.845m-.482 2.555a6.423 6.423 0 0 0-.309 1.237m1.248-2.144c1.972 1.723 4.425 3.942 3.295 8.053-.082-.656-.215-1.606-.553-2.37-.081.434-.193.724-.327.956-.028-.593-.328-1.958-.674-2.513-.04.531-.098.742-.21 1.082-.026-.64-.4-1.8-.73-2.54a3.4 3.4 0 0 1-.242.926c-.081-.92-.385-1.802-.795-2.215",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.516 249.077l1.344.73.327-.601c.167-.308.217-.55.15-.726-.065-.178-.244-.346-.537-.505-.323-.176-.581-.241-.774-.197-.195.043-.355.18-.48.41-.162.298-.241.504-.237.616.005.11.074.2.207.273m1.754.952l1.727.938c.133.072.251.077.355.017.106-.062.23-.225.372-.488.136-.25.226-.461.27-.632.043-.174.037-.318-.018-.432a.761.761 0 0 0-.193-.27 2.01 2.01 0 0 0-.356-.233c-.806-.437-1.396-.309-1.77.386l-.387.714m-2.772-.824c.098-.18.222-.418.372-.712.15-.295.244-.477.282-.547.184-.338.38-.61.59-.818.209-.21.41-.346.605-.406.192-.061.368-.087.528-.078.16.01.312.053.455.13.2.11.352.294.457.555.106.259.152.523.138.794.307-.31.636-.518.987-.626a1.3 1.3 0 0 1 1.04.117c.38.207.621.563.723 1.069.099.504-.043 1.108-.425 1.811-.13.24-.271.492-.423.753-.15.259-.273.476-.368.651l-.332.666-.027-.005a12.05 12.05 0 0 0-1.488-.93l-1.882-1.021a12.32 12.32 0 0 0-1.59-.742l-.015-.028c.153-.247.278-.458.373-.633m9.473-11.55c-.765.64-.632 1.577.4 2.813.52.623 1.038.992 1.556 1.105.516.111.984-.008 1.404-.359.38-.317.541-.7.483-1.149-.06-.448-.34-.973-.841-1.574-.58-.694-1.105-1.104-1.58-1.232-.473-.131-.947 0-1.422.397m3.977-.197c.564.676.81 1.403.735 2.181-.074.774-.467 1.459-1.18 2.054-.667.557-1.39.818-2.167.784-.778-.033-1.429-.364-1.953-.992-.556-.667-.803-1.405-.74-2.214.062-.81.432-1.497 1.108-2.06.713-.596 1.451-.87 2.215-.82.765.044 1.426.4 1.982 1.067m8.538-2.78c.16.574.282.93.368 1.069.338-.094.703-.212 1.095-.354.395-.143.705-.263.929-.36l.337-.143.026.028a5.337 5.337 0 0 0 .232.836l-.01.029c-.139.02-.31.06-.513.116l-2.565.714-.688.219-.02-.021c-.051-.397-.179-.968-.383-1.712l-.575-2.063c-.19-.686-.38-1.24-.564-1.661l.013-.03c.257-.054.48-.108.67-.16l.693-.22.015.022c.048.386.177.956.388 1.711l.551 1.98m9.862-3.054c.073-.668.102-1.252.088-1.753l.02-.023c.275.047.512.081.71.103l.725.053.006.027c-.12.45-.219 1.027-.296 1.73l-.231 2.128c-.072.66-.1 1.244-.084 1.753l-.02.024a12.062 12.062 0 0 0-.71-.103l-.726-.053-.006-.027c.122-.462.22-1.04.292-1.73l.232-2.129m10.506 5.584c1.762-1.395 2.881-2.348 3.359-2.858.054.05.2.137.436.263.185.1.312.159.38.176-2.446 1.852-4.107 3.128-4.984 3.828l-.531-.285c.047-.486.122-1.218.225-2.198.102-.98.187-1.816.254-2.507a28.16 28.16 0 0 0 .12-1.478c.08.062.335.21.767.44.304.164.502.26.596.292-.257 1.188-.464 2.63-.622 4.327m9.031 4.102a13.01 13.01 0 0 0 1.226-1.256l.03-.005c.176.218.331.4.465.548l.508.52-.013.024c-.389.258-.845.625-1.367 1.1l-1.583 1.442c-.49.447-.898.866-1.223 1.259l-.03.005a12.29 12.29 0 0 0-.465-.548l-.508-.52.013-.024c.397-.266.852-.634 1.364-1.104l1.583-1.441m5.318 10.672a46.226 46.226 0 0 0 1.413-1.51l-.023-.05-2.077.065c.095.23.218.508.37.836.078.166.183.385.317.66m-1.223-1.473c-.908.046-1.593.11-2.054.192a1.975 1.975 0 0 0-.143-.367 2.79 2.79 0 0 0-.23-.435 326.8 326.8 0 0 0 6.292-.08l.331.713c-2.145 2.251-3.542 3.784-4.19 4.598-.027-.098-.132-.343-.314-.735-.158-.339-.265-.55-.323-.633.399-.339.896-.81 1.493-1.41a35.296 35.296 0 0 0-.862-1.843",
    style: {
      lineHeight: "125%",
      InkscapeFontSpecification: "'Linux Biolinum Bold'",
      textAlign: "center"
    },
    fontSize: 100,
    fontWeight: 700,
    letterSpacing: 60,
    fontFamily: "Linux Biolinum",
    wordSpacing: 0,
    textAnchor: "middle",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131
  }), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M261.251 299.316l-.819 2.356-2.493.05 1.987 1.507-.722 2.387 2.047-1.424 2.047 1.424-.722-2.387 1.987-1.507-2.493-.05zm9.745-4.151l-.818 2.355-2.494.051 1.987 1.507-.722 2.387 2.047-1.425 2.047 1.425-.722-2.387 1.987-1.507-2.493-.05zm15.052-26.625l-.819 2.356-2.493.051 1.987 1.507-.722 2.387 2.047-1.425 2.047 1.425-.722-2.387 1.987-1.507-2.493-.05zm-7.146 18.995l.819 2.355 2.493.051-1.987 1.507.722 2.387-2.047-1.425-2.047 1.425.722-2.387-1.987-1.507 2.493-.05zm5.048-8.685l.82 2.356 2.493.05-1.987 1.507.722 2.387-2.047-1.424-2.047 1.424.722-2.387-1.987-1.506 2.493-.051zm-33.201 20.466l.819 2.356 2.493.05-1.987 1.507.722 2.387-2.047-1.424-2.047 1.424.722-2.387-1.987-1.507 2.493-.05zm-9.745-4.151l.818 2.355 2.494.051-1.988 1.507.723 2.387-2.047-1.425-2.047 1.425.722-2.387-1.987-1.507 2.493-.05zm-15.051-26.625l.819 2.356 2.493.051-1.987 1.507.722 2.387-2.047-1.425-2.047 1.425.722-2.387-1.987-1.507 2.493-.05zm7.145 18.995l-.819 2.355-2.493.051 1.987 1.507-.722 2.387 2.047-1.425 2.047 1.425-.722-2.387 1.987-1.507-2.493-.05zm-5.048-8.685l-.82 2.356-2.493.05 1.987 1.507-.722 2.387 2.047-1.424 2.047 1.424-.722-2.387 1.987-1.506-2.493-.051z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.131,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M257.15 264.632l-.004-.514h.071l-.882-.508h-.71l-.877.507h.07l.003.514 2.328.001",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M257.15 264.632l-.004-.514h.071l-.882-.508-.067-.773h-.575l-.067.773-.878.507h.07l.003.514 2.328.001zm.27.676v.16l-2.84-.002-.002-.16 2.843.001",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M257.42 265.308v.16l-2.84-.002-.002-.16 2.843.001zm-2.652-.01l-.002-.545h.115l-.006.55.007-.546-.166-.004v-.117l2.54.002v.116h-.156l.003.552-.006-.552h.117l.003.545",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M254.768 265.298l-.002-.545h.115l-.006.551.007-.546-.166-.004v-.117l2.54.002v.115h-.156l.003.552-.006-.552h.117l.003.546",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M255.314 265.164l-.002-.38h-.341l.002.38h.34",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M255.064 264.863v.22h.157v-.22h-.157m1.917.302l-.002-.38h-.34l.002.38h.34",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M256.73 264.865l.003.22h.156l-.001-.22h-.157m.248-.318l-.002-.38h-.34v.38h.342z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M256.728 264.247l.001.22h.156v-.22h-.157m-1.417.298l-.002-.379h-.34l.002.379h.34z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M255.061 264.245v.22h.157v-.22h-.157m.867.3l-.002-.378h-.34v.379h.341",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M255.678 264.246l.001.22h.156v-.22h-.157m.726.3l-.002-.38h-.34l.001.38h.341",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M256.154 264.246v.22h.157l-.001-.22h-.157",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M256.488 264.43l.004.876-.987-.001-.004-.875h.987",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M256.488 264.43l.004.876-.987-.001-.004-.875h.987zm-.992.25h.993m-.87.625l-.003-.619m.756.62l-.003-.619m.48-.63l-.556-.361-.624-.001-.551.36 1.731.002m-1.131-.441h.525m-.384-.166l.001.11h.241v-.11h-.242",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M255.548 264.455h.072l-.021.034s.034.04 0 .085l.019.032h-.07l.02-.03s-.036-.053.001-.087l-.02-.034m.146 0h.071l-.02.034s.034.039 0 .085l.019.032h-.07l.019-.03s-.035-.053.002-.087l-.021-.034m.16 0h.071l-.021.034s.035.04 0 .085l.02.032h-.07l.019-.03s-.035-.053.001-.087l-.021-.034zm.18 0h.072l-.02.035s.034.039 0 .084l.019.033h-.07l.019-.03s-.035-.054.002-.087l-.022-.035zm.16 0h.072l-.021.035s.035.039 0 .084l.02.033h-.07l.018-.03s-.035-.053.003-.087l-.021-.035m.159 0h.072l-.022.035s.036.039.001.084l.018.033h-.069l.019-.03s-.035-.053.002-.087l-.021-.035",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.046
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M255.832 262.432h.342v.4h-.342v-.4z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.034
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M256.006 261.943l-.007.51",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.079
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M255.816 262.134l.374.005",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M252.95 224.325s-2.498 5.8-1.635 6.375c0 0 3.133-3.499 3.95-6.279.817-2.78 0-.192 0-.192l-.227-3.02-2.043 2.876",
    fill: "#452c25"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M252.95 224.325s-2.498 5.8-1.635 6.375c0 0 3.132-3.499 3.95-6.279.817-2.78 0-.192 0-.192l-.227-3.02-2.043 2.876",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.175
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 221.553s-3 6.388-2.314 6.86c0 0 2.493-2.872 3.143-5.154.65-2.282 0-.157 0-.157l.833-4.106",
    fill: "#452c25"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 221.553s-3 6.388-2.314 6.86c0 0 2.493-2.872 3.143-5.154.65-2.282 0-.157 0-.157l.833-4.106",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M256.569 220.13s-3.001 6.388-2.315 6.86c0 0 2.493-2.872 3.144-5.154.65-2.282 0-.157 0-.157l.833-4.106",
    fill: "#452c25"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M256.569 220.13s-3.001 6.388-2.315 6.86c0 0 2.493-2.872 3.144-5.154.65-2.282 0-.157 0-.157l.833-4.106",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M295.294 208.646l3.562 2.022s.87.72-1.039.296c-1.907-.424-5.976-1.828-13.661-6.774-3.475-2.237-4.572-2.174-4.572-2.174l4.844.132 10.866 6.498z",
    fill: "#452c25"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M295.294 208.646l3.562 2.022s.87.72-1.039.296c-1.907-.424-5.976-1.828-13.661-6.774-3.475-2.237-4.572-2.174-4.572-2.174l4.844.132 10.866 6.498z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.128
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M296.471 207.767l3.563 2.022s.869.72-1.04.296c-1.907-.424-5.975-1.828-13.66-6.774-3.476-2.237-.68 1.845-.68 1.845l.589-2.684 11.228 5.295z",
    fill: "#452c25"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M296.471 207.767l3.563 2.022s.869.72-1.04.296c-1.907-.424-5.975-1.828-13.66-6.774-3.476-2.237-.68 1.845-.68 1.845l.589-2.684 11.228 5.295z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.128
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M302.397 209.713s-4.254-.79-5.803-1.924c0 0 .272.49-1.808-.458 0 0 .802 1.824-5.055-2.166-5.857-3.99-3.81-1.985-3.81-1.985l1.64-.423s8.99 3.593 9.977 3.969c.986.375 4.86 2.987 4.86 2.987",
    fill: "#452c25"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M302.397 209.713s-4.254-.79-5.803-1.924c0 0 .272.49-1.808-.458 0 0 .802 1.824-5.055-2.166-5.857-3.99-3.81-1.985-3.81-1.985l1.64-.423s8.99 3.593 9.977 3.969c.986.375 4.86 2.987 4.86 2.987z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.125
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M280.154 211.307l1.426 2.033s-.474 1.905-5.422-1.802c-4.948-3.708-4.687-3.401-4.687-3.401l2.733-.381 6 3.405",
    fill: "#452c25"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M280.154 211.307l1.426 2.033s-.474 1.905-5.422-1.802c-4.948-3.708-4.687-3.401-4.687-3.401l2.733-.381 6 3.405",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M273.728 212.326s2.298 3.006 1.786 3.38c-.511.374-3.225.213-5.163-2.729-1.937-2.942-.04-.15-.04-.15l.18-4.757 3.287 4.11",
    fill: "#452c25"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M273.728 212.326s2.298 3.006 1.786 3.38c-.511.374-3.225.213-5.163-2.729-1.937-2.942-.04-.15-.04-.15l.18-4.757 3.287 4.11",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M276.088 210.942s2.212 2.855 1.97 3.29c-.24.434-3.36.158-5.845-2.66-2.486-2.816-.37-3.716-.37-3.716l4.205 2.937",
    fill: "#452c25"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M276.068 210.868s2.232 2.929 1.99 3.363c-.24.435-3.36.159-5.845-2.658-2.486-2.817-.37-3.717-.37-3.717l4.225 3.012z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M288.694 209.257s6.306 2.712 1.63 2.535c0 0-9.16-2.467-13.9-6.527l1.34-1.772 10.857 5.606",
    fill: "#452c25"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M288.694 209.257s6.306 2.712 1.63 2.535c0 0-9.16-2.467-13.9-6.527l1.34-1.772 10.857 5.606",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M292.003 208.475s3.413 2.07 3.667 2.857c.254.787-10.605-2.028-16.334-6.798l2.559-1.253 10.108 5.194z",
    fill: "#452c25"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M292.003 208.475s3.413 2.07 3.667 2.857c.254.787-10.605-2.028-16.334-6.798l2.559-1.253 10.108 5.194z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M282.091 210.35s2.468 2.026 2.188 2.262c-.28.235-5.285-.514-9.214-3.538l.47-1.807 6.605 2.986",
    fill: "#452c25"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M282.091 210.35s2.468 2.026 2.188 2.262c-.28.235-5.285-.514-9.214-3.538l.47-1.807 6.605 2.986",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M286.312 210.178s2.435 1.68 1.93 1.856c-.505.177-2.414 1.678-11.477-3.63l-1.068-.587 1.439-2.26 9.181 4.474",
    fill: "#452c25"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M286.315 210.105s2.432 1.753 1.927 1.93c-.505.176-2.414 1.677-11.477-3.631l-1.068-.587 1.439-2.26 9.179 4.548z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M277.012 205.206s2.945 2.638 2.57 3.018c-.377.379-3.883-.456-5.43-1.605-1.546-1.15-2.672-2.623-2.672-2.623l3.287-.708 2.245 1.918z",
    fill: "#452c25"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M277.012 205.206s2.945 2.638 2.57 3.018c-.377.379-3.883-.456-5.43-1.605-1.546-1.15-2.672-2.623-2.672-2.623l3.287-.708 2.245 1.918z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M273.5 200.8l5.367 3.2s4.38 3.091 3.917 3.368c-.463.277-3.915-.802-6.362-2.137-2.447-1.334-5.285-4.208-5.285-4.208",
    fill: "#452c25"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M273.5 200.8l5.367 3.2s4.38 3.091 3.917 3.368c-.463.277-3.915-.802-6.362-2.137-2.447-1.334-5.285-4.208-5.285-4.208",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M270.113 215.928s1 2.558.402 2.78c-.597.223-2.077-.233-3.266-2.552-1.188-2.319 1.036-1.339 1.036-1.339l1.828 1.111z",
    fill: "#452c25"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M270.113 215.928s1 2.558.402 2.78c-.597.223-2.077-.233-3.266-2.552-1.188-2.319.807-1.288.807-1.288l2.057 1.06z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M271.893 214.274s1.5 2.48 1.173 2.763c-.327.283-2.305 1.139-4.461-2.06-2.155-3.197 2.218-2.524 2.218-2.524l1.07 1.821z",
    fill: "#452c25"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M271.893 214.274s1.5 2.48 1.173 2.763c-.327.283-2.305 1.139-4.461-2.06-2.155-3.197 2.218-2.524 2.218-2.524l1.07 1.821z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M267.409 203.084s5.118 9.884 4.692 10.409c-.426.526-2.447-.002-3.58-2.615-1.133-2.613-2.06-6.006-2.06-6.006l.948-1.788z",
    fill: "#452c25"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M267.409 203.084s5.118 9.884 4.692 10.409c-.426.526-2.447-.002-3.58-2.615-1.133-2.613-2.06-6.005-2.06-6.005l.948-1.789z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M273.372 205.6s4.27 3.63 3.394 4.087c-.877.458-2.576-.204-5.074-2.676-2.498-2.472 1.64-1.561 1.64-1.561",
    fill: "#452c25"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M273.352 205.525s4.29 3.705 3.414 4.162c-.877.458-2.576-.204-5.074-2.676-2.498-2.472 1.66-1.486 1.66-1.486z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M271.302 205.66s3.052 5.606 2.671 6.133c-.38.528-2.67-1.393-3.8-2.821-1.129-1.428-1.983-3.505-1.983-3.505",
    fill: "#452c25"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M271.302 205.66s3.052 5.606 2.671 6.133c-.38.528-2.67-1.393-3.8-2.821-1.129-1.428-1.983-3.505-1.983-3.505",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M248.426 217.172s-.18 3.304 0 3.551c.181.246 1.857.246 1.947-2.22.091-2.466-.362-2.564-.362-2.564l-1.63 1.134",
    fill: "#452c25"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M248.426 217.172s-.18 3.304 0 3.551c.181.246 1.857.246 1.947-2.22.091-2.466-.362-2.564-.362-2.564l-1.63 1.134",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M249.429 213.19s-1.178 3.699-.045 4.439c1.132.74 2.038-3.65 2.083-4.636.045-.987-2.038.197-2.038.197",
    fill: "#452c25"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M249.429 213.19s-1.178 3.699-.045 4.439c1.132.74 2.038-3.65 2.083-4.636.045-.987-2.038.197-2.038.197z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M250.238 217.912s.226 3.452.86 3.6c.634.148 1.676-.986 1.676-1.874 0-.888-1.087-2.96-1.087-2.96l-1.495 1.086",
    fill: "#452c25"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M250.238 217.912s.226 3.452.86 3.6c.634.148 1.676-.986 1.676-1.874 0-.888-1.087-2.96-1.087-2.96l-1.495 1.086",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M250.268 213.777s-1.178 3.7-.045 4.439c1.132.74 2.038-3.65 2.083-4.636.045-.986-2.038.197-2.038.197z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M250.36 207.841s-1.722 1.776-1.676 2.763c.045.986 2.536-1.332 2.763-1.776.226-.444-1.087-.987-1.087-.987",
    fill: "#452c25"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M250.36 207.841s-1.722 1.776-1.676 2.763c.045.986 2.536-1.332 2.763-1.776.226-.444-1.087-.987-1.087-.987z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M249.176 206.847s-1.359 2.515-.996 3.304c.362.789 1.675-.592 2.31-1.48.634-.887-1.314-1.824-1.314-1.824",
    fill: "#452c25"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M249.176 206.847s-1.359 2.515-.996 3.304c.362.789 1.675-.592 2.31-1.48.634-.887-1.314-1.824-1.314-1.824z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M268.277 203.514s2.17 4.087 1.573 4.31c-.596.222-1.513-.803-2.422-2.025-.91-1.222.85-2.285.85-2.285",
    fill: "#452c25"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M268.277 203.514s2.17 4.087 1.573 4.31c-.596.222-1.513-.803-2.422-2.025-.91-1.222.85-2.285.85-2.285z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M268.327 211.873s.788 3.438.097 3.755c-1.352.62-2.106-2.444-2.187-3.594-.092-1.287 2.09-.161 2.09-.161zm-2.704 5.45s.183 2.574-.188 2.806c-.37.231-1.28.293-2.292-1.871-1.013-2.164-.542-1.355-.542-1.355l2.49-1.23.54 1.404",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M268.113 216.735s.291 2.726-.256 2.803c-.546.076-2-.846-2.633-2.478-.73-1.881 2.539-1.327 2.539-1.327l.35 1.002z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M265.55 208.373s2.798 6.262 2.348 7.154c-.882 1.745-3.424-3.814-4.192-5.984-.859-2.427 1.843-1.17 1.843-1.17z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M264.252 209.42s3.815 6.891 2.206 7.052c-1.609.16-4.534-4.999-5.024-6.198-.491-1.2 2.818-.855 2.818-.855z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M264.024 210.85s1.877 6.605.668 6.02c-1.21-.583-2.666-5.558-2.864-6.632-.199-1.074 2.196.612 2.196.612zm6.595-9.391s2.893 4.42 1.955 4.55c-.939.132-4.37-2.952-4.402-3.463-.03-.51 2.447-1.087 2.447-1.087z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M268.81 201.645s3.69 5.036 2.577 5.292c-1.113.255-1.197-.532-1.197-.532s-2.944-2.654-3.141-3.325c-.198-.671 1.652-1.5 1.652-1.5m3.764.143s2.537 2.617 1.871 3.503c-.665.886-4.19-3.314-4.67-3.847-.48-.534 3.074.241 3.074.241m-6.426 3.74s4.085 7.958 3.333 8.767c-.752.81-5.293-5.967-5.451-6.95-.158-.982 2.16-1.967 2.16-1.967",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M263.964 206.08s1.634 2.49 1.542 3.831c-.093 1.341-2.47-1.92-2.676-2.534-.205-.614 1.134-1.298 1.134-1.298z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.165
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M267.325 204.79s1.27 2.569.88 3.342c-.388.774-2.12-1.56-2.723-2.474-.603-.913 1.843-.869 1.843-.869z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M261.43 207.315s1.994 2.212 1.898 3.391c-.095 1.18-2.99-1.72-3.245-2.263-.253-.543 1.347-1.128 1.347-1.128z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.17
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M274.32 200.932s3.018 2.708 2.55 3.133c-.468.425-4.552-2.5-5.167-3.068-.615-.568 2.617-.065 2.617-.065z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M271.767 200.736l2.361 1.989s2.194 1.465 1.818 1.845c-.375.38-3.811-1.193-4.42-1.91-.61-.715-.54-1.453-.54-1.453l.781-.47zm7.78.626s8.94 3.625 8.592 4.499c-.348.874-9.372-2.902-10.788-3.898-1.416-.996 2.062-.656 2.062-.656",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M279.87 202.51s6.713 3.78 5.93 4.143c-.783.363-5.588-.92-8.068-2.602-2.48-1.681-3.536-2.613-3.536-2.613l3.061-.713 2.613 1.785zm-16.526 4.594s1.271 2.57.882 3.344c-.39.773-1.655-.66-2.257-1.574-.604-.913 1.375-1.77 1.375-1.77zm.302 5.795s1.049 3.744-.108 4.437c-1.157.693-1.91-3.73-1.921-4.718-.012-.988 2.03.28 2.03.28z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M258.45 206.73s3.732-1.639 4.394-1.508c0 0 .783-.196 1.204-.524.421-.328 1.384-1.114 1.384-1.114s-.662-4.523 4.094-4.064c4.756.458 11.016 1.048 12.28 1.245 1.265.197 5.9 1.508 6.984 2.032 1.083.524 8.144 3.72 9.588 4.245.856.31 2.744 1.49 4.14 2.402.963.627-.029.178-.029.178s-11.435-6.07-15.477-6.882c-1.011-.203.07 1.158.07 1.158s-2.627-1.036-3.71-1.494c-1.084-.459-1.987-.656-3.01-.59a6.193 6.193 0 0 1-2.408-.328c-.603-.197-4.034-.328-4.636-.393a7.81 7.81 0 0 1-1.083-.197l.24.393-1.685-.262-.482.721s-1.625.328-1.746-.197c-.12-.524-.963 2.36-1.384 3.212-.422.853-1.987.852-2.469 1.377-.48.525-.782.852-1.022.983-.241.131-1.445.852-1.867.852-.421 0-3.01.197-3.01.197l-.662-1.049.301-.393zm4.907 10.599s.066 3.31-.123 3.548c-.19.24-1.865.17-1.87-2.297-.005-2.468.45-2.548.45-2.548l1.59 1.2",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M263.759 214.79s-.317-1.433-.544-1.63c-.226-.198.09-.396.09-.396s-.588-1.433-.95-1.68c-.363-.246.045-.444.045-.444s-.634-.988-1.087-1.285c-.453-.296 0-.346 0-.346s-.473-1.326-1.577-1.934c0 0-.732-.77-1.478-.982-.747-.212-2.598-.41-4.836-.368-2.357.043-3.356 1.677-3.356 1.677l-.151 1.895.34-.231-.499 2.36c-.079.54.423 1.478.45 2.606.01.357.031.73.072 1.113.107 1.013.344 2.087.804 3.078.036.078.07.307.113.233.116-.198.374.668.607.979 0 0 .14 1.177.25.74.044-.169.422.668.656 1.193.085.19.53 1.487.514.897-.019-.646.391 1.376.391 1.666l.544-.79.272.889.452-.05-.135.84s1.268-1.037 1.313-1.433c.045-.395.09-.691.09-.691l.408-.396.635-.988s1.585 1.235 1.766 1.68c.181.445.363.84.363.84l.407-.395.363.889.226-.445.22.618.02-.038.144.407c.11.103.363.155.839-.64.679-1.137.634-2.026.679-2.224.045-.198.317.346.317.346s.589-1.087.498-1.779c-.09-.692.363-.445.363-.445s.09-1.828 0-2.273c-.091-.444.317-.345.317-.345s-.136-2.174-.272-2.421c-.136-.247.317-.297.317-.297z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M260.585 209.76c.32.096.476.457.612.736-.009-.017.02-.098.004-.133-.136-.28-.296-.645-.616-.74.003 0-.021.13 0 .137m.29 1.366c.59.5.64 1.182.608 1.928 0 .022.008.154.011.07.035-.79.026-1.59-.62-2.135.015.012-.027.114 0 .137m1.227.7c.326.534.356 1.124.357 1.742 0 .078.013.078.013 0 0-.656-.016-1.3-.366-1.876.009.014-.023.102-.003.133m.43 2.58c-.036.383-.105.758-.179 1.135a.478.478 0 0 0 .007.118c.075-.383.145-.766.182-1.155.003-.018-.005-.151-.01-.097m-.397 1.98c.03.25.062.499.036.752-.003.018.004.151.01.097.034-.318.003-.63-.036-.946-.007-.054-.012.08-.01.097m-.761-2.485c0 .423.003.845.038 1.267.005.054.011-.08.01-.098a14.26 14.26 0 0 1-.034-1.17c0-.078-.014-.078-.014 0m-.323 2.745c.033.401.034.804.034 1.206 0 .079.013.079.013 0 0-.435-.003-.87-.038-1.303-.005-.054-.01.079-.01.097m1.812-.35a1.2 1.2 0 0 1 .322.656c.004.026.009-.02.009-.025a.33.33 0 0 0-.003-.094 1.242 1.242 0 0 0-.329-.674c.017.017-.026.11 0 .138m-.108-2.77c.18.15.326.333.47.517-.017-.021.025-.106 0-.137a3.31 3.31 0 0 0-.47-.517c.015.012-.027.115 0 .137m-1.489 2.073a6.366 6.366 0 0 1-.105 1.122.398.398 0 0 0 .007.119c.077-.41.11-.824.112-1.241 0-.078-.013-.078-.013 0m-.793.824c.03.337.03.673 0 1.01 0 .018.005.152.01.098a6.642 6.642 0 0 0 0-1.205c-.005-.054-.011.08-.01.097"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M246.122 207.281s-.906 3.403-.226 3.749c1.33.675 2.188-2.356 2.31-3.502.135-1.283-2.084-.247-2.084-.247",
    fill: "#452c25"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M246.122 207.281s-.906 3.403-.226 3.749c1.33.675 2.188-2.356 2.31-3.502.135-1.283-2.084-.247-2.084-.247z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M248.082 207.254s-1.721 1.776-1.676 2.762c.045.986 2.537-1.332 2.763-1.776.227-.443-1.087-.986-1.087-.986",
    fill: "#452c25"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M248.082 207.254s-1.721 1.776-1.676 2.762c.045.986 2.537-1.332 2.763-1.776.227-.443-1.087-.986-1.087-.986z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M218.726 207.504s-3.556 1.785-3.867 2.549c-.312.763 10.726-1.157 16.791-5.444l-2.46-1.457-10.464 4.352z",
    fill: "#452c25"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M218.726 207.504s-3.556 1.785-3.867 2.549c-.312.763 10.726-1.157 16.791-5.444l-2.46-1.457-10.464 4.352z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M222.883 208.221s-6.436 2.342-1.756 2.436c0 0 9.275-1.93 14.216-5.707l-1.248-1.847-11.13 4.965",
    fill: "#452c25"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M222.924 208.145s-6.477 2.418-1.797 2.512c0 0 9.275-1.93 14.216-5.707l-1.248-1.847-11.171 5.042z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M232.438 201.685s-6.84 3.502-6.07 3.897c.77.394 5.617-.69 8.153-2.269 2.537-1.578 3.624-2.466 3.624-2.466l-3.035-.838-2.672 1.676z",
    fill: "#452c25"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M232.438 201.685s-6.84 3.502-6.07 3.897c.77.394 5.617-.69 8.153-2.269 2.537-1.578 3.624-2.466 3.624-2.466l-3.035-.838-2.672 1.676z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M229.855 209.366s-2.443 2.046-2.16 2.278c.283.234 5.279-.554 9.171-3.608l-.492-1.803-6.57 3.037",
    fill: "#452c25"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M229.855 209.366s-2.443 2.046-2.16 2.278c.283.234 5.279-.554 9.171-3.608l-.492-1.803-6.57 3.037",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M225.603 209.049s-2.348 1.792-1.835 1.945c.513.152 2.497 1.56 11.284-4.171l1.036-.637-1.55-2.189-8.948 4.904",
    fill: "#452c25"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M225.596 208.975s-2.341 1.866-1.828 2.019c.513.152 2.497 1.56 11.284-4.171l1.036-.637-1.55-2.189-8.942 4.978z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M223.789 202.232c-7.39 2.585-14.799 7.734-14.799 7.734.724-.247 19.014-7.61 19.014-7.61M240 213.77s-1.585 2.416-1.268 2.712c.317.296 2.265 1.233 4.53-1.874 2.264-3.107-2.13-2.614-2.13-2.614L240 213.77z",
    fill: "#452c25"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M240.001 213.769s-1.585 2.416-1.268 2.712c.317.296 2.265 1.233 4.53-1.874 2.264-3.107-2.13-2.614-2.13-2.614l-1.132 1.776z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M241.723 215.495s-1.087 2.515-.498 2.762c.588.247 2.083-.148 3.351-2.417 1.269-2.269-.589-1.134-.589-1.134l-2.264.789zm-3.488-3.748s-2.4 2.91-1.902 3.304c.498.395 3.216.346 5.254-2.515 2.038-2.86.045-.148.045-.148l-.589-2.614-2.853 1.825",
    fill: "#452c25"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M241.723 215.495s-1.087 2.515-.498 2.762c.588.247 2.083-.148 3.351-2.417 1.269-2.269-.589-1.134-.589-1.134l-2.264.789zm-3.488-3.748s-2.4 2.91-1.902 3.304c.498.395 3.216.346 5.254-2.515 2.038-2.86.045-.148.045-.148l-.589-2.614-2.853 1.825",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M235.925 210.267s-2.31 2.762-2.083 3.206c.226.444 3.352.296 5.933-2.417 2.582-2.713.499-3.699.499-3.699l-4.303 2.762",
    fill: "#452c25"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M235.925 210.267s-2.31 2.762-2.083 3.206c.226.444 3.352.296 5.933-2.417 2.582-2.713.499-3.699.499-3.699l-4.303 2.762",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M231.849 210.465l-1.495 1.972s.408 1.923 5.48-1.578c5.073-3.502 4.802-3.206 4.802-3.206l-2.718-.493-6.115 3.156",
    fill: "#452c25"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M231.826 210.39l-1.472 2.047s.408 1.923 5.48-1.578c5.073-3.502 4.802-3.206 4.802-3.206l-2.718-.493-6.092 3.23z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M215.669 207.443l-3.215 1.446s-.727.637 1.161.684c1.889.048 5.79-.474 12.578-4.323 3.069-1.74 5.013-3.4 5.013-3.4l-2.473-.918-13.064 6.511z",
    fill: "#452c25"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M215.669 207.443l-3.215 1.446s-.727.637 1.161.684c1.889.048 5.79-.474 12.578-4.323 3.069-1.74 5.013-3.4 5.013-3.4l-2.473-.918-13.064 6.511z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M210.162 209.471s4.626-.503 6.465-1.708c0 0-.376.562 1.99-.361 0 0-1.178 2.118 5.72-2.08 6.897-4.2.056-.086.056-.086l7.66-4.389-.447-.875s-14.637 6.269-15.745 6.618c-1.107.35-5.699 2.881-5.699 2.881",
    fill: "#452c25"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M224.365 205.279l7.689-4.432-.448-.875s-14.637 6.269-15.745 6.618c-1.107.35-5.699 2.881-5.699 2.881s4.626-.503 6.465-1.708c0 0-.376.562 1.99-.361 0 0-1.15 2.075 5.748-2.123z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M243.761 215.388s-.453 3.667.09 3.803c.544.136 2.084-1.018 2.718-3.26.634-2.24-2.49-1.968-2.49-1.968l-.453 1.29",
    fill: "#452c25"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M243.761 215.388s-.453 3.667.09 3.803c.544.136 2.084-1.018 2.718-3.26.634-2.24-2.49-1.968-2.49-1.968l-.453 1.29",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.166
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M246.161 217.073s-.271 2.565.091 2.811c.363.247 1.268.346 2.355-1.775 1.087-2.12.589-1.332.589-1.332l-2.446-1.331-.589 1.38",
    fill: "#452c25"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M246.161 216.95s-.271 2.688.091 2.934c.363.247 1.268.346 2.355-1.775 1.087-2.12.589-1.332.589-1.332l-2.446-1.331-.589 1.504z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M246.84 212.29s-1.992 4.34-.86 4.29c1.133-.05 2.673-3.304 2.899-4.044.227-.74-2.038-.247-2.038-.247",
    fill: "#452c25"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M246.84 212.29s-1.992 4.34-.86 4.29c1.132-.05 2.673-3.304 2.899-4.044.227-.74-2.038-.247-2.038-.247z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M246.668 212.251s-.75 4.783.32 4.378c1.07-.405 1.677-4.007 1.696-4.786.02-.78-2.016.408-2.016.408",
    fill: "#452c25"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M246.668 212.251s-.75 4.783.32 4.378c1.07-.405 1.677-4.007 1.696-4.786.02-.78-2.016.408-2.016.408z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M248.29 212.733s-1.177 3.699-.045 4.439c1.132.74 2.038-3.65 2.083-4.636.046-.987-2.038.197-2.038.197",
    fill: "#452c25"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M248.29 212.733s-1.177 3.699-.045 4.439c1.132.74 2.038-3.65 2.083-4.636.046-.987-2.038.197-2.038.197z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M243.648 211.516s-1.133 3.403-.453 3.748c1.33.675 2.415-2.356 2.536-3.502.136-1.282-2.083-.246-2.083-.246zm-8.447-7.02s-3.035 2.516-2.673 2.91c.363.395 3.896-.295 5.48-1.38 1.586-1.085 2.22-1.677 2.22-1.677l-2.718-1.677-2.31 1.825z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M237.873 201.932s-1.947 1.578-1.585 1.973c.362.395 3.85-1.036 4.483-1.726.635-.69.59-1.43.59-1.43l-3.488 1.183z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M239.866 201.685s-2.627 2.17-1.993 2.96c.634.789 4.303-2.713 4.8-3.157.499-.444-3.08.099-3.08.099",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M238.688 200.7l-5.299 2.515s-4.484 2.91-4.031 3.205c.453.296 3.94-.64 6.431-1.874 2.491-1.233 5.255-3.304 5.255-3.304m-.88 2.32s-5.733 4.93-4.873 5.423c.86.493 4.695-1.572 7.277-3.94",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M240.891 205.185s-3.245 5.477-2.882 6.019c.362.543 2.717-1.282 3.895-2.663 1.178-1.381 2.104-3.42 2.104-3.42",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M242.757 205.669s-3.516 6.534-3.109 7.076c.408.542 2.446.099 3.67-2.466 1.222-2.565 1.117-4.219 1.117-4.219l-1.678-.391z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M244.8 205.982s-3.908 8.064-3.138 8.853c.77.79 5.097-6.116 5.295-7.091.348-1.715-2.203-1.91-2.203-1.91m-8.195-5.184s-3.532 1.677-2.808 2.022c.725.345 4.031-1.134 4.484-1.282.454-.148-1.676-.74-1.676-.74z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M237.103 201.193s-2.174 1.726-1.721 2.17c.452.444 3.76-1.332 4.393-1.875.634-.542-2.672-.295-2.672-.295z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M241.664 201.33s-2.97 3.995-2.06 4.153c.91.158 4.36-2.576 4.408-3.049.048-.473-2.348-1.104-2.348-1.104z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.15
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M242.991 202.228s-3.17 3.995-2.265 4.242c.906.246.997-.395.997-.395s2.49-2.071 2.672-2.614c.181-.543-1.314-1.282-1.314-1.282",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M243.988 203.165s-2.31 3.995-1.722 4.242c.59.246 1.54-.74 2.491-1.924.951-1.183-.77-2.318-.77-2.318z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M244.576 204.99s-1.359 2.515-.996 3.304c.362.79 1.676-.591 2.31-1.479.634-.888-1.314-1.825-1.314-1.825zm.57 6.982s-.906 3.403-.226 3.749c1.33.675 2.188-2.356 2.31-3.502.136-1.282-2.084-.247-2.084-.247z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M251.37 207.37s-.906-.296-1.585-.296c0 0-1.993-1.578-3.08-1.726-1.087-.148-.159-.173-.159-.173s-.113-2.589-.43-2.786c0 0-.181-2.663-1.857-2.86-1.676-.198-5.435.147-6.115-.1-.679-.246-2.76-1.114-6.703-.049-4.034 1.091-11.971 4.655-12.379 4.753-.407.1 9.118-2.09 11.79-3.273 0 0 2.672-.197 3.488-.444 0 0-3.034 1.48-.227.839 2.809-.642 2.174 0 2.174 0s-.271.64 1.314.295c1.585-.345 1.585 0 1.585 0s1.812.641 3.216-.197c0 0 .725 2.516 1.63 2.86 0 0 1.077 2.305 3.342 2.75 0 0 1.076.762 1.302.91l1.28.42 1.369-1.071",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M232.8 200.551s-9.058 3.255-8.742 4.143c.317.888 9.466-2.515 10.916-3.452 1.45-.937-2.038-.74-2.038-.74",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M257.877 207.57c.207.035.382.129.568.224.006.003.085.052.1.032.014-.02-.056-.083-.06-.087a1.641 1.641 0 0 0-.386-.286c-.237-.122-.468-.25-.734-.294-.052-.008.143.179.157.19.095.076.23.2.355.221m-7.052 6.84c.134.258.155.555.29.813-.01-.017.02-.1.003-.133-.134-.258-.155-.555-.29-.813.009.017-.02.1-.003.133m1.23-6.976c.304-.108.625-.11.94-.148.015-.002.005-.138 0-.138-.315.038-.636.04-.94.148-.022.008.004.136 0 .138m1.808-.148c.287-.136.592-.147.903-.147.01 0 .01-.138 0-.138-.311 0-.616.011-.903.147-.025.012.008.135 0 .138m-3.145 1.598c-.037.007-.04.037-.042.071a.33.33 0 0 0 .003.094c.004.027.009-.02.009-.024-.003.025.014 0 .03-.003.018-.003.003-.138 0-.138m-.187 4.869c0 .254.003.509.04.76.003.027.008-.02.01-.024a.333.333 0 0 0-.004-.094 4.26 4.26 0 0 1-.032-.642c0-.078-.014-.078-.014 0"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M252.36 228.153s-1.025.793-1.14 1.166c-.116.374-.148.734-.148.734s.917-.111.805.395c0 0 .297.171.77-.927.473-1.098.92-1.572 1.255-1.54.335.032.762.358.978.587.215.23.512.4.885.293 0 0-.392-.597-.144-.728.247-.13.624-.105.624-.105s-.312-.744-.984-.852c-.672-.108-1.137-.295-.978-.587.16-.293 1.02-2.563 1.02-2.563l-1.14-1.673-.456 1.456s.148.86.154 1.08c.006.22-.905 2.101-1.028 2.21-.123.11-2.565 1.054-2.855 1.146-.29.094-.898.816-.898.816l-.07.543s.41-.335.54-.136c0 0 .284-.357.538-.223.254.134.214.185.214.185s.452-.298.532-.444c.08-.146.101-.128.101-.128s.229-.06.562-.117",
    fill: "#bd8759"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M252.36 228.153s-1.025.793-1.14 1.166c-.116.374-.148.734-.148.734s.917-.111.805.395c0 0 .297.171.77-.927.473-1.098.92-1.572 1.255-1.54.335.032.762.358.978.587.215.23.512.4.885.293 0 0-.392-.598-.144-.728.247-.13.624-.105.624-.105s-.312-.744-.984-.852c-.672-.108-1.137-.295-.978-.587.16-.293 1.02-2.563 1.02-2.563l-1.14-1.673-.456 1.456s.148.86.154 1.08c.006.22-.905 2.101-1.028 2.21-.123.11-2.565 1.054-2.855 1.146-.29.094-.898.816-.898.816l-.07.543s.41-.335.54-.136c0 0 .284-.357.538-.223.254.134.214.185.214.185s.452-.298.532-.444c.08-.146.101-.128.101-.128s.229-.06.562-.117",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M259.325 223.115s.042 1.926.042 2.285c0 .358-.042.895-.247 1.209-.206.314-.412.493-.74.493-.33 0-1.194-.045-1.358.268a5.361 5.361 0 0 1-.289.493s.535-.313.617 0c.083.314-.205.583-.205.583s.494.09.946-.18c.452-.268.7-.313.905-.313.206 0 .37.224.37.224s.124.672.083 1.075c-.042.403-.124 1.21.329 1.21 0 0 .164-.404.329-.449.164-.044.617.403.535.538 0 0 .082-.851-.083-1.344-.164-.493-.247-1.03-.247-1.03s1.4.493 1.523.672c.123.179.452.493.576.448.123-.045 0-.448.246-.538.247-.09.37.134.37.134s-.41-.94-1.028-1.254c-.617-.313-1.028-.313-1.275-.582-.247-.269-.289-.582-.33-.896-.04-.314.012-3.021.012-3.021l-1.04-.204",
    fill: "#bd8759"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M259.346 222.974s.02 2.067.02 2.426c0 .358-.04.895-.246 1.209-.206.314-.412.493-.74.493-.33 0-1.194-.045-1.358.268a5.195 5.195 0 0 1-.289.493s.535-.313.617 0c.083.314-.205.583-.205.583s.494.09.946-.18c.452-.268.7-.313.905-.313.206 0 .37.224.37.224s.124.672.083 1.075c-.042.403-.124 1.21.329 1.21 0 0 .164-.404.329-.449.164-.044.617.403.535.538 0 0 .082-.851-.083-1.344-.164-.493-.247-1.03-.247-1.03s1.4.493 1.523.672c.123.179.452.493.576.448.123-.045 0-.448.246-.538.247-.09.37.134.37.134s-.41-.94-1.028-1.254c-.617-.313-1.028-.313-1.275-.582-.247-.269-.289-.582-.33-.896-.04-.314.012-3.021.012-3.021l-1.06-.166z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M250.74 210.474s-.136-1.372.249-1.52c0 0 .136-1.258 1.812-1.085 0 0 .566-.937 1.472-.444 0 0 .86-.42 1.359-.173.498.247 1.11.666 1.154.765 0 0 .725-.148 1.065.123.34.271.181 1.16.181 1.16s.815.623.883 1.174c.068.551.068.773-.113.921 0 0 .362.296.294.715-.068.42-.408 1.028-.476 1.028-.067 0 .046 1.093-.316 1.463-.363.37-.702.444-.86.493-.16.05-.567.641-.952.715-.385.074-.906-.592-.951-.789-.045-.197-.566-.42-.566-.42s-1.178 1.259-1.97 1.061c-.793-.197-1.178-.863-1.246-.986-.068-.123-.294-1.036-.294-1.036s-.883-.518-.816-1.01c.068-.494.43-1.086.43-1.086l-.34-1.069z",
    fill: "#dcddde"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M253.684 226.07a.31.31 0 0 1-.253-.045m.645-.95a.854.854 0 0 1-.339-.12m-.066.63c.076.044.163.06.252.047m-1.089 1.512a.34.34 0 0 0 .169.06m6.857-.998c.168.03.321.119.494.134m-.206-.627c-.133.033-.247.007-.329-.09m.411-.492a.924.924 0 0 1-.452-.045m-.124 2.016c.157.02.302.098.453.134m-.411.493a.23.23 0 0 1 .205.044m-.082 1.658a.43.43 0 0 1 .288.045m-5.43-2.245a.363.363 0 0 0-.287.225m1.125-.146c-.18.104-.34.25-.364.46m-4.839.463c.14.127.347.202.468.32m10.56-1.003a.375.375 0 0 0-.205.269m.782-.09a.197.197 0 0 0-.123.179",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M249.014 229.412l.587-.152.057.023s-.385.744-.28.924c.104.18-.526-.326-.364-.795",
    fill: "#d9c0b9"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M249.014 229.412l.587-.152.057.023s-.385.744-.28.924c.104.18-.526-.326-.364-.795z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M251.248 229.851s-.65 1.085.193 1.628c0 0-.052-1.012.608-1.23l-.8-.398z",
    fill: "#d9c0b9"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M251.248 229.851s-.65 1.085.193 1.628c0 0-.052-1.012.608-1.23l-.8-.398z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M255.56 228.84l-.197-.587.228-.308.461-.005.196.092s.37.846.046 1.29c0 0-.137-.478-.294-.543 0 0-.344-.054-.44.06",
    fill: "#d9c0b9"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M255.56 228.84l-.197-.587.228-.308.461-.005.196.092s.37.846.046 1.29c0 0-.137-.478-.294-.543 0 0-.344-.054-.44.06z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M257 227.599h.386l.147.36-.055.333-.333.154s-.55-.14-.414.513c0 0-.257-1.2.27-1.36",
    fill: "#d9c0b9"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M257 227.599h.386l.147.36-.055.333-.333.154s-.549-.14-.414.513c0 0-.257-1.2.27-1.36z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M259.725 230.286l.398-.44.429.226s-.178 1.16-.245 1.247c-.067.087-.08.1-.08.134 0 .033-.067-.22-.196-.367-.128-.147-.263-.787-.306-.8",
    fill: "#d9c0b9"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M259.725 230.286l.398-.44.429.226s-.178 1.16-.245 1.247c-.067.087-.08.1-.08.134 0 .033-.067-.22-.196-.367-.128-.147-.263-.787-.306-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M262.321 229.12s.643.8.563 1.06c0 0 .662-.667-.19-1.614l-.373.553z",
    fill: "#d9c0b9"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M262.321 229.12s.643.8.563 1.06c0 0 .662-.667-.19-1.614l-.373.553z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 208.948c.128.036.208.13.252.256.003.006.008-.042.008-.048 0-.026.004-.06-.005-.085-.044-.127-.125-.223-.255-.26.003 0-.02.131 0 .137m.145 2.215c.2.21.349.455.432.736-.007-.022.015-.094.004-.133a1.81 1.81 0 0 0-.436-.74c.016.017-.026.11 0 .137m-.47-1.624c.196.17.362.368.542.553-.016-.017.027-.11 0-.137-.18-.186-.346-.385-.542-.554.015.013-.027.114 0 .138m.539 3.682c.057.332-.02.615-.143.908-.015.037.012.114.004.133a2.04 2.04 0 0 0 .146-1.16.437.437 0 0 0-.007.12m.506 1.144c.026.17.03.339 0 .51a.493.493 0 0 0-.003.093c0 .004.004.051.009.025.044-.247.037-.5 0-.746-.004-.027-.009.02-.009.024a.331.331 0 0 0 .003.094m1.953 4.032c.13.462.14.933.14 1.41 0 .079.014.079.014 0 0-.52-.01-1.039-.15-1.543.007.023-.014.094-.004.133m-.325.938a7.903 7.903 0 0 1-.362.96c-.016.035.013.115.004.133a7.85 7.85 0 0 0 .362-.96c.012-.038-.01-.112-.003-.133m-10.913-3.114c.302.394.466.866.72 1.29-.008-.015.023-.102.005-.133-.256-.425-.42-.9-.725-1.295.017.022-.025.106 0 .138m1.916.047c-.276.036-.344-.36-.579-.443.004 0-.022.13 0 .137.234.083.303.48.579.443.015-.002.004-.138 0-.137m-1.087 1.833c.199.348.33.732.543 1.071-.01-.014.023-.102.004-.133-.214-.34-.345-.722-.543-1.07.01.015-.022.1-.004.132m1.267.446c.223.268.424.55.54.884-.007-.021.017-.096.004-.133-.117-.336-.32-.62-.544-.889.017.02-.026.107 0 .138m-.11 1.327c.112.231.213.47.325.701-.008-.017.02-.098.004-.133-.112-.232-.213-.47-.325-.701.008.018-.02.098-.004.133m1.193.258c.065.244.101.493.103.746 0 .078.014.078.014 0a3.517 3.517 0 0 0-.114-.879c.006.024-.014.094-.004.133m-.507 1.101c.078.35.18.694.363 1.004-.008-.015.022-.101.004-.133-.18-.306-.283-.644-.36-.99a.357.357 0 0 0-.007.12m.292-4.68c.286.108.572.216.868.295 0 0 .02-.133 0-.138a8.62 8.62 0 0 1-.868-.296c.005.002-.022.13 0 .138m.217 1.219c.341.19.7.34 1.048.516-.009-.004.025-.125 0-.137-.348-.176-.707-.327-1.048-.517.01.006-.026.123 0 .138m.326 1.366c.176.214.368.41.578.59-.015-.012.027-.114 0-.137a4.765 4.765 0 0 1-.578-.591c.016.02-.026.107 0 .138m.36 1.696c.146.234.215.494.25.768.005.027.01-.02.01-.025a.33.33 0 0 0-.003-.094c-.037-.278-.105-.544-.255-.782.008.014-.023.102-.004.133m1.01-4.217c.033.164.071.326.11.487-.005-.024.014-.093.005-.132a10.767 10.767 0 0 1-.107-.473c-.005-.027-.01.02-.01.024a.297.297 0 0 0 .004.094m2.53-1.012c-.07.18-.155.351-.252.517-.019.032.012.118.004.133a3.79 3.79 0 0 0 .253-.517c.015-.036-.012-.113-.003-.133m1.043-.044c0 .29-.005.58-.069.864a.396.396 0 0 0 .007.119c.073-.323.076-.653.076-.983 0-.078-.014-.078-.014 0m.219 1.6c.026.249 0 .494-.035.74a.611.611 0 0 0 .007.12c.044-.319.071-.637.038-.958-.006-.054-.012.08-.01.098m.796 1.516c-.047.343-.254.617-.502.84-.027.024.015.124 0 .138.254-.229.46-.508.509-.86a.538.538 0 0 0-.007-.118m-2.564-1.484c-.072.143-.166.273-.253.406-.013.019-.005.065-.005.085 0 .005.004.055.008.048.088-.133.18-.263.253-.406.01-.022.005-.062.005-.085 0-.005-.004-.054-.008-.048m.29 2.029a2.016 2.016 0 0 1-.36.406c-.028.021.014.126 0 .137.143-.113.252-.258.36-.406.012-.015.007-.05.007-.069 0-.008-.01-.065-.006-.068m-.904 1.07c-.353-.349-.519-.797-.36-1.304.012-.039-.01-.111-.003-.133-.178.564-.06 1.156.363 1.575-.016-.016.027-.111 0-.138m-1.196-1.127c.027.21.026.412-.035.613-.011.038.01.11.004.133.084-.28.076-.577.038-.864-.004-.027-.009.02-.009.024a.33.33 0 0 0 .003.094m2.748 1.351c-.075.25-.21.47-.326.702-.016.034.013.116.004.133.116-.232.251-.452.326-.702.011-.038-.01-.11-.004-.133m1.77.739c-.152.27-.329.523-.505.775-.02.03.012.121.004.133a9.68 9.68 0 0 0 .505-.775c.019-.033-.012-.118-.003-.133m.866.93c-.074.473-.111.95-.147 1.427-.003.023.006.155.012.07.034-.461.07-.921.142-1.379a.482.482 0 0 0-.007-.118m1.117-1.658c.003.161.034.32.036.48.003.097.014.007.013-.036-.003-.161-.034-.32-.036-.48-.003-.097-.014-.007-.013.036m-11.887-5.21c-.068.475-.01.929.146 1.382-.007-.022.016-.096.004-.133-.128-.371-.2-.723-.143-1.13a.612.612 0 0 0-.007-.119"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M254.739 209.435c.763-.7 1.77-1.438 2.853-1.18 0 0 .019-.133 0-.137-1.082-.258-2.09.48-2.853 1.18-.027.024.015.123 0 .137m3.668.835c-.765-.521-2.103-.712-2.853-.07-.027.023.015.125 0 .138.75-.642 2.088-.451 2.853.07-.012-.01.027-.12 0-.138m-2.923 1.176c.314 1.016.72 2.05.542 3.136a.54.54 0 0 0 .007.12c.192-1.178-.203-2.28-.545-3.39.007.023-.016.096-.003.134m-1.225.618c.188 1.027.068 2.065-.003 3.098-.003.023.006.154.012.07.074-1.096.196-2.198-.003-3.287a.437.437 0 0 0-.007.119m1.634-.755c.998.237 1.974.903 2.512 1.802-.01-.014.022-.1.004-.132-.539-.903-1.514-1.57-2.516-1.808 0 0-.02.134 0 .138m-.89 1.39c.004.63.053 1.263-.13 1.876-.012.039.01.11.003.133.197-.656.145-1.333.141-2.01 0-.078-.014-.078-.014 0m1.57-.14c.627.52 1.124 1.303 1.218 2.132.006.054.011-.08.009-.097-.096-.847-.585-1.64-1.228-2.172.015.012-.026.115 0 .138m-4.617 1.732c.207-.296.465-.634.813-.76.023-.008-.004-.137 0-.139-.35.128-.607.468-.817.766-.02.03.012.121.004.133m1.495-5.4c-.133-.565-.556-.898-1.01-1.201.01.007-.025.106 0 .122.45.302.874.635 1.006 1.197-.005-.021.012-.083.004-.118m-.885-.01c-.523-.248-1.063-.277-1.63-.278-.01 0-.01.138 0 .138.567 0 1.107.03 1.63.278-.008-.004.025-.126 0-.138m1.634-.087c.069-.543-.011-1.055-.479-1.39.012.009-.023.104 0 .121.393.281.536.672.473 1.165a.496.496 0 0 0 .006.104m1.967.641c.491-.261 1.026-.212 1.562-.208.01 0 .01-.138 0-.138-.536-.004-1.07-.053-1.562.208-.026.014.01.133 0 .138m.883 1.318c.758.08 1.336.47 1.834 1.042-.033-.039.052-.217 0-.276-.498-.571-1.076-.961-1.834-1.041-.011-.001-.029.272 0 .275m-3.332 2.09c-.18.724-.042 1.641-.88 1.938-.045.016.008.273 0 .276.848-.301.706-1.217.887-1.949.02-.078-.019-.218-.007-.265",
    fill: "#fff"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M255.482 212.276c.291.762.697 1.54.54 2.386a.931.931 0 0 0 .014.237c.192-1.042-.181-1.932-.547-2.889.016.04-.035.192-.007.266m1.09-.134c.74.094 1.39.752 1.488 1.508.007.053.019-.042.019-.05a1.08 1.08 0 0 0-.005-.188c-.1-.77-.744-1.45-1.501-1.546-.01 0-.03.272 0 .276m-.006 1.091c.116.634.295 1.267.07 1.9-.026.075.023.224.008.266.28-.79.08-1.607-.065-2.404a.996.996 0 0 0-.013.238m-.402-2.757c.814-.137 1.674-.26 2.378.278-.028-.022.054-.235 0-.276-.704-.537-1.564-.415-2.378-.278-.033.006-.006.277 0 .276m-1.487-1.615c.097-.673.69-1.153 1.284-1.37.045-.016-.009-.272 0-.275-.614.223-1.198.717-1.298 1.407a.991.991 0 0 0-.005.188c0 .008.011.103.019.05m-.743.404c-.02-.746-.346-1.346-.668-1.998.015.03-.036.174-.006.235.289.584.634 1.154.652 1.827.005.172.025.014.023-.064m-.685.399c-.145-.664-.583-1.104-1.161-1.407.018.01-.051.249 0 .275.559.293 1.006.724 1.148 1.37.006.025.025-.184.013-.238m-1.093-.266c-.38-.264-.779-.513-1.24-.584-.007-.001-.026.211 0 .215.461.07.86.32 1.24.584-.02-.014.042-.186 0-.215m2.368 3.12c.065.705.153 1.417-.198 2.06-.036.066.025.235.007.266.42-.77.288-1.682.21-2.52-.01-.109-.022.158-.019.194",
    fill: "#fff"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M255.346 212.137c.236.663.514 1.368.468 2.088-.003.045.012.309.023.14.057-.877-.193-1.678-.483-2.494.014.042-.034.191-.007.266m.546-.967c.675.207 1.344.428 1.834.972-.033-.037.053-.218 0-.276-.49-.544-1.16-.764-1.834-.972.005.002-.042.263 0 .276m-1.824-1.498c.071-.587.134-1.171.14-1.763.003-.157-.026-.157-.027 0-.005.526-.069 1.047-.133 1.568-.004.036.006.303.02.195m-1.233-.374c-.498-.226-.94-.55-1.359-.902.03.025-.054.23 0 .276.419.352.861.676 1.36.902-.016-.007.048-.254 0-.276m-.205 3.54c-.32.202-.54.485-.683.838-.02.048-.01.12-.01.17 0 .01.012.108.017.095.141-.349.36-.628.675-.827.054-.034-.023-.261 0-.276m.871.518c-.012.483-.278.883-.599 1.217-.052.055.033.241 0 .276.386-.403.61-.852.625-1.42.003-.088-.02-.267-.026-.073m2.28-3.801c.402-.633 1.37-.686 2.018-.863.04-.01-.003-.275 0-.275-.655.179-1.619.232-2.024.872-.04.062.024.239.007.266m-4.456-.01a2.21 2.21 0 0 1-.44-.206c.013.007-.031.152 0 .17.142.08.284.16.44.206-.003 0 .026-.162 0-.17m.088 3.24c-.14.058-.285.116-.381.24-.023.03-.014.104-.014.138 0 .032 0 .065.004.097 0-.005.006.044.01.04.097-.123.241-.182.381-.239.022-.009.014-.12.014-.138a.766.766 0 0 0-.014-.137m.586.149c-.287.129-.497.378-.676.632-.032.046.018.19.006.209.178-.252.386-.498.67-.625.038-.017-.011-.21 0-.216m1.11.275c-.251.611-.935 1.287-.44 1.971-.017-.023.05-.209.008-.265-.344-.474.261-1.007.439-1.44.03-.073-.023-.228-.007-.266m.781-.01c.02.623-.09 1.238-.199 1.849a.966.966 0 0 0 .014.238c.127-.717.233-1.43.212-2.16-.006-.194-.03-.015-.027.072m2.005-.736c.455.595.857 1.235 1.051 1.97-.012-.047.028-.188.007-.266-.195-.739-.601-1.382-1.058-1.98.034.044-.049.211 0 .276m.235-.48c.747.57 1.579 1.105 2.105 1.91-.018-.025.047-.204.007-.265-.529-.81-1.361-1.348-2.113-1.92.029.022-.053.235 0 .276",
    fill: "#fff"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M256.57 211c.28-.026.538-.016.803.082.237.087.433.283.648.413.217.13.437.25.614.436.232.244.234.66.303.974a.76.76 0 0 0 .011-.203c-.056-.257-.085-.518-.173-.767-.085-.244-.296-.393-.501-.525-.246-.157-.487-.316-.73-.476-.29-.19-.643-.2-.974-.168-.024.002-.01.235 0 .235",
    fill: "#fff"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M258.4 212.53c.082.242.179.478.262.719-.01-.028.02-.124.005-.173-.083-.24-.18-.477-.262-.718.01.028-.021.124-.005.173m-2.093-3.809c.526-.145 1.065-.24 1.582-.42.044-.014-.007-.272 0-.274-.517.178-1.056.274-1.582.418-.04.012.003.275 0 .276m-2.193.264a2.41 2.41 0 0 1 .352-.744c.196-.293.223-.66.464-.927.052-.057-.033-.238 0-.275-.198.22-.267.503-.381.771-.136.322-.35.56-.442.91-.021.078.02.219.007.265m-1.797 4.926c-.094.453-.077.926.09 1.359-.015-.04.036-.192.008-.266a1.457 1.457 0 0 1-.085-.855c.013-.06.008-.128.005-.189 0-.009-.008-.101-.018-.05m1.09.858c-.188.257-.19.648-.09.943.003.01.015-.08.015-.09.003-.05.007-.112-.009-.16-.056-.165-.014-.3.085-.434.02-.029.012-.096.012-.13 0-.014-.018-.122-.012-.129m.81-.435c-.009.26-.148.509-.257.738-.023.05.018.166.006.192.135-.285.26-.557.27-.878.003-.063-.014-.191-.019-.052m.025-1.53v.329c0 .01-.003.137.014.137.016 0 .014-.128.014-.137v-.33c0-.008.003-.137-.014-.137-.016 0-.014.128-.014.138m-.37.192c.02.04.038.078.052.12.01.058.014.062.014.01a.844.844 0 0 0-.016.257c0 .008.008.101.019.048.041-.225.05-.494-.062-.7-.007-.013-.017.086-.017.096 0 .044-.013.128.01.17m-.527-.176a3.697 3.697 0 0 0-.12.522.841.841 0 0 0-.006.189c0 .008.01.102.019.05.027-.169.062-.333.114-.496.016-.051.01-.116.009-.169a.443.443 0 0 0-.017-.096m-.406.025c-.247.301-.575.501-.908.688-.052.029.02.264 0 .275.333-.186.661-.386.908-.688.022-.028.013-.104.013-.138 0-.014-.018-.132-.013-.137m-.703.12c-.15.119-.319.205-.499.268-.044.016.008.273 0 .276.18-.063.348-.15.499-.27.023-.018.013-.112.013-.137a3.31 3.31 0 0 0-.013-.138m-.996-.245c-.146.065-.294.12-.44.186-.038.017.012.215 0 .22.146-.064.294-.12.44-.185.038-.017-.012-.216 0-.22m3.033-.12c.003.18.03.355.065.531.01.052.018-.04.018-.05a.847.847 0 0 0-.005-.188c-.023-.12-.05-.243-.052-.367a.417.417 0 0 0-.017-.096c-.018.05-.01.118-.01.17m.469-.216c.003.21.022.413.097.611a.413.413 0 0 0 .017-.096c.003-.05.009-.12-.01-.17a1.02 1.02 0 0 1-.078-.345c0-.01.003-.138-.014-.138-.015 0-.013.128-.013.138m.361-.047c.063.088.134.21.137.323 0 .011.013.107.017.096.018-.05.01-.118.01-.17a.886.886 0 0 0-.156-.515c-.01-.013-.017.087-.017.097 0 .038-.014.135.01.169m.443-.175a.815.815 0 0 1 .41.21c-.002-.002.014-.127.014-.138 0-.029.01-.115-.013-.138a.814.814 0 0 0-.41-.21c-.004 0-.037.269 0 .276m.234-.359c.18.151.381.264.615.3.007 0 .032-.27 0-.276a1.248 1.248 0 0 1-.615-.3l-.014.139c0 .026-.01.118.014.137m.497-1.197c.16.002.314.028.469.06.003 0 .036-.268 0-.275a2.468 2.468 0 0 0-.469-.06c-.02 0-.021.275 0 .275m-.23-.573c.095-.156.238-.271.377-.385.023-.019.014-.111.014-.137a5.69 5.69 0 0 0-.014-.138c-.142.116-.287.234-.385.394-.023.038-.01.127-.01.17 0 .008.01.109.017.096m-.436-.553a1.05 1.05 0 0 1 .198-.49c.023-.03.014-.103.014-.137 0-.015-.018-.132-.014-.138a1.114 1.114 0 0 0-.216.716c0 .008.01.102.018.05m-.355-.256c.18-.254.302-.545.469-.808.024-.037.01-.128.01-.17 0-.008-.008-.11-.017-.095-.167.262-.288.553-.469.807-.024.035-.01.13-.009.17 0 .009.007.11.017.096",
    fill: "#fff"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M254.448 208.322c.007.309.029.618.094.92.012.052.018-.04.019-.05a.698.698 0 0 0-.005-.188c-.055-.25-.077-.5-.082-.756-.004-.193-.028-.014-.026.074m-1.309.216c.048.112.11.217.165.324.035.068.067.137.094.208.01.027.02.055.027.083-.017-.056.012-.042-.022.017-.037.064.024.236.007.265.08-.136.067-.358.031-.508-.056-.238-.201-.434-.295-.655.016.038-.037.194-.007.266m-.26.537a4.81 4.81 0 0 0-.586-.479 1.625 1.625 0 0 0-.014.138c0 .024-.01.12.014.138.203.149.406.299.585.479-.003-.002.014-.127.014-.138 0-.03.01-.114-.014-.138m.857.287c.121-.605.098-1.21-.15-1.778.017.037-.038.194-.008.265.18.414.235.82.144 1.275-.012.06-.008.127-.005.188 0 .01.008.102.018.05m1.282-.79c.02 0 .02-.275 0-.275s-.02.276 0 .276",
    fill: "#fff"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M253.568 209.389c.032-.342.112-.676.146-1.018.01-.096.01-.196 0-.292-.006-.07-.021-.07-.029 0-.034.341-.114.676-.146 1.018a1.584 1.584 0 0 0 0 .292c.007.069.022.07.029 0m3.706 2.125c.296.097.589.298.726.591.01.02.025-.13.025-.144.003-.071.018-.188-.014-.254-.141-.3-.434-.507-.737-.606.01.003-.065.392 0 .413m-1.002 2.057c.053.177.058.339.025.52a1.166 1.166 0 0 0-.007.283c0 .013.014.153.028.074.075-.411.087-.871-.034-1.275a.685.685 0 0 0-.025.144c-.003.08-.01.176.014.254m-.835-.558c0 .342.02.682-.05 1.019-.017.09-.011.191-.006.283 0 .013.012.152.028.074.092-.454.07-.916.068-1.376 0-.014.003-.206-.02-.206s-.02.192-.02.206m-.425.37c-.118.453-.235.907-.327 1.367-.018.09-.013.192-.007.283 0 .014.012.152.028.074.09-.446.202-.886.317-1.326.03-.117-.03-.328-.01-.398m.57.289c.004.39.049.782.006 1.17a1.5 1.5 0 0 0 0 .292c.007.07.02.07.029 0 .054-.489.01-.972.006-1.462 0-.014.003-.207-.02-.207-.024 0-.021.192-.021.207m-2.743.208c.008-.123.007-.147-.004-.074a.74.74 0 0 1-.08.205c-.034.061-.016.188-.014.254 0 .014.014.165.025.145.144-.26.133-.6.093-.887-.012-.08-.027.062-.028.075a1.4 1.4 0 0 0 .007.282m1.206-.817c.08.155.074.29.073.46 0 .013-.003.206.02.206s.02-.193.02-.207c.003-.285.032-.597-.103-.858-.01-.02-.024.13-.024.145-.003.068-.019.19.014.254m.328-.142a.39.39 0 0 1 .145.194c.01.025.012.1.01.013a.74.74 0 0 0 .01.124c0-.002.006.045.015.02.027-.075.016-.176.015-.254-.004-.2-.033-.381-.196-.51-.006-.006-.014.066-.014.06a1.43 1.43 0 0 0-.006.146c0 .049 0 .098.006.146.003.012.003.05.014.06m.405-.366c.065.132.14.258.205.39.01.02.015-.018.016-.022.006-.04.008-.082.009-.123 0-.053 0-.106-.003-.16-.003-.026 0-.07-.012-.094-.065-.132-.14-.258-.205-.39-.01-.02-.015.018-.016.022-.006.04-.008.082-.009.123 0 .053 0 .106.003.159.003.026 0 .07.012.095m.908-.329c.16.228.326.452.503.666-.006-.007.02-.186.02-.207 0-.05.015-.165-.02-.206a9.95 9.95 0 0 1-.492-.651c-.014-.02-.025.13-.025.144-.003.058-.022.202.014.254m.469-.778c.121.214.261.415.415.606-.006-.008.02-.186.02-.207 0-.05.015-.164-.02-.207a4.393 4.393 0 0 1-.405-.59c-.01-.02-.024.13-.024.144-.003.065-.02.194.014.254m-4.564-2.082a1.83 1.83 0 0 0-.44-.27c-.01-.004-.02.197-.02.207 0 .026-.012.194.02.207.16.067.305.16.44.27 0 0 .02-.194.02-.207 0-.039.015-.178-.02-.207m1.43-.492l.028.07c.006.018.01.035.014.053.005.033.006.034.003.002 0 .041.003.084.01.124 0-.002.006.046.015.02.027-.075.016-.175.015-.254a1.084 1.084 0 0 0-.073-.413c-.01-.023-.016.02-.016.02a1.034 1.034 0 0 0-.009.124c-.003.074-.016.185.014.254m1.128-1.072c.007.272-.022.557-.162.794-.034.058-.016.19-.014.254 0 .014.013.164.025.144.22-.372.201-.882.19-1.302a.602.602 0 0 0-.025-.144c-.026.075-.016.177-.014.254m.254 1.529c.24-.162.404-.409.532-.666.033-.065.016-.185.014-.254 0-.015-.015-.164-.024-.145-.126.253-.287.493-.522.651-.035.024-.02.173-.02.207 0 .012.016.21.02.207m.702-.03c.083-.086.153-.183.235-.27.012-.013.012-.044.014-.06.005-.048.006-.097.006-.146 0-.049 0-.098-.006-.146 0 .007-.009-.066-.014-.06-.082.085-.152.182-.235.268-.012.014-.012.045-.014.061a1.431 1.431 0 0 0-.006.146c0 .049 0 .098.006.146 0-.007.01.066.014.06m1.055.186a8.344 8.344 0 0 1-.79-.03c-.019-.002-.044.409 0 .413a8 8 0 0 0 .79.03c.03 0 .03-.413 0-.413m-.234.952c.351.21.692.44 1.055.628-.028-.014.075-.373 0-.413-.363-.19-.704-.418-1.055-.629.033.02-.079.366 0 .414",
    fill: "#fff"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M255.955 211.155c.313.2.655.353.938.599 0 0 .02-.192.02-.207 0-.04.015-.176-.02-.207-.283-.246-.625-.399-.938-.598a2.25 2.25 0 0 0-.02.207c0 .032-.014.184.02.206m-2.015-1.504c.045-.15.044-.312.044-.468 0-.014.003-.207-.02-.207-.024 0-.02.193-.02.207 0 .056 0 .009.002 0a.466.466 0 0 1-.015.07c-.024.078-.016.173-.014.254.003.04.003.083.009.123 0-.005.007.048.015.021m-2.467-1.1c.275.337.623.58.962.845.251.195.437.527.708.682-.031-.018.078-.37 0-.413-.244-.14-.407-.434-.624-.615-.358-.3-.746-.545-1.046-.912.05.062-.076.32 0 .413m.586 1.114a8.184 8.184 0 0 1-.468-.54c-.005-.004-.016.068-.015.061a1.774 1.774 0 0 0-.006.146c0 .05-.014.165.02.207.15.185.303.368.469.539-.004-.004.02-.19.02-.207 0-.045.015-.17-.02-.206m-.328 2.73c-.11.2-.204.411-.346.591-.034.043-.02.156-.02.207 0 .021.027.198.02.206.146-.185.243-.4.357-.605.033-.062.016-.188.014-.254 0-.015-.014-.165-.025-.145m.308.414c-.005.23-.083.459-.112.686a1.368 1.368 0 0 0 0 .293c.007.07.02.068.029 0 .036-.293.116-.572.122-.87.003-.077.013-.179-.014-.254a.67.67 0 0 0-.025.145m1.08 1.9c.195-.654.174-1.344.16-2.02-.006-.29-.041-.022-.039.11.01.511.016 1.017-.132 1.511-.034.115.03.331.01.399m.635-1.586c.074.226.09.433.053.67a1.398 1.398 0 0 0-.007.282c0 .012.016.154.028.074.07-.468.086-.97-.063-1.425a.689.689 0 0 0-.025.145c-.003.078-.011.177.014.254m.62-.233c.228.28.297.65.275 1.006-.004.068.02.463.035.209.033-.538.047-1.19-.31-1.628.006.008-.02.186-.02.207 0 .05-.014.164.02.206",
    fill: "#fff"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M254.544 212.614c.143.594.253 1.193.314 1.802.016.162.033-.238.028-.292a14.24 14.24 0 0 0-.331-1.908c.017.072-.04.28-.01.398m.585-.15c.26.359.487.737.615 1.167a.683.683 0 0 0 .025-.144c.003-.08.009-.176-.015-.254-.127-.43-.354-.809-.615-1.167.026.034-.073.313-.01.398m1.212-.997c-.12-.209-.376-.234-.592-.216-.04.003-.02.414 0 .413.204-.017.466.002.58.202.012.02.025-.13.026-.145.003-.065.02-.194-.014-.254",
    fill: "#fff"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M255.721 211.304c.38-.055.76-.06 1.142-.06.031 0 .031-.413 0-.413-.382 0-.762.005-1.142.06-.048.007-.012.416 0 .413m.703-3.136c-.303.363-.464.856-.567 1.315-.02.089-.012.193-.007.283 0 .015.01.151.028.074.097-.436.259-.914.546-1.259.035-.041.02-.157.02-.206 0-.02-.026-.2-.02-.207m-1.65.355c.056.35.2.671.297 1.009a.751.751 0 0 0 .025-.145c.003-.08.009-.175-.014-.254-.094-.323-.234-.632-.288-.966-.013-.08-.027.061-.028.074a1.33 1.33 0 0 0 .007.282m-.312.603a1.652 1.652 0 0 1-.316-.561c-.008-.027-.017.025-.016.02a1.02 1.02 0 0 0-.009.124c-.003.08-.009.176.014.254a1.7 1.7 0 0 0 .327.576c.005.005.015-.068.015-.06.005-.05.006-.098.006-.147 0-.05.014-.163-.02-.206m-.557.27c-.46-.15-.9-.333-1.29-.63.043.033-.08.352 0 .414.39.296.83.48 1.29.628-.01-.003.065-.392 0-.413",
    fill: "#fff"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M254.411 209.28s-1.822.311-2.303.421c-.48.11-1.57.22-1.948.22-.38 0-.962-.302-1.367-.385-.405-.083-1.72-.22-2.202.275-.48.496-.784.662-.936.827-.152.165-.761.706-.785.946-.024.239.153.597.456.597.304 0 .942.646.941.781-.003.225.834.468 1.62.463 1.42-.008 2.119-.723 4.246-.472 1.159.136 3.29-.772 3.67-1.323.38-.551.607-1.13.227-1.763-.38-.634-1.517-.57-1.619-.588",
    fill: "#dba05f"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M254.411 209.28s-1.822.311-2.303.421c-.48.11-1.57.22-1.948.22-.38 0-.962-.302-1.367-.385-.405-.083-1.72-.22-2.202.275-.48.496-.784.662-.936.827-.152.165-.761.706-.785.946-.024.239.153.597.456.597.304 0 .942.646.941.781-.003.225.834.468 1.62.463 1.42-.008 2.119-.723 4.246-.472 1.159.136 3.29-.772 3.67-1.323.38-.551.607-1.13.227-1.763-.38-.634-1.517-.57-1.619-.588z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M246.782 211.323s-.005.04-.013-.022l-.01-.049-.014-.033-.003-.038c-.008-.013.039.01.186-.135 0 .003.044-.07.124-.19a.889.889 0 0 1 .46-.299c.277-.065.534-.018.57-.016.012-.015-.63-.022-.672.053.003-.05.619-.072.652-.029.008-.014-.582-.02-.625.062 0-.037.534-.063.592-.013 0 0-.1-.011-.126-.008l.046.008-.075-.001-.043-.004c0-.001.117.014.125.025 0 .002.053-.015-.157-.004 0 0-.128-.024-.337.043-.274.04-.265.412-.68.65"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M246.735 211.168c.025.002.203-.07.375-.388-.049-.086.644-.356.715-.27.003-.002.189 0 .298.018",
    fill: "none"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M247.421 210.569c-.07-.01-.422.286-.39.303-.076.182-.273.3-.296.296m.716-.558c0-.023.475-.068.57-.033m-.658.161c-.013-.05.495-.12.542-.085",
    fill: "none"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M247.893 211.06s.022.014-.008-.015l-.022-.025-.012-.021-.018-.016s-.016.007-.144.12c0-.001-.056.041-.121.103-.003-.005-.124.103-.26.178-.146.021-.357.116-.357.153-.013-.056.418-.17.412-.176.03.02-.382.096-.39.18-.014-.05.379-.15.395-.15.02.022-.347.083-.358.162 0 .002.05-.05.071-.05l-.026.019c.013-.013.03-.016.046-.022l.027-.012s-.073.032-.07.048c.003.008-.043-.005.094-.042.003.013.347-.07.74-.433"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M247.829 210.973c-.003-.006-.153.15-.31.26.004.026-.32.215-.405.192-.005-.01-.138.056-.193.124",
    fill: "none"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M247.35 211.357c.024-.024.227-.163.227-.165.072-.076.252-.22.252-.22m-.472.42c.016.017-.303.06-.354.138m.446-.147c.02.041-.342.138-.357.149",
    fill: "none"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M248.397 209.586s-.026-.578-.582-.799c-.557-.22-1.19-.248-1.417-.22-.228.028-.266.13-.55.175a2.702 2.702 0 0 0-.589.183s0-.027-.152.248c-.152.276-.404.413-.278.661.126.248.043.292.198.339.156.047-.077-.085-.077-.085s-.975.315-.738.912c.237.598.475.374.546.362.071-.012.552-.26.552-.26l.79-.738s.93-.364 1.031-.392c.102-.027.542.01.542.01l.724-.396z",
    fill: "#c6262c"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M248.397 209.586s-.026-.578-.582-.799c-.557-.22-1.19-.248-1.417-.22-.228.028-.266.13-.55.175a2.702 2.702 0 0 0-.589.183s0-.027-.152.248c-.152.276-.404.413-.278.661.126.248.043.292.198.339.156.047-.077-.085-.077-.085s-.975.315-.738.912c.237.598.475.374.546.362.071-.012.552-.26.552-.26l.79-.739s.93-.363 1.031-.39c.102-.028.542.01.542.01l.724-.397z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M247.69 210.944c0 .144-.147.33-.328.416-.18.085-.327.037-.327-.107s.146-.33.327-.416c.18-.085.327-.037.327.107"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M243.824 213.587s-.763-1.314 1.355-1.958c0 0 .64.349.788.59 0 0-.37.617-1.576.778 0 0-.542.16-.567.59",
    fill: "#d9c0b9"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M243.824 213.587s-.763-1.314 1.355-1.958c0 0 .64.349.788.59 0 0-.37.617-1.576.778 0 0-.542.16-.567.59z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M244.046 213.372s.852.18 1.428-.241c.472-.346.64-.188.763-.161 0 0 .025-.43-.27-.751 0 0-.599.494-1.042.628-.443.134-.743.09-.88.525",
    fill: "#d9c0b9"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M244.046 213.372s.852.18 1.428-.241c.472-.346.64-.188.763-.161 0 0 .025-.43-.27-.751 0 0-.599.494-1.042.628-.443.134-.743.09-.88.525z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.142
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M246.416 212.94c.159 0 .32.003.476-.034.018-.004 0-.138 0-.138-.156.037-.317.035-.476.035-.01 0-.01.138 0 .138m-.299-2.207c-.13 0-.091.158-.17.224-.012.01-.007.055-.007.068l.007.07c.079-.066.042-.224.17-.224.01 0 .01-.138 0-.138m.44.297c.066-.124.197-.174.314-.234.025-.012-.009-.133 0-.137-.12.06-.25.112-.318.238-.01.021-.006.062-.005.085 0 .005.005.055.008.048m.57.76a.277.277 0 0 0 .256-.124c.01-.015.006-.051.006-.069 0-.008-.01-.065-.006-.069a.277.277 0 0 1-.256.125c-.007 0-.013.136 0 .137m.45-.161a.804.804 0 0 0 .403-.35c.012-.02.006-.063.005-.085 0-.005-.005-.055-.008-.048a.793.793 0 0 1-.4.345c-.023.01.007.135 0 .138m-.707-.744c-.1.167-.288.253-.401.41-.02.028.012.121.004.133.113-.158.301-.242.401-.41.012-.02.006-.064.005-.085 0-.005-.005-.055-.009-.048m.306 2.198c.36.02.71-.03 1.058-.124.02-.006-.003-.138 0-.138a3.317 3.317 0 0 1-1.058.124c-.008 0-.013.137 0 .138m1.666-.062c.472-.343.87-.635 1.023-1.233.01-.04-.01-.11-.004-.133-.153.593-.553.89-1.02 1.228-.026.02.014.128 0 .138m.28-.82c.336-.2.576-.515.708-.885.013-.037-.011-.112-.004-.133-.131.369-.37.682-.704.88-.026.015.011.131 0 .138m-.158-2.088c.257-.031.537.183.718.348-.016-.014.027-.113 0-.138-.18-.165-.461-.379-.718-.348-.015.002-.005.139 0 .138m6.68 1.041c.292-.472.132-1.064-.17-1.487.007.012-.025.104-.005.133.256.358.426.809.17 1.221-.02.031.012.12.003.133m-5.098-.668c.296.214 1.109.759.887 1.207-.018.034.012.116.004.132.304-.612-.481-1.18-.89-1.477.013.01-.027.118 0 .138m2.292 2.2a1.55 1.55 0 0 0 .076-.391.526.526 0 0 0 0-.097c-.003-.024-.007-.024-.01 0-.012.121-.028.24-.07.354-.01.025-.005.06-.005.085 0 .005.006.054.008.048",
    fill: "#7a2e26"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M253.716 212.47c.177-.03.353-.12.53-.24m-9.023-.258c-.346.212-.892.215-1 .693-.003.007 0 .033.003.03.108-.476.655-.478.998-.688.006-.005-.003-.033 0-.035",
    fill: "#5e3f17"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M244.99 210.442c.148.003.323.081.3.264a.454.454 0 0 0 0 .097c.003.024.006.023.01 0a.713.713 0 0 0-.023-.346c-.048-.117-.174-.15-.287-.153-.01 0-.011.138 0 .138m.715.275a.697.697 0 0 0-.068-.619c.008.013-.024.104-.004.133.076.11.115.22.068.353-.014.038.01.112.004.133m.579-.612c-.037-.24-.121-.509-.343-.634.01.006-.026.123 0 .138.216.122.3.38.336.615.004.027.01-.02.01-.024a.33.33 0 0 0-.004-.095m.51-.124c.031-.224.012-.464-.173-.614.014.012-.028.116 0 .138.103.083.186.217.166.358a.589.589 0 0 0-.003.093c0 .004.006.052.01.025m-.853-.754c.498-.252 1.512-.365 1.902.139-.017-.022.025-.106 0-.138-.39-.503-1.404-.391-1.902-.139-.025.013.009.134 0 .138",
    fill: "#842116"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M244.753 211.307c.113-.168.077-.392-.034-.55.008.012-.024.104-.004.134.03.04.055.083.074.13.024.057-.009.107-.04.153-.012.018-.004.065-.004.085 0 .005.004.055.008.048m5.085 1.46a.67.67 0 0 0 .308-.446c.006-.03.004-.063.003-.094 0-.005-.004-.05-.009-.024a.651.651 0 0 1-.302.426c-.026.017.012.13 0 .138m.763-.062a.405.405 0 0 0 .098-.27c0-.024.004-.06-.005-.084-.003-.006-.008.043-.008.048-.003.059-.048.127-.085.168-.012.013-.006.053-.006.069 0 .006.008.067.006.069m4.606-2.528a.98.98 0 0 1 .09.716.397.397 0 0 0 .007.119c.071-.315.068-.682-.094-.968.01.015-.021.1-.003.133m-.457.468c.09.224.084.457.058.695-.003.018.004.151.01.097.034-.315.056-.626-.064-.925.008.02-.018.096-.004.133m-.432.4c0 .168.003.336-.056.495-.014.038.011.113.004.133.072-.199.066-.418.066-.627 0-.078-.014-.078-.014 0",
    fill: "#7a2e26"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M260.537 224.5l.096.271s.021.053.068.097l-.145-.406-.02.037z",
    fill: "#452c25"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M250.082 207.946c-1.828.105-3.631-1.11-3.631-1.11-2.266-.444-2.397-2.492-2.397-2.492-.907-.345-1.686-2.672-1.686-2.672-1.404.838-3.161.009-3.161.009s0-.346-1.585 0c-1.586.345-1.314-.296-1.314-.296s.634-.642-2.174 0c-2.808.64.227-.839.227-.839-.816.247-3.488.444-3.488.444-.98.044-1.976.528-3.06.837-.675.192-1.829.416-2.412.666-1.557.665-4.677 2.095-7.254 3.107-3.388 1.33-6.073 2.34-5.896 2.298.211-.051 3.678-2.247 8.021-4.216 4.033-1.83 8.662-3.521 10.995-4.184 3.029-1.004 5.509-.524 6.916-.014.68.247 4.427-.115 6.102.082 1.676.197 1.85 2.953 1.85 2.953.318.197.431 2.787.431 2.787s-.928.024.159.172 3.08 1.726 3.08 1.726c.679 0 .756-.024.756-.024s.395-.497.939-.705c.543-.209 1.041-.417 1.653-.463.611-.047 1.474-.052 2.085.017.612.07 1.334.075 2.195.237.86.162.95.209 1.222.301.272.093.516.033.516.033 1.119-.468 3.194-1.295 3.672-1.2 0 0 .783-.197 1.204-.524a112.08 112.08 0 0 0 1.384-1.115s-.664-4.681 4.091-4.222c4.756.459 11.061 1.07 12.326 1.266 1.264.196 5.792 1.49 6.875 2.014 1.084.525 4.197 1.92 5.583 2.533.563.248 2.705 1.197 4.29 1.824 2.38.94 4.158 2.504 4.158 2.504-1.491-.63-2.697-1.352-3.878-1.865-.955-.414-1.954-.607-2.731-.952-1.649-.733-2.919-1.4-3.918-1.865-3.683-1.716-3.65-1.784-5.141-1.901-1.028-.081.739 1.254.739 1.254s-3.371-1.31-4.455-1.77c-1.083-.459-1.986-.655-3.01-.59a6.171 6.171 0 0 1-2.407-.327c-.602-.197-4.034-.328-4.636-.394a7.812 7.812 0 0 1-1.083-.196l.24.393-1.685-.262-.482.72s-1.625.328-1.745-.196c-.12-.524-.964 2.36-1.385 3.212-.422.852-2.344.57-2.826 1.094-.482.524-1.509.875-1.75 1.006-.24.132-.97.07-1.392.07-.627 0-.093.009-1.121.205 0 0-.889-.008-1.229-.147-.34-.14-1.087-.354-1.463-.462-.514-.147-3.373-.212-3.78-.189-.409.023-1.098.234-1.55.42-.453.184-1.246.67-1.246.786",
    fill: "#dcddde"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M250.082 207.946c-1.828.105-3.631-1.11-3.631-1.11-2.266-.444-2.397-2.492-2.397-2.492-.907-.345-1.686-2.672-1.686-2.672-1.404.838-3.161.009-3.161.009s0-.346-1.585 0c-1.586.345-1.314-.296-1.314-.296s.634-.642-2.174 0c-2.808.64.227-.839.227-.839-.816.247-3.488.444-3.488.444-.98.044-1.976.528-3.06.837-.675.192-1.829.416-2.412.666-1.557.665-4.677 2.095-7.254 3.107-3.388 1.33-6.073 2.34-5.896 2.298.211-.051 3.678-2.247 8.021-4.216 4.033-1.83 8.662-3.521 10.995-4.184 3.029-1.004 5.509-.524 6.916-.014.68.247 4.427-.115 6.102.082 1.676.197 1.85 2.953 1.85 2.953.318.197.431 2.787.431 2.787s-.928.024.159.172 3.08 1.726 3.08 1.726c.679 0 .756-.024.756-.024s.395-.497.939-.705c.543-.209 1.041-.417 1.653-.463.611-.047 1.474-.052 2.085.017.612.07 1.334.075 2.195.237.86.162.95.209 1.222.301.272.093.516.033.516.033 1.119-.468 3.194-1.295 3.672-1.2 0 0 .783-.197 1.204-.524.421-.328 1.384-1.115 1.384-1.115s-.664-4.681 4.091-4.222c4.756.459 11.061 1.07 12.326 1.266 1.264.196 5.792 1.49 6.875 2.014 1.084.525 4.197 1.92 5.583 2.533.563.248 2.705 1.197 4.29 1.824 2.38.94 4.158 2.504 4.158 2.504-1.491-.63-2.697-1.352-3.878-1.865-.955-.414-1.954-.607-2.731-.952-1.649-.733-2.919-1.4-3.918-1.865-3.683-1.716-3.65-1.784-5.141-1.901-1.028-.081.739 1.254.739 1.254s-3.371-1.31-4.455-1.77c-1.083-.459-1.986-.655-3.01-.59a6.171 6.171 0 0 1-2.407-.327c-.602-.197-4.034-.328-4.636-.394a7.812 7.812 0 0 1-1.083-.196l.24.393-1.685-.262-.482.72s-1.625.328-1.745-.196c-.12-.524-.964 2.36-1.385 3.212-.422.852-2.344.57-2.826 1.094-.482.524-1.509.875-1.75 1.006-.24.132-.97.07-1.392.07-.627 0-.093.009-1.121.205 0 0-.889-.008-1.229-.147-.34-.14-1.087-.354-1.463-.462-.514-.147-3.373-.212-3.78-.189-.409.023-1.098.234-1.55.42-.453.184-1.246.67-1.246.786",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.069
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M250.27 207.398s-.192.148-.24.516c-.048.368-.024.22-.024.22",
    fill: "#452c25"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M259.51 206.86c.243.18.493.364.708.58.007.007.076.07.053.02a.579.579 0 0 0-.114-.151 6.973 6.973 0 0 0-.782-.647c-.044-.033.004.048.01.057a.58.58 0 0 0 .126.14",
    fill: "#574f4c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBo);
export default __webpack_public_path__ + "static/media/bo.d18ef8e4572adfbc6f3e97bbf737e747.svg";
export { ForwardRef as ReactComponent };